import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type AllowedApiHostname = {
  __typename?: 'AllowedApiHostname';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hostnameWildcard: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AllowedApiHostnameFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  hostnameWildcard?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type AllowedApiHostnameSortArgs = {
  direction: SortDirection;
  field: AllowedApiHostnameSortFields;
};

export enum AllowedApiHostnameSortFields {
  CreatedAt = 'createdAt',
  HostnameWildcard = 'hostnameWildcard',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type AuthorizationCode = {
  __typename?: 'AuthorizationCode';
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  redirectUri: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  tenantUser?: Maybe<TenantUser>;
  tenantUserId: Scalars['ID']['output'];
};

export type AuthorizationCodeFilterArgs = {
  code?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  redirectUri?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  tenantUser?: InputMaybe<TenantUserFilterArgs>;
  tenantUserId?: InputMaybe<StringFieldComparison>;
};

export type AuthorizationCodeSortArgs = {
  direction: SortDirection;
  field: AuthorizationCodeSortFields;
};

export enum AuthorizationCodeSortFields {
  Code = 'code',
  CreatedAt = 'createdAt',
  Id = 'id',
  RedirectUri = 'redirectUri'
}

export type BooleanFieldComparison = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Content = {
  __typename?: 'Content';
  contentFills: PaginatedContentFill;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  machineName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentFill = {
  __typename?: 'ContentFill';
  content: Content;
  contentId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fill: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentFillFilterArgs = {
  content?: InputMaybe<ContentFilterArgs>;
  contentId?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  fill?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ContentFillSortArgs = {
  direction: SortDirection;
  field: ContentFillSortFields;
};

export enum ContentFillSortFields {
  CreatedAt = 'createdAt',
  Fill = 'fill',
  Id = 'id',
  Locale = 'locale',
  UpdatedAt = 'updatedAt'
}

export type ContentFilterArgs = {
  contentFills?: InputMaybe<ContentFillFilterArgs>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ContentSortArgs = {
  direction: SortDirection;
  field: ContentSortFields;
};

export enum ContentSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  MachineName = 'machineName',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type ErrorLog = {
  __typename?: 'ErrorLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  domain: Scalars['String']['output'];
  error: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stack?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ErrorLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  domain?: InputMaybe<StringFieldComparison>;
  error?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  stack?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ErrorLogSortArgs = {
  direction: SortDirection;
  field: ErrorLogSortFields;
};

export enum ErrorLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Domain = 'domain',
  Error = 'error',
  Id = 'id',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type EventLog = {
  __typename?: 'EventLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  log: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  log?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type EventLogSortArgs = {
  direction: SortDirection;
  field: EventLogSortFields;
};

export enum EventLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Log = 'log',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type Job = {
  __typename?: 'Job';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  log?: Maybe<Scalars['String']['output']>;
  queue: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JobFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  log?: InputMaybe<StringFieldComparison>;
  queue?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type JobSortArgs = {
  direction: SortDirection;
  field: JobSortFields;
};

export enum JobSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Log = 'log',
  Queue = 'queue',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type MailLayout = {
  __typename?: 'MailLayout';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  default: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layout: Scalars['String']['output'];
  machineName: Scalars['String']['output'];
  mailLayoutFields: PaginatedMailLayoutField;
  mailTemplates: PaginatedMailTemplate;
  name: Scalars['String']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MailLayoutField = {
  __typename?: 'MailLayoutField';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  machineName: Scalars['String']['output'];
  mailLayout: MailLayout;
  mailLayoutId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MailLayoutFieldFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  mailLayout?: InputMaybe<MailLayoutFilterArgs>;
  mailLayoutId?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  required?: InputMaybe<BooleanFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MailLayoutFieldSortArgs = {
  direction: SortDirection;
  field: MailLayoutFieldSortFields;
};

export enum MailLayoutFieldSortFields {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  MachineName = 'machineName',
  Name = 'name',
  Required = 'required',
  UpdatedAt = 'updatedAt'
}

export type MailLayoutFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  default?: InputMaybe<BooleanFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  layout?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  mailLayoutFields?: InputMaybe<MailLayoutFieldFilterArgs>;
  mailTemplates?: InputMaybe<MailTemplateFilterArgs>;
  name?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MailLayoutSortArgs = {
  direction: SortDirection;
  field: MailLayoutSortFields;
};

export enum MailLayoutSortFields {
  CreatedAt = 'createdAt',
  Default = 'default',
  Description = 'description',
  Id = 'id',
  Layout = 'layout',
  MachineName = 'machineName',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type MailLog = {
  __typename?: 'MailLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailTemplate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  mailOptions?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sentBy: Scalars['String']['output'];
  sentTo: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MailLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  emailTemplate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  mailOptions?: InputMaybe<StringFieldComparison>;
  message?: InputMaybe<StringFieldComparison>;
  reason?: InputMaybe<StringFieldComparison>;
  sentBy?: InputMaybe<StringFieldComparison>;
  sentTo?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MailLogSortArgs = {
  direction: SortDirection;
  field: MailLogSortFields;
};

export enum MailLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EmailTemplate = 'emailTemplate',
  Id = 'id',
  Locale = 'locale',
  MailOptions = 'mailOptions',
  Message = 'message',
  Reason = 'reason',
  SentBy = 'sentBy',
  SentTo = 'sentTo',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type MailTemplate = {
  __typename?: 'MailTemplate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  machineName: Scalars['String']['output'];
  mailLayout: MailLayout;
  mailLayoutId: Scalars['ID']['output'];
  mailTemplateFields: PaginatedMailTemplateField;
  mailTemplateFills: PaginatedMailTemplateFill;
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MailTemplateField = {
  __typename?: 'MailTemplateField';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  machineName: Scalars['String']['output'];
  mailTemplate: MailTemplate;
  mailTemplateId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MailTemplateFieldFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  mailTemplate?: InputMaybe<MailTemplateFilterArgs>;
  mailTemplateId?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  required?: InputMaybe<BooleanFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MailTemplateFieldSortArgs = {
  direction: SortDirection;
  field: MailTemplateFieldSortFields;
};

export enum MailTemplateFieldSortFields {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  MachineName = 'machineName',
  Name = 'name',
  Required = 'required',
  UpdatedAt = 'updatedAt'
}

export type MailTemplateFill = {
  __typename?: 'MailTemplateFill';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fields: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  mailTemplate: MailTemplate;
  mailTemplateId: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MailTemplateFillFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  fields?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  mailTemplate?: InputMaybe<MailTemplateFilterArgs>;
  mailTemplateId?: InputMaybe<StringFieldComparison>;
  subject?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MailTemplateFillSortArgs = {
  direction: SortDirection;
  field: MailTemplateFillSortFields;
};

export enum MailTemplateFillSortFields {
  CreatedAt = 'createdAt',
  Fields = 'fields',
  Id = 'id',
  Locale = 'locale',
  Subject = 'subject',
  UpdatedAt = 'updatedAt'
}

export type MailTemplateFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  mailLayout?: InputMaybe<MailLayoutFilterArgs>;
  mailLayoutId?: InputMaybe<StringFieldComparison>;
  mailTemplateFields?: InputMaybe<MailTemplateFieldFilterArgs>;
  mailTemplateFills?: InputMaybe<MailTemplateFillFilterArgs>;
  name?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MailTemplateSortArgs = {
  direction: SortDirection;
  field: MailTemplateSortFields;
};

export enum MailTemplateSortFields {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  MachineName = 'machineName',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type MissingContent = {
  __typename?: 'MissingContent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  machineName: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MissingContentFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MissingContentSortArgs = {
  direction: SortDirection;
  field: MissingContentSortFields;
};

export enum MissingContentSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Locale = 'locale',
  MachineName = 'machineName',
  UpdatedAt = 'updatedAt'
}

export type Mutation = {
  __typename?: 'Mutation';
  createAllowedApiHostname: AllowedApiHostname;
  createAuthorizationCode: AuthorizationCode;
  createContent: Content;
  createContentFill: ContentFill;
  createErrorLog: ErrorLog;
  createEventLog: EventLog;
  createJob: Job;
  createMailLayout: MailLayout;
  createMailLayoutField: MailLayoutField;
  createMailLog: MailLog;
  createMailTemplate: MailTemplate;
  createMailTemplateField: MailTemplateField;
  createMailTemplateFill: MailTemplateFill;
  createMissingContent: MissingContent;
  createPermission: Permission;
  createResetPassword: ResetPassword;
  createRole: Role;
  createTenant: Tenant;
  createTenantUser: TenantUser;
  createTenantUserResetPassword: TenantUserResetPassword;
  createUser: User;
  createUserTenantRole: UserTenantRole;
  deleteAllowedApiHostname: AllowedApiHostname;
  deleteAuthorizationCode: AuthorizationCode;
  deleteContent: Content;
  deleteContentFill: ContentFill;
  deleteErrorLog: ErrorLog;
  deleteEventLog: EventLog;
  deleteJob: Job;
  deleteMailLayout: MailLayout;
  deleteMailLayoutField: MailLayoutField;
  deleteMailLog: MailLog;
  deleteMailTemplate: MailTemplate;
  deleteMailTemplateField: MailTemplateField;
  deleteMailTemplateFill: MailTemplateFill;
  deleteMissingContent: MissingContent;
  deletePermission: Permission;
  deleteResetPassword: ResetPassword;
  deleteRole: Role;
  deleteTenant: Tenant;
  deleteTenantUser: TenantUser;
  deleteTenantUserResetPassword: TenantUserResetPassword;
  deleteUser: User;
  deleteUserTenantRole: UserTenantRole;
  restoreErrorLog: ErrorLog;
  restoreEventLog: EventLog;
  restoreJob: Job;
  restoreMailLog: MailLog;
  restoreTenantUser: TenantUser;
  restoreTenantUserResetPassword: TenantUserResetPassword;
  restoreUser: User;
  updateAllowedApiHostname: AllowedApiHostname;
  updateAuthorizationCode: AuthorizationCode;
  updateContent: Content;
  updateContentFill: ContentFill;
  updateErrorLog: ErrorLog;
  updateEventLog: EventLog;
  updateJob: Job;
  updateMailLayout: MailLayout;
  updateMailLayoutField: MailLayoutField;
  updateMailLog: MailLog;
  updateMailTemplate: MailTemplate;
  updateMailTemplateField: MailTemplateField;
  updateMailTemplateFill: MailTemplateFill;
  updateMissingContent: MissingContent;
  updatePermission: Permission;
  updateResetPassword: ResetPassword;
  updateRole: Role;
  updateTenant: Tenant;
  updateTenantUser: TenantUser;
  updateTenantUserResetPassword: TenantUserResetPassword;
  updateUser: User;
  updateUserTenantRole: UserTenantRole;
};


export type MutationCreateAllowedApiHostnameArgs = {
  hostnameWildcard: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationCreateAuthorizationCodeArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  tenantUserId: Scalars['ID']['input'];
};


export type MutationCreateContentArgs = {
  contentFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  machineName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationCreateContentFillArgs = {
  contentId: Scalars['ID']['input'];
  fill: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


export type MutationCreateErrorLogArgs = {
  domain: Scalars['String']['input'];
  error: Scalars['String']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEventLogArgs = {
  log: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateJobArgs = {
  log?: InputMaybe<Scalars['String']['input']>;
  queue: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationCreateMailLayoutArgs = {
  default: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  layout: Scalars['String']['input'];
  machineName: Scalars['String']['input'];
  mailLayoutFieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mailTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateMailLayoutFieldArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  machineName: Scalars['String']['input'];
  mailLayoutId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
};


export type MutationCreateMailLogArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mailOptions?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sentBy: Scalars['String']['input'];
  sentTo: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMailTemplateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  machineName: Scalars['String']['input'];
  mailLayoutId: Scalars['ID']['input'];
  mailTemplateFieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mailTemplateFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationCreateMailTemplateFieldArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  machineName: Scalars['String']['input'];
  mailTemplateId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
};


export type MutationCreateMailTemplateFillArgs = {
  fields: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  mailTemplateId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};


export type MutationCreateMissingContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  machineName: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationCreatePermissionArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateResetPasswordArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateRoleArgs = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  permissionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateTenantArgs = {
  allowedApiHostnameIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  authorizationCodeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  confirmAccountEnabled: Scalars['Boolean']['input'];
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  frontendBaseUri?: InputMaybe<Scalars['String']['input']>;
  googleAuthEnabled: Scalars['Boolean']['input'];
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleSecret?: InputMaybe<Scalars['String']['input']>;
  inviteExpiration?: InputMaybe<Scalars['Int']['input']>;
  mailLayoutIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mailTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  microsoftAuthEnabled: Scalars['Boolean']['input'];
  microsoftId?: InputMaybe<Scalars['String']['input']>;
  microsoftSecret?: InputMaybe<Scalars['String']['input']>;
  microsoftTenantId?: InputMaybe<Scalars['String']['input']>;
  missingContentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  passwordResetExpiration?: InputMaybe<Scalars['Int']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  registerEnabled: Scalars['Boolean']['input'];
  tenantUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateTenantUserArgs = {
  accountProvider?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  authorizationCodeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  tenantUserResetPasswordIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateTenantUserResetPasswordArgs = {
  tenantUserId: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  invite?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone: Scalars['String']['input'];
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateUserTenantRoleArgs = {
  roleId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteAllowedApiHostnameArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAuthorizationCodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentFillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailLayoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailLayoutFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailTemplateFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailTemplateFillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMissingContentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantUserResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreTenantUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreTenantUserResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAllowedApiHostnameArgs = {
  hostnameWildcard?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateAuthorizationCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateContentArgs = {
  contentFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  machineName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateContentFillArgs = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateErrorLogArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEventLogArgs = {
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateJobArgs = {
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMailLayoutArgs = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  layout?: InputMaybe<Scalars['String']['input']>;
  machineName?: InputMaybe<Scalars['String']['input']>;
  mailLayoutFieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mailTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateMailLayoutFieldArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  machineName?: InputMaybe<Scalars['String']['input']>;
  mailLayoutId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateMailLogArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  mailOptions?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMailTemplateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  machineName?: InputMaybe<Scalars['String']['input']>;
  mailLayoutId?: InputMaybe<Scalars['ID']['input']>;
  mailTemplateFieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mailTemplateFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateMailTemplateFieldArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  machineName?: InputMaybe<Scalars['String']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateMailTemplateFillArgs = {
  fields?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMissingContentArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  machineName?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePermissionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRoleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  permissionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateTenantArgs = {
  allowedApiHostnameIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  authorizationCodeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  confirmAccountEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  frontendBaseUri?: InputMaybe<Scalars['String']['input']>;
  googleAuthEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleSecret?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inviteExpiration?: InputMaybe<Scalars['Int']['input']>;
  mailLayoutIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mailTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  microsoftAuthEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  microsoftId?: InputMaybe<Scalars['String']['input']>;
  microsoftSecret?: InputMaybe<Scalars['String']['input']>;
  microsoftTenantId?: InputMaybe<Scalars['String']['input']>;
  missingContentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  passwordResetExpiration?: InputMaybe<Scalars['Int']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  registerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tenantUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateTenantUserArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authorizationCodeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantUserResetPasswordIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateTenantUserResetPasswordArgs = {
  id: Scalars['ID']['input'];
  tenantUserId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type PageArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PaginatedAllowedApiHostname = {
  __typename?: 'PaginatedAllowedApiHostname';
  items?: Maybe<Array<AllowedApiHostname>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedAuthorizationCode = {
  __typename?: 'PaginatedAuthorizationCode';
  items?: Maybe<Array<AuthorizationCode>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedContent = {
  __typename?: 'PaginatedContent';
  items?: Maybe<Array<Content>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedContentFill = {
  __typename?: 'PaginatedContentFill';
  items?: Maybe<Array<ContentFill>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedErrorLog = {
  __typename?: 'PaginatedErrorLog';
  items?: Maybe<Array<ErrorLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedEventLog = {
  __typename?: 'PaginatedEventLog';
  items?: Maybe<Array<EventLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedJob = {
  __typename?: 'PaginatedJob';
  items?: Maybe<Array<Job>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailLayout = {
  __typename?: 'PaginatedMailLayout';
  items?: Maybe<Array<MailLayout>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailLayoutField = {
  __typename?: 'PaginatedMailLayoutField';
  items?: Maybe<Array<MailLayoutField>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailLog = {
  __typename?: 'PaginatedMailLog';
  items?: Maybe<Array<MailLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailTemplate = {
  __typename?: 'PaginatedMailTemplate';
  items?: Maybe<Array<MailTemplate>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailTemplateField = {
  __typename?: 'PaginatedMailTemplateField';
  items?: Maybe<Array<MailTemplateField>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailTemplateFill = {
  __typename?: 'PaginatedMailTemplateFill';
  items?: Maybe<Array<MailTemplateFill>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMissingContent = {
  __typename?: 'PaginatedMissingContent';
  items?: Maybe<Array<MissingContent>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPermission = {
  __typename?: 'PaginatedPermission';
  items?: Maybe<Array<Permission>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResetPassword = {
  __typename?: 'PaginatedResetPassword';
  items?: Maybe<Array<ResetPassword>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedRole = {
  __typename?: 'PaginatedRole';
  items?: Maybe<Array<Role>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedTenant = {
  __typename?: 'PaginatedTenant';
  items?: Maybe<Array<Tenant>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedTenantUser = {
  __typename?: 'PaginatedTenantUser';
  items?: Maybe<Array<TenantUser>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedTenantUserResetPassword = {
  __typename?: 'PaginatedTenantUserResetPassword';
  items?: Maybe<Array<TenantUserResetPassword>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  items?: Maybe<Array<User>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedUserTenantRole = {
  __typename?: 'PaginatedUserTenantRole';
  items?: Maybe<Array<UserTenantRole>>;
  totalCount: Scalars['Int']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles: PaginatedRole;
};

export type PermissionFilterArgs = {
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  roles?: InputMaybe<RoleFilterArgs>;
};

export type PermissionSortArgs = {
  direction: SortDirection;
  field: PermissionSortFields;
};

export enum PermissionSortFields {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type Query = {
  __typename?: 'Query';
  allowedApiHostname?: Maybe<AllowedApiHostname>;
  allowedApiHostnames: PaginatedAllowedApiHostname;
  authorizationCode?: Maybe<AuthorizationCode>;
  authorizationCodes: PaginatedAuthorizationCode;
  content?: Maybe<Content>;
  contentFill?: Maybe<ContentFill>;
  contentFills: PaginatedContentFill;
  contents: PaginatedContent;
  errorLog?: Maybe<ErrorLog>;
  errorLogs: PaginatedErrorLog;
  eventLog?: Maybe<EventLog>;
  eventLogs: PaginatedEventLog;
  globalMailLayouts: PaginatedMailLayout;
  job?: Maybe<Job>;
  jobs: PaginatedJob;
  mailLayout?: Maybe<MailLayout>;
  mailLayoutField?: Maybe<MailLayoutField>;
  mailLayoutFields: PaginatedMailLayoutField;
  mailLayouts: PaginatedMailLayout;
  mailLog?: Maybe<MailLog>;
  mailLogs: PaginatedMailLog;
  mailTemplate?: Maybe<MailTemplate>;
  mailTemplateField?: Maybe<MailTemplateField>;
  mailTemplateFields: PaginatedMailTemplateField;
  mailTemplateFill?: Maybe<MailTemplateFill>;
  mailTemplateFills: PaginatedMailTemplateFill;
  mailTemplates: PaginatedMailTemplate;
  missingContent?: Maybe<MissingContent>;
  missingContents: PaginatedMissingContent;
  permission?: Maybe<Permission>;
  permissions: PaginatedPermission;
  resetPassword?: Maybe<ResetPassword>;
  resetPasswords: PaginatedResetPassword;
  role?: Maybe<Role>;
  roles: PaginatedRole;
  tenant?: Maybe<Tenant>;
  tenantUser?: Maybe<TenantUser>;
  tenantUserResetPassword?: Maybe<TenantUserResetPassword>;
  tenantUserResetPasswords: PaginatedTenantUserResetPassword;
  tenantUsers: PaginatedTenantUser;
  tenants: PaginatedTenant;
  user?: Maybe<User>;
  userTenantRole?: Maybe<UserTenantRole>;
  userTenantRoles: PaginatedUserTenantRole;
  users: PaginatedUser;
};


export type QueryAllowedApiHostnameArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAllowedApiHostnamesArgs = {
  filter?: InputMaybe<AllowedApiHostnameFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AllowedApiHostnameSortArgs>>;
};


export type QueryAuthorizationCodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuthorizationCodesArgs = {
  filter?: InputMaybe<AuthorizationCodeFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AuthorizationCodeSortArgs>>;
};


export type QueryContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentFillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentFillsArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type QueryContentsArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type QueryErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryErrorLogsArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type QueryEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventLogsArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type QueryGlobalMailLayoutsArgs = {
  filter?: InputMaybe<MailLayoutFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutSortArgs>>;
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobsArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type QueryMailLayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailLayoutFieldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailLayoutFieldsArgs = {
  filter?: InputMaybe<MailLayoutFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutFieldSortArgs>>;
};


export type QueryMailLayoutsArgs = {
  filter?: InputMaybe<MailLayoutFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutSortArgs>>;
};


export type QueryMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailLogsArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type QueryMailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailTemplateFieldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailTemplateFieldsArgs = {
  filter?: InputMaybe<MailTemplateFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFieldSortArgs>>;
};


export type QueryMailTemplateFillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailTemplateFillsArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type QueryMailTemplatesArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type QueryMissingContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMissingContentsArgs = {
  filter?: InputMaybe<MissingContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MissingContentSortArgs>>;
};


export type QueryPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionsArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type QueryResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResetPasswordsArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantUserResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantUserResetPasswordsArgs = {
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserResetPasswordSortArgs>>;
};


export type QueryTenantUsersArgs = {
  filter?: InputMaybe<TenantUserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserSortArgs>>;
};


export type QueryTenantsArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTenantRolesArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResetPasswordFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  token?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ResetPasswordSortArgs = {
  direction: SortDirection;
  field: ResetPasswordSortFields;
};

export enum ResetPasswordSortFields {
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  Token = 'token',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type Role = {
  __typename?: 'Role';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  machineName: Scalars['String']['output'];
  permissions: PaginatedPermission;
  userTenantRoles: PaginatedUserTenantRole;
};

export type RoleFilterArgs = {
  description?: InputMaybe<StringFieldComparison>;
  displayName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  permissions?: InputMaybe<PermissionFilterArgs>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type RoleSortArgs = {
  direction: SortDirection;
  field: RoleSortFields;
};

export enum RoleSortFields {
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  MachineName = 'machineName'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  createdAllowedApiHostname: AllowedApiHostname;
  createdAuthorizationCode: AuthorizationCode;
  createdContent: Content;
  createdContentFill: ContentFill;
  createdErrorLog: ErrorLog;
  createdEventLog: EventLog;
  createdJob: Job;
  createdMailLayout: MailLayout;
  createdMailLayoutField: MailLayoutField;
  createdMailLog: MailLog;
  createdMailTemplate: MailTemplate;
  createdMailTemplateField: MailTemplateField;
  createdMailTemplateFill: MailTemplateFill;
  createdMissingContent: MissingContent;
  createdPermission: Permission;
  createdResetPassword: ResetPassword;
  createdRole: Role;
  createdTenant: Tenant;
  createdTenantUser: TenantUser;
  createdTenantUserResetPassword: TenantUserResetPassword;
  createdUser: User;
  createdUserTenantRole: UserTenantRole;
  deletedAllowedApiHostname: AllowedApiHostname;
  deletedAuthorizationCode: AuthorizationCode;
  deletedContent: Content;
  deletedContentFill: ContentFill;
  deletedErrorLog: ErrorLog;
  deletedEventLog: EventLog;
  deletedJob: Job;
  deletedMailLayout: MailLayout;
  deletedMailLayoutField: MailLayoutField;
  deletedMailLog: MailLog;
  deletedMailTemplate: MailTemplate;
  deletedMailTemplateField: MailTemplateField;
  deletedMailTemplateFill: MailTemplateFill;
  deletedMissingContent: MissingContent;
  deletedPermission: Permission;
  deletedResetPassword: ResetPassword;
  deletedRole: Role;
  deletedTenant: Tenant;
  deletedTenantUser: TenantUser;
  deletedTenantUserResetPassword: TenantUserResetPassword;
  deletedUser: User;
  deletedUserTenantRole: UserTenantRole;
  restoredErrorLog: ErrorLog;
  restoredEventLog: EventLog;
  restoredJob: Job;
  restoredMailLog: MailLog;
  restoredTenantUser: TenantUser;
  restoredTenantUserResetPassword: TenantUserResetPassword;
  restoredUser: User;
  updatedAllowedApiHostname: AllowedApiHostname;
  updatedAuthorizationCode: AuthorizationCode;
  updatedContent: Content;
  updatedContentFill: ContentFill;
  updatedErrorLog: ErrorLog;
  updatedEventLog: EventLog;
  updatedJob: Job;
  updatedMailLayout: MailLayout;
  updatedMailLayoutField: MailLayoutField;
  updatedMailLog: MailLog;
  updatedMailTemplate: MailTemplate;
  updatedMailTemplateField: MailTemplateField;
  updatedMailTemplateFill: MailTemplateFill;
  updatedMissingContent: MissingContent;
  updatedPermission: Permission;
  updatedResetPassword: ResetPassword;
  updatedRole: Role;
  updatedTenant: Tenant;
  updatedTenantUser: TenantUser;
  updatedTenantUserResetPassword: TenantUserResetPassword;
  updatedUser: User;
  updatedUserTenantRole: UserTenantRole;
};


export type SubscriptionCreatedAllowedApiHostnameArgs = {
  filter?: InputMaybe<AllowedApiHostnameFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AllowedApiHostnameSortArgs>>;
};


export type SubscriptionCreatedAuthorizationCodeArgs = {
  filter?: InputMaybe<AuthorizationCodeFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AuthorizationCodeSortArgs>>;
};


export type SubscriptionCreatedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionCreatedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionCreatedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionCreatedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionCreatedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionCreatedMailLayoutArgs = {
  filter?: InputMaybe<MailLayoutFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutSortArgs>>;
};


export type SubscriptionCreatedMailLayoutFieldArgs = {
  filter?: InputMaybe<MailLayoutFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutFieldSortArgs>>;
};


export type SubscriptionCreatedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionCreatedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionCreatedMailTemplateFieldArgs = {
  filter?: InputMaybe<MailTemplateFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFieldSortArgs>>;
};


export type SubscriptionCreatedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionCreatedMissingContentArgs = {
  filter?: InputMaybe<MissingContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MissingContentSortArgs>>;
};


export type SubscriptionCreatedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionCreatedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionCreatedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionCreatedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionCreatedTenantUserArgs = {
  filter?: InputMaybe<TenantUserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserSortArgs>>;
};


export type SubscriptionCreatedTenantUserResetPasswordArgs = {
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserResetPasswordSortArgs>>;
};


export type SubscriptionCreatedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionCreatedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type SubscriptionDeletedAllowedApiHostnameArgs = {
  filter?: InputMaybe<AllowedApiHostnameFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AllowedApiHostnameSortArgs>>;
};


export type SubscriptionDeletedAuthorizationCodeArgs = {
  filter?: InputMaybe<AuthorizationCodeFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AuthorizationCodeSortArgs>>;
};


export type SubscriptionDeletedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionDeletedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionDeletedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionDeletedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionDeletedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionDeletedMailLayoutArgs = {
  filter?: InputMaybe<MailLayoutFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutSortArgs>>;
};


export type SubscriptionDeletedMailLayoutFieldArgs = {
  filter?: InputMaybe<MailLayoutFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutFieldSortArgs>>;
};


export type SubscriptionDeletedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionDeletedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionDeletedMailTemplateFieldArgs = {
  filter?: InputMaybe<MailTemplateFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFieldSortArgs>>;
};


export type SubscriptionDeletedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionDeletedMissingContentArgs = {
  filter?: InputMaybe<MissingContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MissingContentSortArgs>>;
};


export type SubscriptionDeletedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionDeletedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionDeletedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionDeletedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionDeletedTenantUserArgs = {
  filter?: InputMaybe<TenantUserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserSortArgs>>;
};


export type SubscriptionDeletedTenantUserResetPasswordArgs = {
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserResetPasswordSortArgs>>;
};


export type SubscriptionDeletedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionDeletedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type SubscriptionRestoredErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionRestoredEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionRestoredJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionRestoredMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionRestoredTenantUserArgs = {
  filter?: InputMaybe<TenantUserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserSortArgs>>;
};


export type SubscriptionRestoredTenantUserResetPasswordArgs = {
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserResetPasswordSortArgs>>;
};


export type SubscriptionRestoredUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionUpdatedAllowedApiHostnameArgs = {
  filter?: InputMaybe<AllowedApiHostnameFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AllowedApiHostnameSortArgs>>;
};


export type SubscriptionUpdatedAuthorizationCodeArgs = {
  filter?: InputMaybe<AuthorizationCodeFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AuthorizationCodeSortArgs>>;
};


export type SubscriptionUpdatedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionUpdatedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionUpdatedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionUpdatedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionUpdatedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionUpdatedMailLayoutArgs = {
  filter?: InputMaybe<MailLayoutFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutSortArgs>>;
};


export type SubscriptionUpdatedMailLayoutFieldArgs = {
  filter?: InputMaybe<MailLayoutFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutFieldSortArgs>>;
};


export type SubscriptionUpdatedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionUpdatedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionUpdatedMailTemplateFieldArgs = {
  filter?: InputMaybe<MailTemplateFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFieldSortArgs>>;
};


export type SubscriptionUpdatedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionUpdatedMissingContentArgs = {
  filter?: InputMaybe<MissingContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MissingContentSortArgs>>;
};


export type SubscriptionUpdatedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionUpdatedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionUpdatedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionUpdatedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionUpdatedTenantUserArgs = {
  filter?: InputMaybe<TenantUserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserSortArgs>>;
};


export type SubscriptionUpdatedTenantUserResetPasswordArgs = {
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserResetPasswordSortArgs>>;
};


export type SubscriptionUpdatedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionUpdatedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};

export type Tenant = {
  __typename?: 'Tenant';
  allowedApiHostnames: PaginatedAllowedApiHostname;
  authorizationCodes: PaginatedAuthorizationCode;
  confirmAccountEnabled: Scalars['Boolean']['output'];
  contents: PaginatedContent;
  frontendBaseUri?: Maybe<Scalars['String']['output']>;
  googleAuthEnabled: Scalars['Boolean']['output'];
  googleId?: Maybe<Scalars['String']['output']>;
  googleSecret?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviteExpiration: Scalars['Int']['output'];
  mailLayouts: PaginatedMailLayout;
  mailTemplates: PaginatedMailTemplate;
  microsoftAuthEnabled: Scalars['Boolean']['output'];
  microsoftId?: Maybe<Scalars['String']['output']>;
  microsoftSecret?: Maybe<Scalars['String']['output']>;
  microsoftTenantId?: Maybe<Scalars['String']['output']>;
  missingContents: PaginatedMissingContent;
  name: Scalars['String']['output'];
  passwordResetExpiration: Scalars['Int']['output'];
  publicKey: Scalars['String']['output'];
  redirectUri?: Maybe<Scalars['String']['output']>;
  registerEnabled: Scalars['Boolean']['output'];
  tenantUsers: PaginatedTenantUser;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  userTenantRoles: PaginatedUserTenantRole;
};

export type TenantFilterArgs = {
  allowedApiHostnames?: InputMaybe<AllowedApiHostnameFilterArgs>;
  authorizationCodes?: InputMaybe<AuthorizationCodeFilterArgs>;
  confirmAccountEnabled?: InputMaybe<BooleanFieldComparison>;
  contents?: InputMaybe<ContentFilterArgs>;
  frontendBaseUri?: InputMaybe<StringFieldComparison>;
  googleAuthEnabled?: InputMaybe<BooleanFieldComparison>;
  googleId?: InputMaybe<StringFieldComparison>;
  googleSecret?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  inviteExpiration?: InputMaybe<NumberFieldComparison>;
  mailLayouts?: InputMaybe<MailLayoutFilterArgs>;
  mailTemplates?: InputMaybe<MailTemplateFilterArgs>;
  microsoftAuthEnabled?: InputMaybe<BooleanFieldComparison>;
  microsoftId?: InputMaybe<StringFieldComparison>;
  microsoftSecret?: InputMaybe<StringFieldComparison>;
  microsoftTenantId?: InputMaybe<StringFieldComparison>;
  missingContents?: InputMaybe<MissingContentFilterArgs>;
  name?: InputMaybe<StringFieldComparison>;
  passwordResetExpiration?: InputMaybe<NumberFieldComparison>;
  publicKey?: InputMaybe<StringFieldComparison>;
  redirectUri?: InputMaybe<StringFieldComparison>;
  registerEnabled?: InputMaybe<BooleanFieldComparison>;
  tenantUsers?: InputMaybe<TenantUserFilterArgs>;
  termsAndConditions?: InputMaybe<StringFieldComparison>;
  timeZone?: InputMaybe<StringFieldComparison>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type TenantSortArgs = {
  direction: SortDirection;
  field: TenantSortFields;
};

export enum TenantSortFields {
  ConfirmAccountEnabled = 'confirmAccountEnabled',
  FrontendBaseUri = 'frontendBaseUri',
  GoogleAuthEnabled = 'googleAuthEnabled',
  GoogleId = 'googleId',
  GoogleSecret = 'googleSecret',
  Id = 'id',
  InviteExpiration = 'inviteExpiration',
  MicrosoftAuthEnabled = 'microsoftAuthEnabled',
  MicrosoftId = 'microsoftId',
  MicrosoftSecret = 'microsoftSecret',
  MicrosoftTenantId = 'microsoftTenantId',
  Name = 'name',
  PasswordResetExpiration = 'passwordResetExpiration',
  PublicKey = 'publicKey',
  RedirectUri = 'redirectUri',
  RegisterEnabled = 'registerEnabled',
  TermsAndConditions = 'termsAndConditions',
  TimeZone = 'timeZone'
}

export type TenantUser = {
  __typename?: 'TenantUser';
  accountProvider?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  authorizationCodes: PaginatedAuthorizationCode;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  tenantUserResetPasswords: PaginatedTenantUserResetPassword;
  termsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  totpVerified?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TenantUserFilterArgs = {
  accountProvider?: InputMaybe<StringFieldComparison>;
  active?: InputMaybe<BooleanFieldComparison>;
  authorizationCodes?: InputMaybe<AuthorizationCodeFilterArgs>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  emailVerifiedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  tenantUserResetPasswords?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  termsAndConditions?: InputMaybe<BooleanFieldComparison>;
  totpVerified?: InputMaybe<BooleanFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type TenantUserResetPassword = {
  __typename?: 'TenantUserResetPassword';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  tenantUser?: Maybe<TenantUser>;
  tenantUserId: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TenantUserResetPasswordFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  tenantUser?: InputMaybe<TenantUserFilterArgs>;
  tenantUserId?: InputMaybe<StringFieldComparison>;
  token?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type TenantUserResetPasswordSortArgs = {
  direction: SortDirection;
  field: TenantUserResetPasswordSortFields;
};

export enum TenantUserResetPasswordSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Token = 'token',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type TenantUserSortArgs = {
  direction: SortDirection;
  field: TenantUserSortFields;
};

export enum TenantUserSortFields {
  AccountProvider = 'accountProvider',
  Active = 'active',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Email = 'email',
  EmailVerifiedAt = 'emailVerifiedAt',
  Id = 'id',
  TermsAndConditions = 'termsAndConditions',
  TotpVerified = 'totpVerified',
  UpdatedAt = 'updatedAt'
}

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  termsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  timeZone: Scalars['String']['output'];
  totpVerified?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userTenantRoles: PaginatedUserTenantRole;
};

export type UserFilterArgs = {
  active?: InputMaybe<BooleanFieldComparison>;
  avatar?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  emailVerifiedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  termsAndConditions?: InputMaybe<BooleanFieldComparison>;
  timeZone?: InputMaybe<StringFieldComparison>;
  totpVerified?: InputMaybe<BooleanFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type UserSortArgs = {
  direction: SortDirection;
  field: UserSortFields;
};

export enum UserSortFields {
  Active = 'active',
  Avatar = 'avatar',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Email = 'email',
  EmailVerifiedAt = 'emailVerifiedAt',
  Id = 'id',
  Locale = 'locale',
  Name = 'name',
  TermsAndConditions = 'termsAndConditions',
  TimeZone = 'timeZone',
  TotpVerified = 'totpVerified',
  UpdatedAt = 'updatedAt'
}

export type UserTenantRole = {
  __typename?: 'UserTenantRole';
  id: Scalars['ID']['output'];
  role: Role;
  roleId: Scalars['ID']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type UserTenantRoleFilterArgs = {
  id?: InputMaybe<StringFieldComparison>;
  role?: InputMaybe<RoleFilterArgs>;
  roleId?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type UserTenantRoleSortArgs = {
  direction: SortDirection;
  field: UserTenantRoleSortFields;
};

export enum UserTenantRoleSortFields {
  Id = 'id'
}

export type AllowedApiHostnameFieldsFragment = { __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } };

export type GetAllowedApiHostnamesQueryVariables = Exact<{
  filter?: InputMaybe<AllowedApiHostnameFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AllowedApiHostnameSortArgs> | AllowedApiHostnameSortArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllowedApiHostnamesQuery = { __typename?: 'Query', allowedApiHostnames: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } }> | null } };

export type GetAllowedApiHostnameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllowedApiHostnameQuery = { __typename?: 'Query', allowedApiHostname?: { __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } | null };

export type GetAllRelatedDataForAllowedApiHostnameQueryVariables = Exact<{
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForAllowedApiHostnameQuery = { __typename?: 'Query', tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null } };

export type CreateAllowedApiHostnameMutationVariables = Exact<{
  hostnameWildcard: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAllowedApiHostnameMutation = { __typename?: 'Mutation', createAllowedApiHostname: { __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type UpdateAllowedApiHostnameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hostnameWildcard?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAllowedApiHostnameMutation = { __typename?: 'Mutation', updateAllowedApiHostname: { __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type DeleteAllowedApiHostnameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteAllowedApiHostnameMutation = { __typename?: 'Mutation', deleteAllowedApiHostname: { __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type CreatedAllowedApiHostnameSubscriptionVariables = Exact<{
  filter?: InputMaybe<AllowedApiHostnameFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedAllowedApiHostnameSubscription = { __typename?: 'Subscription', createdAllowedApiHostname: { __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type UpdatedAllowedApiHostnameSubscriptionVariables = Exact<{
  filter?: InputMaybe<AllowedApiHostnameFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedAllowedApiHostnameSubscription = { __typename?: 'Subscription', updatedAllowedApiHostname: { __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type DeletedAllowedApiHostnameSubscriptionVariables = Exact<{
  filter?: InputMaybe<AllowedApiHostnameFilterArgs>;
}>;


export type DeletedAllowedApiHostnameSubscription = { __typename?: 'Subscription', deletedAllowedApiHostname: { __typename?: 'AllowedApiHostname', id: string } };

export type AuthorizationCodeFieldsFragment = { __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, createdAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetAuthorizationCodesQueryVariables = Exact<{
  filter?: InputMaybe<AuthorizationCodeFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<AuthorizationCodeSortArgs> | AuthorizationCodeSortArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAuthorizationCodesQuery = { __typename?: 'Query', authorizationCodes: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, createdAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetAuthorizationCodeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAuthorizationCodeQuery = { __typename?: 'Query', authorizationCode?: { __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, createdAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForAuthorizationCodeQueryVariables = Exact<{
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForAuthorizationCodeQuery = { __typename?: 'Query', tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', items?: Array<{ __typename?: 'TenantUser', id: string, displayField: string }> | null } };

export type CreateAuthorizationCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  tenantUserId: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAuthorizationCodeMutation = { __typename?: 'Mutation', createAuthorizationCode: { __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, createdAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateAuthorizationCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantUserId?: InputMaybe<Scalars['ID']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAuthorizationCodeMutation = { __typename?: 'Mutation', updateAuthorizationCode: { __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, createdAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteAuthorizationCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteAuthorizationCodeMutation = { __typename?: 'Mutation', deleteAuthorizationCode: { __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, createdAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedAuthorizationCodeSubscriptionVariables = Exact<{
  filter?: InputMaybe<AuthorizationCodeFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedAuthorizationCodeSubscription = { __typename?: 'Subscription', createdAuthorizationCode: { __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, createdAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedAuthorizationCodeSubscriptionVariables = Exact<{
  filter?: InputMaybe<AuthorizationCodeFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedAuthorizationCodeSubscription = { __typename?: 'Subscription', updatedAuthorizationCode: { __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, createdAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedAuthorizationCodeSubscriptionVariables = Exact<{
  filter?: InputMaybe<AuthorizationCodeFilterArgs>;
}>;


export type DeletedAuthorizationCodeSubscription = { __typename?: 'Subscription', deletedAuthorizationCode: { __typename?: 'AuthorizationCode', id: string } };

export type ContentFieldsFragment = { __typename?: 'Content', id: string, machineName: string, name: string, createdAt?: any | null, updatedAt?: any | null, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, contentId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } };

export type GetContentsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs> | ContentSortArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentsQuery = { __typename?: 'Query', contents: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, createdAt?: any | null, updatedAt?: any | null, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, contentId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } }> | null } };

export type GetContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, machineName: string, name: string, createdAt?: any | null, updatedAt?: any | null, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, contentId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } | null };

export type GetAllRelatedDataForContentQueryVariables = Exact<{
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForContentQuery = { __typename?: 'Query', contentFills?: { __typename?: 'PaginatedContentFill', items?: Array<{ __typename?: 'ContentFill', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null } };

export type CreateContentMutationVariables = Exact<{
  machineName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  contentFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantId: Scalars['ID']['input'];
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContentMutation = { __typename?: 'Mutation', createContent: { __typename?: 'Content', id: string, machineName: string, name: string, createdAt?: any | null, updatedAt?: any | null, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, contentId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type UpdateContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  machineName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  contentFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateContentMutation = { __typename?: 'Mutation', updateContent: { __typename?: 'Content', id: string, machineName: string, name: string, createdAt?: any | null, updatedAt?: any | null, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, contentId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type DeleteContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteContentMutation = { __typename?: 'Mutation', deleteContent: { __typename?: 'Content', id: string, machineName: string, name: string, createdAt?: any | null, updatedAt?: any | null, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, contentId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type CreatedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedContentSubscription = { __typename?: 'Subscription', createdContent: { __typename?: 'Content', id: string, machineName: string, name: string, createdAt?: any | null, updatedAt?: any | null, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, contentId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type UpdatedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedContentSubscription = { __typename?: 'Subscription', updatedContent: { __typename?: 'Content', id: string, machineName: string, name: string, createdAt?: any | null, updatedAt?: any | null, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, contentId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type DeletedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
}>;


export type DeletedContentSubscription = { __typename?: 'Subscription', deletedContent: { __typename?: 'Content', id: string } };

export type ContentFillFieldsFragment = { __typename?: 'ContentFill', id: string, fill: string, locale: string, createdAt?: any | null, updatedAt?: any | null, content?: { __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } };

export type GetContentFillsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs> | ContentFillSortArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentFillsQuery = { __typename?: 'Query', contentFills: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, locale: string, createdAt?: any | null, updatedAt?: any | null, content?: { __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } }> | null } };

export type GetContentFillQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentFillQuery = { __typename?: 'Query', contentFill?: { __typename?: 'ContentFill', id: string, fill: string, locale: string, createdAt?: any | null, updatedAt?: any | null, content?: { __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } | null };

export type GetAllRelatedDataForContentFillQueryVariables = Exact<{
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForContentFillQuery = { __typename?: 'Query', contents?: { __typename?: 'PaginatedContent', items?: Array<{ __typename?: 'Content', id: string, displayField: string }> | null } };

export type CreateContentFillMutationVariables = Exact<{
  fill: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  contentId: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContentFillMutation = { __typename?: 'Mutation', createContentFill: { __typename?: 'ContentFill', id: string, fill: string, locale: string, createdAt?: any | null, updatedAt?: any | null, content?: { __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdateContentFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fill?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['ID']['input']>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateContentFillMutation = { __typename?: 'Mutation', updateContentFill: { __typename?: 'ContentFill', id: string, fill: string, locale: string, createdAt?: any | null, updatedAt?: any | null, content?: { __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeleteContentFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteContentFillMutation = { __typename?: 'Mutation', deleteContentFill: { __typename?: 'ContentFill', id: string, fill: string, locale: string, createdAt?: any | null, updatedAt?: any | null, content?: { __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type CreatedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedContentFillSubscription = { __typename?: 'Subscription', createdContentFill: { __typename?: 'ContentFill', id: string, fill: string, locale: string, createdAt?: any | null, updatedAt?: any | null, content?: { __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdatedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedContentFillSubscription = { __typename?: 'Subscription', updatedContentFill: { __typename?: 'ContentFill', id: string, fill: string, locale: string, createdAt?: any | null, updatedAt?: any | null, content?: { __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeletedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
}>;


export type DeletedContentFillSubscription = { __typename?: 'Subscription', deletedContentFill: { __typename?: 'ContentFill', id: string } };

export type ErrorLogFieldsFragment = { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetErrorLogsQueryVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs> | ErrorLogSortArgs>;
}>;


export type GetErrorLogsQuery = { __typename?: 'Query', errorLogs: { __typename?: 'PaginatedErrorLog', totalCount: number, items?: Array<{ __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetErrorLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetErrorLogQuery = { __typename?: 'Query', errorLog?: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateErrorLogMutationVariables = Exact<{
  error: Scalars['String']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
}>;


export type CreateErrorLogMutation = { __typename?: 'Mutation', createErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateErrorLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  stack?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateErrorLogMutation = { __typename?: 'Mutation', updateErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteErrorLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteErrorLogMutation = { __typename?: 'Mutation', deleteErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type CreatedErrorLogSubscription = { __typename?: 'Subscription', createdErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type UpdatedErrorLogSubscription = { __typename?: 'Subscription', updatedErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type DeletedErrorLogSubscription = { __typename?: 'Subscription', deletedErrorLog: { __typename?: 'ErrorLog', id: string } };

export type RestoredErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type RestoredErrorLogSubscription = { __typename?: 'Subscription', restoredErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type EventLogFieldsFragment = { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetEventLogsQueryVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs> | EventLogSortArgs>;
}>;


export type GetEventLogsQuery = { __typename?: 'Query', eventLogs: { __typename?: 'PaginatedEventLog', totalCount: number, items?: Array<{ __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetEventLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventLogQuery = { __typename?: 'Query', eventLog?: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateEventLogMutationVariables = Exact<{
  log: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type CreateEventLogMutation = { __typename?: 'Mutation', createEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateEventLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEventLogMutation = { __typename?: 'Mutation', updateEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteEventLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEventLogMutation = { __typename?: 'Mutation', deleteEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type CreatedEventLogSubscription = { __typename?: 'Subscription', createdEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type UpdatedEventLogSubscription = { __typename?: 'Subscription', updatedEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type DeletedEventLogSubscription = { __typename?: 'Subscription', deletedEventLog: { __typename?: 'EventLog', id: string } };

export type RestoredEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type RestoredEventLogSubscription = { __typename?: 'Subscription', restoredEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type JobFieldsFragment = { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetJobsQueryVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs> | JobSortArgs>;
}>;


export type GetJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'PaginatedJob', totalCount: number, items?: Array<{ __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetJobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobQuery = { __typename?: 'Query', job?: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateJobMutationVariables = Exact<{
  queue: Scalars['String']['input'];
  status: Scalars['String']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  queue?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type CreatedJobSubscription = { __typename?: 'Subscription', createdJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type UpdatedJobSubscription = { __typename?: 'Subscription', updatedJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type DeletedJobSubscription = { __typename?: 'Subscription', deletedJob: { __typename?: 'Job', id: string } };

export type RestoredJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type RestoredJobSubscription = { __typename?: 'Subscription', restoredJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type MailLayoutFieldsFragment = { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailLayoutId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } | null };

export type GetMailLayoutsQueryVariables = Exact<{
  filter?: InputMaybe<MailLayoutFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutSortArgs> | MailLayoutSortArgs>;
  withMailLayoutFields?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailLayoutsQuery = { __typename?: 'Query', mailLayouts: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailLayoutId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } | null }> | null } };

export type GetMailLayoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailLayoutFields?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailLayoutQuery = { __typename?: 'Query', mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailLayoutId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } | null } | null };

export type GetAllRelatedDataForMailLayoutQueryVariables = Exact<{
  withMailLayoutFields?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailLayoutQuery = { __typename?: 'Query', mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', items?: Array<{ __typename?: 'MailLayoutField', id: string, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', items?: Array<{ __typename?: 'MailTemplate', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null } };

export type CreateMailLayoutMutationVariables = Exact<{
  name: Scalars['String']['input'];
  machineName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  layout: Scalars['String']['input'];
  default: Scalars['Boolean']['input'];
  mailLayoutFields?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mailTemplates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withMailLayoutFields?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailLayoutMutation = { __typename?: 'Mutation', createMailLayout: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailLayoutId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } | null } };

export type UpdateMailLayoutMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  machineName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  mailLayoutFields?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mailTemplates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withMailLayoutFields?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailLayoutMutation = { __typename?: 'Mutation', updateMailLayout: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailLayoutId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } | null } };

export type DeleteMailLayoutMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailLayoutFields?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailLayoutMutation = { __typename?: 'Mutation', deleteMailLayout: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailLayoutId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } | null } };

export type CreatedMailLayoutSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLayoutFilterArgs>;
  withMailLayoutFields?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailLayoutSubscription = { __typename?: 'Subscription', createdMailLayout: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailLayoutId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } | null } };

export type UpdatedMailLayoutSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLayoutFilterArgs>;
  withMailLayoutFields?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailLayoutSubscription = { __typename?: 'Subscription', updatedMailLayout: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields?: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailLayoutId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } | null } };

export type DeletedMailLayoutSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLayoutFilterArgs>;
}>;


export type DeletedMailLayoutSubscription = { __typename?: 'Subscription', deletedMailLayout: { __typename?: 'MailLayout', id: string } };

export type MailLayoutFieldFieldsFragment = { __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } };

export type GetMailLayoutFieldsQueryVariables = Exact<{
  filter?: InputMaybe<MailLayoutFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLayoutFieldSortArgs> | MailLayoutFieldSortArgs>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailLayoutFieldsQuery = { __typename?: 'Query', mailLayoutFields: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } }> | null } };

export type GetMailLayoutFieldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailLayoutFieldQuery = { __typename?: 'Query', mailLayoutField?: { __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } | null };

export type GetAllRelatedDataForMailLayoutFieldQueryVariables = Exact<{
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailLayoutFieldQuery = { __typename?: 'Query', mailLayouts?: { __typename?: 'PaginatedMailLayout', items?: Array<{ __typename?: 'MailLayout', id: string, displayField: string }> | null } };

export type CreateMailLayoutFieldMutationVariables = Exact<{
  name: Scalars['String']['input'];
  machineName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
  mailLayoutId: Scalars['ID']['input'];
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailLayoutFieldMutation = { __typename?: 'Mutation', createMailLayoutField: { __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdateMailLayoutFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  machineName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  mailLayoutId?: InputMaybe<Scalars['ID']['input']>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailLayoutFieldMutation = { __typename?: 'Mutation', updateMailLayoutField: { __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeleteMailLayoutFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailLayoutFieldMutation = { __typename?: 'Mutation', deleteMailLayoutField: { __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type CreatedMailLayoutFieldSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLayoutFieldFilterArgs>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailLayoutFieldSubscription = { __typename?: 'Subscription', createdMailLayoutField: { __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdatedMailLayoutFieldSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLayoutFieldFilterArgs>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailLayoutFieldSubscription = { __typename?: 'Subscription', updatedMailLayoutField: { __typename?: 'MailLayoutField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeletedMailLayoutFieldSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLayoutFieldFilterArgs>;
}>;


export type DeletedMailLayoutFieldSubscription = { __typename?: 'Subscription', deletedMailLayoutField: { __typename?: 'MailLayoutField', id: string } };

export type MailLogFieldsFragment = { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null };

export type GetMailLogsQueryVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs> | MailLogSortArgs>;
}>;


export type GetMailLogsQuery = { __typename?: 'Query', mailLogs: { __typename?: 'PaginatedMailLog', totalCount: number, items?: Array<{ __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null }> | null } };

export type GetMailLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMailLogQuery = { __typename?: 'Query', mailLog?: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null } | null };

export type CreateMailLogMutationVariables = Exact<{
  sentTo: Scalars['String']['input'];
  sentBy: Scalars['String']['input'];
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mailOptions?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMailLogMutation = { __typename?: 'Mutation', createMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null } };

export type UpdateMailLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sentTo?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mailOptions?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMailLogMutation = { __typename?: 'Mutation', updateMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null } };

export type DeleteMailLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMailLogMutation = { __typename?: 'Mutation', deleteMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null } };

export type CreatedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type CreatedMailLogSubscription = { __typename?: 'Subscription', createdMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null } };

export type UpdatedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type UpdatedMailLogSubscription = { __typename?: 'Subscription', updatedMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null } };

export type DeletedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type DeletedMailLogSubscription = { __typename?: 'Subscription', deletedMailLog: { __typename?: 'MailLog', id: string } };

export type RestoredMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type RestoredMailLogSubscription = { __typename?: 'Subscription', restoredMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, locale?: string | null, mailOptions?: string | null } };

export type MailTemplateFieldsFragment = { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } };

export type GetMailTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs> | MailTemplateSortArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplatesQuery = { __typename?: 'Query', mailTemplates: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } }> | null } };

export type GetMailTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateQuery = { __typename?: 'Query', mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } | null };

export type GetAllRelatedDataForMailTemplateQueryVariables = Exact<{
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailTemplateQuery = { __typename?: 'Query', mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', items?: Array<{ __typename?: 'MailTemplateFill', id: string, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', items?: Array<{ __typename?: 'MailLayout', id: string, displayField: string }> | null }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', items?: Array<{ __typename?: 'MailTemplateField', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null } };

export type CreateMailTemplateMutationVariables = Exact<{
  machineName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  mailTemplateFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mailLayoutId: Scalars['ID']['input'];
  mailTemplateFields?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantId: Scalars['ID']['input'];
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailTemplateMutation = { __typename?: 'Mutation', createMailTemplate: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type UpdateMailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  machineName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mailTemplateFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mailLayoutId?: InputMaybe<Scalars['ID']['input']>;
  mailTemplateFields?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailTemplateMutation = { __typename?: 'Mutation', updateMailTemplate: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type DeleteMailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailTemplateMutation = { __typename?: 'Mutation', deleteMailTemplate: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type CreatedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailTemplateSubscription = { __typename?: 'Subscription', createdMailTemplate: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type UpdatedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayout?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplateFields?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailTemplateSubscription = { __typename?: 'Subscription', updatedMailTemplate: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayout?: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, mailTemplateFields?: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, mailTemplateId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type DeletedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
}>;


export type DeletedMailTemplateSubscription = { __typename?: 'Subscription', deletedMailTemplate: { __typename?: 'MailTemplate', id: string } };

export type MailTemplateFieldFieldsFragment = { __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } };

export type GetMailTemplateFieldsQueryVariables = Exact<{
  filter?: InputMaybe<MailTemplateFieldFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFieldSortArgs> | MailTemplateFieldSortArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateFieldsQuery = { __typename?: 'Query', mailTemplateFields: { __typename?: 'PaginatedMailTemplateField', totalCount: number, items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } }> | null } };

export type GetMailTemplateFieldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateFieldQuery = { __typename?: 'Query', mailTemplateField?: { __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } | null };

export type GetAllRelatedDataForMailTemplateFieldQueryVariables = Exact<{
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailTemplateFieldQuery = { __typename?: 'Query', mailTemplates?: { __typename?: 'PaginatedMailTemplate', items?: Array<{ __typename?: 'MailTemplate', id: string, displayField: string }> | null } };

export type CreateMailTemplateFieldMutationVariables = Exact<{
  name: Scalars['String']['input'];
  machineName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
  mailTemplateId: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailTemplateFieldMutation = { __typename?: 'Mutation', createMailTemplateField: { __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdateMailTemplateFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  machineName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailTemplateFieldMutation = { __typename?: 'Mutation', updateMailTemplateField: { __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeleteMailTemplateFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailTemplateFieldMutation = { __typename?: 'Mutation', deleteMailTemplateField: { __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type CreatedMailTemplateFieldSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFieldFilterArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailTemplateFieldSubscription = { __typename?: 'Subscription', createdMailTemplateField: { __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdatedMailTemplateFieldSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFieldFilterArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailTemplateFieldSubscription = { __typename?: 'Subscription', updatedMailTemplateField: { __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeletedMailTemplateFieldSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFieldFilterArgs>;
}>;


export type DeletedMailTemplateFieldSubscription = { __typename?: 'Subscription', deletedMailTemplateField: { __typename?: 'MailTemplateField', id: string } };

export type MailTemplateFillFieldsFragment = { __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } };

export type GetMailTemplateFillsQueryVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs> | MailTemplateFillSortArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateFillsQuery = { __typename?: 'Query', mailTemplateFills: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } }> | null } };

export type GetMailTemplateFillQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateFillQuery = { __typename?: 'Query', mailTemplateFill?: { __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } | null };

export type GetAllRelatedDataForMailTemplateFillQueryVariables = Exact<{
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailTemplateFillQuery = { __typename?: 'Query', mailTemplates?: { __typename?: 'PaginatedMailTemplate', items?: Array<{ __typename?: 'MailTemplate', id: string, displayField: string }> | null } };

export type CreateMailTemplateFillMutationVariables = Exact<{
  subject: Scalars['String']['input'];
  fields: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  mailTemplateId: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailTemplateFillMutation = { __typename?: 'Mutation', createMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdateMailTemplateFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailTemplateFillMutation = { __typename?: 'Mutation', updateMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeleteMailTemplateFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailTemplateFillMutation = { __typename?: 'Mutation', deleteMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type CreatedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailTemplateFillSubscription = { __typename?: 'Subscription', createdMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdatedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailTemplateFillSubscription = { __typename?: 'Subscription', updatedMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, fields: string, locale: string, createdAt?: any | null, updatedAt?: any | null, mailTemplate?: { __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeletedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
}>;


export type DeletedMailTemplateFillSubscription = { __typename?: 'Subscription', deletedMailTemplateFill: { __typename?: 'MailTemplateFill', id: string } };

export type MissingContentFieldsFragment = { __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } };

export type GetMissingContentsQueryVariables = Exact<{
  filter?: InputMaybe<MissingContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MissingContentSortArgs> | MissingContentSortArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMissingContentsQuery = { __typename?: 'Query', missingContents: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } }> | null } };

export type GetMissingContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMissingContentQuery = { __typename?: 'Query', missingContent?: { __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } | null };

export type GetAllRelatedDataForMissingContentQueryVariables = Exact<{
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMissingContentQuery = { __typename?: 'Query', tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null } };

export type CreateMissingContentMutationVariables = Exact<{
  machineName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMissingContentMutation = { __typename?: 'Mutation', createMissingContent: { __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type UpdateMissingContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  machineName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMissingContentMutation = { __typename?: 'Mutation', updateMissingContent: { __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type DeleteMissingContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMissingContentMutation = { __typename?: 'Mutation', deleteMissingContent: { __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type CreatedMissingContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<MissingContentFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMissingContentSubscription = { __typename?: 'Subscription', createdMissingContent: { __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type UpdatedMissingContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<MissingContentFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMissingContentSubscription = { __typename?: 'Subscription', updatedMissingContent: { __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string } } };

export type DeletedMissingContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<MissingContentFilterArgs>;
}>;


export type DeletedMissingContentSubscription = { __typename?: 'Subscription', deletedMissingContent: { __typename?: 'MissingContent', id: string } };

export type PermissionFieldsFragment = { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } };

export type GetPermissionsQueryVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs> | PermissionSortArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPermissionsQuery = { __typename?: 'Query', permissions: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } }> | null } };

export type GetPermissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPermissionQuery = { __typename?: 'Query', permission?: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } | null };

export type GetAllRelatedDataForPermissionQueryVariables = Exact<{
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForPermissionQuery = { __typename?: 'Query', roles?: { __typename?: 'PaginatedRole', items?: Array<{ __typename?: 'Role', id: string, displayField: string }> | null } };

export type CreatePermissionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePermissionMutation = { __typename?: 'Mutation', createPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type UpdatePermissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type DeletePermissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePermissionMutation = { __typename?: 'Mutation', deletePermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type CreatedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedPermissionSubscription = { __typename?: 'Subscription', createdPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type UpdatedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedPermissionSubscription = { __typename?: 'Subscription', updatedPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type DeletedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
}>;


export type DeletedPermissionSubscription = { __typename?: 'Subscription', deletedPermission: { __typename?: 'Permission', id: string } };

export type ResetPasswordFieldsFragment = { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null };

export type GetResetPasswordsQueryVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs> | ResetPasswordSortArgs>;
}>;


export type GetResetPasswordsQuery = { __typename?: 'Query', resetPasswords: { __typename?: 'PaginatedResetPassword', totalCount: number, items?: Array<{ __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null }> | null } };

export type GetResetPasswordQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResetPasswordQuery = { __typename?: 'Query', resetPassword?: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type CreateResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type CreateResetPasswordMutation = { __typename?: 'Mutation', createResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type UpdateResetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateResetPasswordMutation = { __typename?: 'Mutation', updateResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type DeleteResetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResetPasswordMutation = { __typename?: 'Mutation', deleteResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type CreatedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type CreatedResetPasswordSubscription = { __typename?: 'Subscription', createdResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type UpdatedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type UpdatedResetPasswordSubscription = { __typename?: 'Subscription', updatedResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type DeletedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type DeletedResetPasswordSubscription = { __typename?: 'Subscription', deletedResetPassword: { __typename?: 'ResetPassword', id: string } };

export type RoleFieldsFragment = { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } };

export type GetRolesQueryVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs> | RoleSortArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRolesQuery = { __typename?: 'Query', roles: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } }> | null } };

export type GetRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRoleQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } | null };

export type GetAllRelatedDataForRoleQueryVariables = Exact<{
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForRoleQuery = { __typename?: 'Query', permissions?: { __typename?: 'PaginatedPermission', items?: Array<{ __typename?: 'Permission', id: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null } };

export type CreateRoleMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type CreatedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedRoleSubscription = { __typename?: 'Subscription', createdRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type UpdatedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedRoleSubscription = { __typename?: 'Subscription', updatedRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type DeletedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
}>;


export type DeletedRoleSubscription = { __typename?: 'Subscription', deletedRole: { __typename?: 'Role', id: string } };

export type TenantFieldsFragment = { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetTenantsQueryVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs> | TenantSortArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAllowedApiHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantsQuery = { __typename?: 'Query', tenants: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetTenantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAllowedApiHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantQuery = { __typename?: 'Query', tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForTenantQueryVariables = Exact<{
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAllowedApiHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForTenantQuery = { __typename?: 'Query', userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', items?: Array<{ __typename?: 'Content', id: string, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', items?: Array<{ __typename?: 'AllowedApiHostname', id: string, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', items?: Array<{ __typename?: 'MailTemplate', id: string, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', items?: Array<{ __typename?: 'MailLayout', id: string, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', items?: Array<{ __typename?: 'MissingContent', id: string, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', items?: Array<{ __typename?: 'AuthorizationCode', id: string, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', items?: Array<{ __typename?: 'TenantUser', id: string, displayField: string }> | null } };

export type CreateTenantMutationVariables = Exact<{
  name: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  frontendBaseUri?: InputMaybe<Scalars['String']['input']>;
  googleAuthEnabled: Scalars['Boolean']['input'];
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleSecret?: InputMaybe<Scalars['String']['input']>;
  microsoftAuthEnabled: Scalars['Boolean']['input'];
  microsoftId?: InputMaybe<Scalars['String']['input']>;
  microsoftSecret?: InputMaybe<Scalars['String']['input']>;
  microsoftTenantId?: InputMaybe<Scalars['String']['input']>;
  inviteExpiration?: InputMaybe<Scalars['Int']['input']>;
  passwordResetExpiration?: InputMaybe<Scalars['Int']['input']>;
  registerEnabled: Scalars['Boolean']['input'];
  confirmAccountEnabled: Scalars['Boolean']['input'];
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  allowedApiHostnames?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mailTemplates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mailLayouts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  missingContents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  authorizationCodes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAllowedApiHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateTenantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  frontendBaseUri?: InputMaybe<Scalars['String']['input']>;
  googleAuthEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleSecret?: InputMaybe<Scalars['String']['input']>;
  microsoftAuthEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  microsoftId?: InputMaybe<Scalars['String']['input']>;
  microsoftSecret?: InputMaybe<Scalars['String']['input']>;
  microsoftTenantId?: InputMaybe<Scalars['String']['input']>;
  inviteExpiration?: InputMaybe<Scalars['Int']['input']>;
  passwordResetExpiration?: InputMaybe<Scalars['Int']['input']>;
  registerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  confirmAccountEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  allowedApiHostnames?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mailTemplates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mailLayouts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  missingContents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  authorizationCodes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantUsers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAllowedApiHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteTenantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAllowedApiHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteTenantMutation = { __typename?: 'Mutation', deleteTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAllowedApiHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedTenantSubscription = { __typename?: 'Subscription', createdTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAllowedApiHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  withMailLayouts?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingContents?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedTenantSubscription = { __typename?: 'Subscription', updatedTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, contents?: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, machineName: string, name: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, allowedApiHostnames?: { __typename?: 'PaginatedAllowedApiHostname', totalCount: number, items?: Array<{ __typename?: 'AllowedApiHostname', id: string, hostnameWildcard: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, machineName: string, name: string, description?: string | null, mailLayoutId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, mailLayouts?: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, missingContents?: { __typename?: 'PaginatedMissingContent', totalCount: number, items?: Array<{ __typename?: 'MissingContent', id: string, machineName: string, locale?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUsers?: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
}>;


export type DeletedTenantSubscription = { __typename?: 'Subscription', deletedTenant: { __typename?: 'Tenant', id: string } };

export type TenantUserFieldsFragment = { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetTenantUsersQueryVariables = Exact<{
  filter?: InputMaybe<TenantUserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserSortArgs> | TenantUserSortArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantUsersQuery = { __typename?: 'Query', tenantUsers: { __typename?: 'PaginatedTenantUser', totalCount: number, items?: Array<{ __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetTenantUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantUserQuery = { __typename?: 'Query', tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForTenantUserQueryVariables = Exact<{
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForTenantUserQuery = { __typename?: 'Query', tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', items?: Array<{ __typename?: 'AuthorizationCode', id: string, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, displayField: string }> | null } };

export type CreateTenantUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  active: Scalars['Boolean']['input'];
  tenantId: Scalars['ID']['input'];
  authorizationCodes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantUserResetPasswords?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateTenantUserMutation = { __typename?: 'Mutation', createTenantUser: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateTenantUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  authorizationCodes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantUserResetPasswords?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTenantUserMutation = { __typename?: 'Mutation', updateTenantUser: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteTenantUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteTenantUserMutation = { __typename?: 'Mutation', deleteTenantUser: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedTenantUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantUserFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedTenantUserSubscription = { __typename?: 'Subscription', createdTenantUser: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedTenantUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantUserFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedTenantUserSubscription = { __typename?: 'Subscription', updatedTenantUser: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedTenantUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantUserFilterArgs>;
}>;


export type DeletedTenantUserSubscription = { __typename?: 'Subscription', deletedTenantUser: { __typename?: 'TenantUser', id: string } };

export type RestoredTenantUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantUserFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withAuthorizationCodes?: InputMaybe<Scalars['Boolean']['input']>;
  withTenantUserResetPasswords?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredTenantUserSubscription = { __typename?: 'Subscription', restoredTenantUser: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, authorizationCodes?: { __typename?: 'PaginatedAuthorizationCode', totalCount: number, items?: Array<{ __typename?: 'AuthorizationCode', id: string, code: string, redirectUri: string, tenantId: string, tenantUserId: string, createdAt?: any | null, displayField: string }> | null }, tenantUserResetPasswords?: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, tenantUserId: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type TenantUserResetPasswordFieldsFragment = { __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetTenantUserResetPasswordsQueryVariables = Exact<{
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantUserResetPasswordSortArgs> | TenantUserResetPasswordSortArgs>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantUserResetPasswordsQuery = { __typename?: 'Query', tenantUserResetPasswords: { __typename?: 'PaginatedTenantUserResetPassword', totalCount: number, items?: Array<{ __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetTenantUserResetPasswordQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantUserResetPasswordQuery = { __typename?: 'Query', tenantUserResetPassword?: { __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForTenantUserResetPasswordQueryVariables = Exact<{
  withTenantUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForTenantUserResetPasswordQuery = { __typename?: 'Query', tenantUsers?: { __typename?: 'PaginatedTenantUser', items?: Array<{ __typename?: 'TenantUser', id: string, displayField: string }> | null } };

export type CreateTenantUserResetPasswordMutationVariables = Exact<{
  type: Scalars['String']['input'];
  tenantUserId: Scalars['ID']['input'];
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateTenantUserResetPasswordMutation = { __typename?: 'Mutation', createTenantUserResetPassword: { __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdateTenantUserResetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  tenantUserId?: InputMaybe<Scalars['ID']['input']>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTenantUserResetPasswordMutation = { __typename?: 'Mutation', updateTenantUserResetPassword: { __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeleteTenantUserResetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteTenantUserResetPasswordMutation = { __typename?: 'Mutation', deleteTenantUserResetPassword: { __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedTenantUserResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedTenantUserResetPasswordSubscription = { __typename?: 'Subscription', createdTenantUserResetPassword: { __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedTenantUserResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedTenantUserResetPasswordSubscription = { __typename?: 'Subscription', updatedTenantUserResetPassword: { __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedTenantUserResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
}>;


export type DeletedTenantUserResetPasswordSubscription = { __typename?: 'Subscription', deletedTenantUserResetPassword: { __typename?: 'TenantUserResetPassword', id: string } };

export type RestoredTenantUserResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantUserResetPasswordFilterArgs>;
  withTenantUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredTenantUserResetPasswordSubscription = { __typename?: 'Subscription', restoredTenantUserResetPassword: { __typename?: 'TenantUserResetPassword', id: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, tenantUser?: { __typename?: 'TenantUser', id: string, email: string, termsAndConditions?: boolean | null, active: boolean, emailVerifiedAt?: any | null, totpVerified?: boolean | null, accountProvider?: string | null, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UserFieldsFragment = { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } };

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs> | UserSortArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } }> | null } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } | null };

export type GetAllRelatedDataForUserQueryVariables = Exact<{
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForUserQuery = { __typename?: 'Query', userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null } };

export type CreateUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type CreatedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedUserSubscription = { __typename?: 'Subscription', createdUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type UpdatedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedUserSubscription = { __typename?: 'Subscription', updatedUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type DeletedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
}>;


export type DeletedUserSubscription = { __typename?: 'Subscription', deletedUser: { __typename?: 'User', id: string } };

export type RestoredUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredUserSubscription = { __typename?: 'Subscription', restoredUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type UserTenantRoleFieldsFragment = { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } };

export type GetUserTenantRolesQueryVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs> | UserTenantRoleSortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserTenantRolesQuery = { __typename?: 'Query', userTenantRoles: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } }> | null } };

export type GetUserTenantRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserTenantRoleQuery = { __typename?: 'Query', userTenantRole?: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } | null };

export type GetAllRelatedDataForUserTenantRoleQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForUserTenantRoleQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, roles?: { __typename?: 'PaginatedRole', items?: Array<{ __typename?: 'Role', id: string, displayField: string }> | null } };

export type CreateUserTenantRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserTenantRoleMutation = { __typename?: 'Mutation', createUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type UpdateUserTenantRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserTenantRoleMutation = { __typename?: 'Mutation', updateUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type DeleteUserTenantRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUserTenantRoleMutation = { __typename?: 'Mutation', deleteUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type CreatedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedUserTenantRoleSubscription = { __typename?: 'Subscription', createdUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type UpdatedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedUserTenantRoleSubscription = { __typename?: 'Subscription', updatedUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, publicKey: string, redirectUri?: string | null, termsAndConditions?: string | null, frontendBaseUri?: string | null, googleAuthEnabled: boolean, googleId?: string | null, googleSecret?: string | null, microsoftAuthEnabled: boolean, microsoftId?: string | null, microsoftSecret?: string | null, microsoftTenantId?: string | null, inviteExpiration: number, passwordResetExpiration: number, registerEnabled: boolean, confirmAccountEnabled: boolean, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type DeletedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
}>;


export type DeletedUserTenantRoleSubscription = { __typename?: 'Subscription', deletedUserTenantRole: { __typename?: 'UserTenantRole', id: string } };

export type GetFullUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFullUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string, role: { __typename?: 'Role', id: string, machineName: string, displayField: string }, tenant: { __typename?: 'Tenant', id: string, name: string, displayField: string } }> | null } } | null };

export type CreateUserWithTenantRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserWithTenantRoleMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type GlobalMailLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalMailLayoutQuery = { __typename?: 'Query', globalMailLayouts: { __typename?: 'PaginatedMailLayout', totalCount: number, items?: Array<{ __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, layout: string, default: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, mailLayoutFields: { __typename?: 'PaginatedMailLayoutField', totalCount: number, items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, machineName: string, mailLayoutId: string, required: boolean }> | null } }> | null } };

export type GetMailTemplateWithLayoutFieldsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMailTemplateWithLayoutFieldsQuery = { __typename?: 'Query', mailTemplate?: { __typename?: 'MailTemplate', id: string, name: string, description?: string | null, mailLayout: { __typename?: 'MailLayout', id: string, name: string, machineName: string, description?: string | null, mailLayoutFields: { __typename?: 'PaginatedMailLayoutField', items?: Array<{ __typename?: 'MailLayoutField', id: string, name: string, required: boolean, machineName: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null }> | null } }, mailTemplateFields: { __typename?: 'PaginatedMailTemplateField', items?: Array<{ __typename?: 'MailTemplateField', id: string, name: string, machineName: string, description?: string | null, required: boolean }> | null } } | null };

export const AllowedApiHostnameFieldsFragmentDoc = gql`
    fragment allowedApiHostnameFields on AllowedApiHostname {
  id
  hostnameWildcard
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    publicKey
    redirectUri
    termsAndConditions
    frontendBaseUri
    googleAuthEnabled
    googleId
    googleSecret
    microsoftAuthEnabled
    microsoftId
    microsoftSecret
    microsoftTenantId
    inviteExpiration
    passwordResetExpiration
    registerEnabled
    confirmAccountEnabled
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const AuthorizationCodeFieldsFragmentDoc = gql`
    fragment authorizationCodeFields on AuthorizationCode {
  id
  code
  redirectUri
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    publicKey
    redirectUri
    termsAndConditions
    frontendBaseUri
    googleAuthEnabled
    googleId
    googleSecret
    microsoftAuthEnabled
    microsoftId
    microsoftSecret
    microsoftTenantId
    inviteExpiration
    passwordResetExpiration
    registerEnabled
    confirmAccountEnabled
    displayField: name
  }
  tenantUser @include(if: $withTenantUser) {
    id
    email
    termsAndConditions
    active
    emailVerifiedAt
    totpVerified
    accountProvider
    tenantId
    createdAt
    updatedAt
    deletedAt
    displayField: email
  }
  createdAt
}
    `;
export const ContentFieldsFragmentDoc = gql`
    fragment contentFields on Content {
  id
  machineName
  name
  contentFills @include(if: $withContentFills) {
    items {
      id
      fill
      locale
      contentId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    publicKey
    redirectUri
    termsAndConditions
    frontendBaseUri
    googleAuthEnabled
    googleId
    googleSecret
    microsoftAuthEnabled
    microsoftId
    microsoftSecret
    microsoftTenantId
    inviteExpiration
    passwordResetExpiration
    registerEnabled
    confirmAccountEnabled
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const ContentFillFieldsFragmentDoc = gql`
    fragment contentFillFields on ContentFill {
  id
  fill
  locale
  content @include(if: $withContent) {
    id
    machineName
    name
    tenantId
    createdAt
    updatedAt
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const ErrorLogFieldsFragmentDoc = gql`
    fragment errorLogFields on ErrorLog {
  id
  error
  stack
  domain
  createdAt
  updatedAt
  deletedAt
}
    `;
export const EventLogFieldsFragmentDoc = gql`
    fragment eventLogFields on EventLog {
  id
  log
  type
  createdAt
  updatedAt
  deletedAt
}
    `;
export const JobFieldsFragmentDoc = gql`
    fragment jobFields on Job {
  id
  queue
  status
  log
  createdAt
  updatedAt
  deletedAt
}
    `;
export const MailLayoutFieldsFragmentDoc = gql`
    fragment mailLayoutFields on MailLayout {
  id
  name
  machineName
  description
  layout
  default
  mailLayoutFields @include(if: $withMailLayoutFields) {
    items {
      id
      name
      machineName
      description
      required
      mailLayoutId
      createdAt
      updatedAt
      displayField: name
    }
    totalCount
  }
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      machineName
      name
      description
      mailLayoutId
      tenantId
      createdAt
      updatedAt
      displayField: machineName
    }
    totalCount
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    publicKey
    redirectUri
    termsAndConditions
    frontendBaseUri
    googleAuthEnabled
    googleId
    googleSecret
    microsoftAuthEnabled
    microsoftId
    microsoftSecret
    microsoftTenantId
    inviteExpiration
    passwordResetExpiration
    registerEnabled
    confirmAccountEnabled
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const MailLayoutFieldFieldsFragmentDoc = gql`
    fragment mailLayoutFieldFields on MailLayoutField {
  id
  name
  machineName
  description
  required
  mailLayout @include(if: $withMailLayout) {
    id
    name
    machineName
    description
    layout
    default
    tenantId
    createdAt
    updatedAt
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const MailLogFieldsFragmentDoc = gql`
    fragment mailLogFields on MailLog {
  id
  sentTo
  sentBy
  emailTemplate
  status
  message
  reason
  createdAt
  updatedAt
  deletedAt
  locale
  mailOptions
}
    `;
export const MailTemplateFieldsFragmentDoc = gql`
    fragment mailTemplateFields on MailTemplate {
  id
  machineName
  name
  description
  mailTemplateFills @include(if: $withMailTemplateFills) {
    items {
      id
      subject
      fields
      locale
      mailTemplateId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  mailLayout @include(if: $withMailLayout) {
    id
    name
    machineName
    description
    layout
    default
    tenantId
    createdAt
    updatedAt
    displayField: name
  }
  mailTemplateFields @include(if: $withMailTemplateFields) {
    items {
      id
      name
      machineName
      description
      required
      mailTemplateId
      createdAt
      updatedAt
      displayField: name
    }
    totalCount
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    publicKey
    redirectUri
    termsAndConditions
    frontendBaseUri
    googleAuthEnabled
    googleId
    googleSecret
    microsoftAuthEnabled
    microsoftId
    microsoftSecret
    microsoftTenantId
    inviteExpiration
    passwordResetExpiration
    registerEnabled
    confirmAccountEnabled
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const MailTemplateFieldFieldsFragmentDoc = gql`
    fragment mailTemplateFieldFields on MailTemplateField {
  id
  name
  machineName
  description
  required
  mailTemplate @include(if: $withMailTemplate) {
    id
    machineName
    name
    description
    mailLayoutId
    tenantId
    createdAt
    updatedAt
    displayField: machineName
  }
  createdAt
  updatedAt
}
    `;
export const MailTemplateFillFieldsFragmentDoc = gql`
    fragment mailTemplateFillFields on MailTemplateFill {
  id
  subject
  fields
  locale
  mailTemplate @include(if: $withMailTemplate) {
    id
    machineName
    name
    description
    mailLayoutId
    tenantId
    createdAt
    updatedAt
    displayField: machineName
  }
  createdAt
  updatedAt
}
    `;
export const MissingContentFieldsFragmentDoc = gql`
    fragment missingContentFields on MissingContent {
  id
  machineName
  locale
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    publicKey
    redirectUri
    termsAndConditions
    frontendBaseUri
    googleAuthEnabled
    googleId
    googleSecret
    microsoftAuthEnabled
    microsoftId
    microsoftSecret
    microsoftTenantId
    inviteExpiration
    passwordResetExpiration
    registerEnabled
    confirmAccountEnabled
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const PermissionFieldsFragmentDoc = gql`
    fragment permissionFields on Permission {
  id
  name
  description
  roles @include(if: $withRoles) {
    items {
      id
      machineName
      displayName
      description
      displayField: displayName
    }
    totalCount
  }
}
    `;
export const ResetPasswordFieldsFragmentDoc = gql`
    fragment resetPasswordFields on ResetPassword {
  id
  email
  token
  type
  createdAt
  updatedAt
}
    `;
export const RoleFieldsFragmentDoc = gql`
    fragment roleFields on Role {
  id
  machineName
  displayName
  description
  permissions @include(if: $withPermissions) {
    items {
      id
      name
      description
      displayField: name
    }
    totalCount
  }
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      displayField: id
    }
    totalCount
  }
}
    `;
export const TenantFieldsFragmentDoc = gql`
    fragment tenantFields on Tenant {
  id
  name
  timeZone
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      displayField: id
    }
    totalCount
  }
  publicKey
  redirectUri
  termsAndConditions
  frontendBaseUri
  googleAuthEnabled
  googleId
  googleSecret
  microsoftAuthEnabled
  microsoftId
  microsoftSecret
  microsoftTenantId
  inviteExpiration
  passwordResetExpiration
  registerEnabled
  confirmAccountEnabled
  contents @include(if: $withContents) {
    items {
      id
      machineName
      name
      tenantId
      createdAt
      updatedAt
      displayField: name
    }
    totalCount
  }
  allowedApiHostnames @include(if: $withAllowedApiHostnames) {
    items {
      id
      hostnameWildcard
      tenantId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      machineName
      name
      description
      mailLayoutId
      tenantId
      createdAt
      updatedAt
      displayField: machineName
    }
    totalCount
  }
  mailLayouts @include(if: $withMailLayouts) {
    items {
      id
      name
      machineName
      description
      layout
      default
      tenantId
      createdAt
      updatedAt
      displayField: name
    }
    totalCount
  }
  missingContents @include(if: $withMissingContents) {
    items {
      id
      machineName
      locale
      tenantId
      createdAt
      updatedAt
      displayField: machineName
    }
    totalCount
  }
  authorizationCodes @include(if: $withAuthorizationCodes) {
    items {
      id
      code
      redirectUri
      tenantId
      tenantUserId
      createdAt
      displayField: id
    }
    totalCount
  }
  tenantUsers @include(if: $withTenantUsers) {
    items {
      id
      email
      termsAndConditions
      active
      emailVerifiedAt
      totpVerified
      accountProvider
      tenantId
      createdAt
      updatedAt
      deletedAt
      displayField: email
    }
    totalCount
  }
}
    `;
export const TenantUserFieldsFragmentDoc = gql`
    fragment tenantUserFields on TenantUser {
  id
  email
  termsAndConditions
  active
  emailVerifiedAt
  totpVerified
  accountProvider
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    publicKey
    redirectUri
    termsAndConditions
    frontendBaseUri
    googleAuthEnabled
    googleId
    googleSecret
    microsoftAuthEnabled
    microsoftId
    microsoftSecret
    microsoftTenantId
    inviteExpiration
    passwordResetExpiration
    registerEnabled
    confirmAccountEnabled
    displayField: name
  }
  authorizationCodes @include(if: $withAuthorizationCodes) {
    items {
      id
      code
      redirectUri
      tenantId
      tenantUserId
      createdAt
      displayField: id
    }
    totalCount
  }
  tenantUserResetPasswords @include(if: $withTenantUserResetPasswords) {
    items {
      id
      tenantUserId
      token
      type
      createdAt
      updatedAt
      deletedAt
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const TenantUserResetPasswordFieldsFragmentDoc = gql`
    fragment tenantUserResetPasswordFields on TenantUserResetPassword {
  id
  tenantUser @include(if: $withTenantUser) {
    id
    email
    termsAndConditions
    active
    emailVerifiedAt
    totpVerified
    accountProvider
    tenantId
    createdAt
    updatedAt
    deletedAt
    displayField: email
  }
  token
  type
  createdAt
  updatedAt
  deletedAt
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  name
  email
  emailVerifiedAt
  active
  avatar
  totpVerified
  termsAndConditions
  locale
  timeZone
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const UserTenantRoleFieldsFragmentDoc = gql`
    fragment userTenantRoleFields on UserTenantRole {
  id
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    publicKey
    redirectUri
    termsAndConditions
    frontendBaseUri
    googleAuthEnabled
    googleId
    googleSecret
    microsoftAuthEnabled
    microsoftId
    microsoftSecret
    microsoftTenantId
    inviteExpiration
    passwordResetExpiration
    registerEnabled
    confirmAccountEnabled
    displayField: name
  }
  role @include(if: $withRole) {
    id
    machineName
    displayName
    description
    displayField: displayName
  }
}
    `;
export const GetAllowedApiHostnamesDocument = gql`
    query GetAllowedApiHostnames($filter: AllowedApiHostnameFilterArgs, $paging: PageArgs, $sorting: [AllowedApiHostnameSortArgs!], $withTenant: Boolean = false) {
  allowedApiHostnames(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...allowedApiHostnameFields
    }
    totalCount
  }
}
    ${AllowedApiHostnameFieldsFragmentDoc}`;

/**
 * __useGetAllowedApiHostnamesQuery__
 *
 * To run a query within a React component, call `useGetAllowedApiHostnamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedApiHostnamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedApiHostnamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetAllowedApiHostnamesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllowedApiHostnamesQuery, GetAllowedApiHostnamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllowedApiHostnamesQuery, GetAllowedApiHostnamesQueryVariables>(GetAllowedApiHostnamesDocument, options);
      }
export function useGetAllowedApiHostnamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllowedApiHostnamesQuery, GetAllowedApiHostnamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllowedApiHostnamesQuery, GetAllowedApiHostnamesQueryVariables>(GetAllowedApiHostnamesDocument, options);
        }
export function useGetAllowedApiHostnamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllowedApiHostnamesQuery, GetAllowedApiHostnamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllowedApiHostnamesQuery, GetAllowedApiHostnamesQueryVariables>(GetAllowedApiHostnamesDocument, options);
        }
export type GetAllowedApiHostnamesQueryHookResult = ReturnType<typeof useGetAllowedApiHostnamesQuery>;
export type GetAllowedApiHostnamesLazyQueryHookResult = ReturnType<typeof useGetAllowedApiHostnamesLazyQuery>;
export type GetAllowedApiHostnamesSuspenseQueryHookResult = ReturnType<typeof useGetAllowedApiHostnamesSuspenseQuery>;
export type GetAllowedApiHostnamesQueryResult = Apollo.QueryResult<GetAllowedApiHostnamesQuery, GetAllowedApiHostnamesQueryVariables>;
export const GetAllowedApiHostnameDocument = gql`
    query GetAllowedApiHostname($id: ID!, $withTenant: Boolean = false) {
  allowedApiHostname(id: $id) {
    ...allowedApiHostnameFields
  }
}
    ${AllowedApiHostnameFieldsFragmentDoc}`;

/**
 * __useGetAllowedApiHostnameQuery__
 *
 * To run a query within a React component, call `useGetAllowedApiHostnameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedApiHostnameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedApiHostnameQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetAllowedApiHostnameQuery(baseOptions: Apollo.QueryHookOptions<GetAllowedApiHostnameQuery, GetAllowedApiHostnameQueryVariables> & ({ variables: GetAllowedApiHostnameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllowedApiHostnameQuery, GetAllowedApiHostnameQueryVariables>(GetAllowedApiHostnameDocument, options);
      }
export function useGetAllowedApiHostnameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllowedApiHostnameQuery, GetAllowedApiHostnameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllowedApiHostnameQuery, GetAllowedApiHostnameQueryVariables>(GetAllowedApiHostnameDocument, options);
        }
export function useGetAllowedApiHostnameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllowedApiHostnameQuery, GetAllowedApiHostnameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllowedApiHostnameQuery, GetAllowedApiHostnameQueryVariables>(GetAllowedApiHostnameDocument, options);
        }
export type GetAllowedApiHostnameQueryHookResult = ReturnType<typeof useGetAllowedApiHostnameQuery>;
export type GetAllowedApiHostnameLazyQueryHookResult = ReturnType<typeof useGetAllowedApiHostnameLazyQuery>;
export type GetAllowedApiHostnameSuspenseQueryHookResult = ReturnType<typeof useGetAllowedApiHostnameSuspenseQuery>;
export type GetAllowedApiHostnameQueryResult = Apollo.QueryResult<GetAllowedApiHostnameQuery, GetAllowedApiHostnameQueryVariables>;
export const GetAllRelatedDataForAllowedApiHostnameDocument = gql`
    query GetAllRelatedDataForAllowedApiHostname($withTenants: Boolean = false) {
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForAllowedApiHostnameQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForAllowedApiHostnameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForAllowedApiHostnameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForAllowedApiHostnameQuery({
 *   variables: {
 *      withTenants: // value for 'withTenants'
 *   },
 * });
 */
export function useGetAllRelatedDataForAllowedApiHostnameQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForAllowedApiHostnameQuery, GetAllRelatedDataForAllowedApiHostnameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForAllowedApiHostnameQuery, GetAllRelatedDataForAllowedApiHostnameQueryVariables>(GetAllRelatedDataForAllowedApiHostnameDocument, options);
      }
export function useGetAllRelatedDataForAllowedApiHostnameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForAllowedApiHostnameQuery, GetAllRelatedDataForAllowedApiHostnameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForAllowedApiHostnameQuery, GetAllRelatedDataForAllowedApiHostnameQueryVariables>(GetAllRelatedDataForAllowedApiHostnameDocument, options);
        }
export function useGetAllRelatedDataForAllowedApiHostnameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForAllowedApiHostnameQuery, GetAllRelatedDataForAllowedApiHostnameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForAllowedApiHostnameQuery, GetAllRelatedDataForAllowedApiHostnameQueryVariables>(GetAllRelatedDataForAllowedApiHostnameDocument, options);
        }
export type GetAllRelatedDataForAllowedApiHostnameQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAllowedApiHostnameQuery>;
export type GetAllRelatedDataForAllowedApiHostnameLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAllowedApiHostnameLazyQuery>;
export type GetAllRelatedDataForAllowedApiHostnameSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAllowedApiHostnameSuspenseQuery>;
export type GetAllRelatedDataForAllowedApiHostnameQueryResult = Apollo.QueryResult<GetAllRelatedDataForAllowedApiHostnameQuery, GetAllRelatedDataForAllowedApiHostnameQueryVariables>;
export const CreateAllowedApiHostnameDocument = gql`
    mutation CreateAllowedApiHostname($hostnameWildcard: String!, $tenantId: ID!, $withTenant: Boolean = false) {
  createAllowedApiHostname(
    hostnameWildcard: $hostnameWildcard
    tenantId: $tenantId
  ) {
    ...allowedApiHostnameFields
  }
}
    ${AllowedApiHostnameFieldsFragmentDoc}`;
export type CreateAllowedApiHostnameMutationFn = Apollo.MutationFunction<CreateAllowedApiHostnameMutation, CreateAllowedApiHostnameMutationVariables>;

/**
 * __useCreateAllowedApiHostnameMutation__
 *
 * To run a mutation, you first call `useCreateAllowedApiHostnameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllowedApiHostnameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllowedApiHostnameMutation, { data, loading, error }] = useCreateAllowedApiHostnameMutation({
 *   variables: {
 *      hostnameWildcard: // value for 'hostnameWildcard'
 *      tenantId: // value for 'tenantId'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreateAllowedApiHostnameMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllowedApiHostnameMutation, CreateAllowedApiHostnameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllowedApiHostnameMutation, CreateAllowedApiHostnameMutationVariables>(CreateAllowedApiHostnameDocument, options);
      }
export type CreateAllowedApiHostnameMutationHookResult = ReturnType<typeof useCreateAllowedApiHostnameMutation>;
export type CreateAllowedApiHostnameMutationResult = Apollo.MutationResult<CreateAllowedApiHostnameMutation>;
export type CreateAllowedApiHostnameMutationOptions = Apollo.BaseMutationOptions<CreateAllowedApiHostnameMutation, CreateAllowedApiHostnameMutationVariables>;
export const UpdateAllowedApiHostnameDocument = gql`
    mutation UpdateAllowedApiHostname($id: ID!, $hostnameWildcard: String, $tenantId: ID, $withTenant: Boolean = false) {
  updateAllowedApiHostname(
    id: $id
    hostnameWildcard: $hostnameWildcard
    tenantId: $tenantId
  ) {
    ...allowedApiHostnameFields
  }
}
    ${AllowedApiHostnameFieldsFragmentDoc}`;
export type UpdateAllowedApiHostnameMutationFn = Apollo.MutationFunction<UpdateAllowedApiHostnameMutation, UpdateAllowedApiHostnameMutationVariables>;

/**
 * __useUpdateAllowedApiHostnameMutation__
 *
 * To run a mutation, you first call `useUpdateAllowedApiHostnameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowedApiHostnameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowedApiHostnameMutation, { data, loading, error }] = useUpdateAllowedApiHostnameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hostnameWildcard: // value for 'hostnameWildcard'
 *      tenantId: // value for 'tenantId'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdateAllowedApiHostnameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllowedApiHostnameMutation, UpdateAllowedApiHostnameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllowedApiHostnameMutation, UpdateAllowedApiHostnameMutationVariables>(UpdateAllowedApiHostnameDocument, options);
      }
export type UpdateAllowedApiHostnameMutationHookResult = ReturnType<typeof useUpdateAllowedApiHostnameMutation>;
export type UpdateAllowedApiHostnameMutationResult = Apollo.MutationResult<UpdateAllowedApiHostnameMutation>;
export type UpdateAllowedApiHostnameMutationOptions = Apollo.BaseMutationOptions<UpdateAllowedApiHostnameMutation, UpdateAllowedApiHostnameMutationVariables>;
export const DeleteAllowedApiHostnameDocument = gql`
    mutation DeleteAllowedApiHostname($id: ID!, $withTenant: Boolean = false) {
  deleteAllowedApiHostname(id: $id) {
    ...allowedApiHostnameFields
  }
}
    ${AllowedApiHostnameFieldsFragmentDoc}`;
export type DeleteAllowedApiHostnameMutationFn = Apollo.MutationFunction<DeleteAllowedApiHostnameMutation, DeleteAllowedApiHostnameMutationVariables>;

/**
 * __useDeleteAllowedApiHostnameMutation__
 *
 * To run a mutation, you first call `useDeleteAllowedApiHostnameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllowedApiHostnameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllowedApiHostnameMutation, { data, loading, error }] = useDeleteAllowedApiHostnameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useDeleteAllowedApiHostnameMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllowedApiHostnameMutation, DeleteAllowedApiHostnameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllowedApiHostnameMutation, DeleteAllowedApiHostnameMutationVariables>(DeleteAllowedApiHostnameDocument, options);
      }
export type DeleteAllowedApiHostnameMutationHookResult = ReturnType<typeof useDeleteAllowedApiHostnameMutation>;
export type DeleteAllowedApiHostnameMutationResult = Apollo.MutationResult<DeleteAllowedApiHostnameMutation>;
export type DeleteAllowedApiHostnameMutationOptions = Apollo.BaseMutationOptions<DeleteAllowedApiHostnameMutation, DeleteAllowedApiHostnameMutationVariables>;
export const CreatedAllowedApiHostnameDocument = gql`
    subscription CreatedAllowedApiHostname($filter: AllowedApiHostnameFilterArgs, $withTenant: Boolean = false) {
  createdAllowedApiHostname(filter: $filter) {
    ...allowedApiHostnameFields
  }
}
    ${AllowedApiHostnameFieldsFragmentDoc}`;

/**
 * __useCreatedAllowedApiHostnameSubscription__
 *
 * To run a query within a React component, call `useCreatedAllowedApiHostnameSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedAllowedApiHostnameSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedAllowedApiHostnameSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreatedAllowedApiHostnameSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedAllowedApiHostnameSubscription, CreatedAllowedApiHostnameSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedAllowedApiHostnameSubscription, CreatedAllowedApiHostnameSubscriptionVariables>(CreatedAllowedApiHostnameDocument, options);
      }
export type CreatedAllowedApiHostnameSubscriptionHookResult = ReturnType<typeof useCreatedAllowedApiHostnameSubscription>;
export type CreatedAllowedApiHostnameSubscriptionResult = Apollo.SubscriptionResult<CreatedAllowedApiHostnameSubscription>;
export const UpdatedAllowedApiHostnameDocument = gql`
    subscription UpdatedAllowedApiHostname($filter: AllowedApiHostnameFilterArgs, $withTenant: Boolean = false) {
  updatedAllowedApiHostname(filter: $filter) {
    ...allowedApiHostnameFields
  }
}
    ${AllowedApiHostnameFieldsFragmentDoc}`;

/**
 * __useUpdatedAllowedApiHostnameSubscription__
 *
 * To run a query within a React component, call `useUpdatedAllowedApiHostnameSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedAllowedApiHostnameSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedAllowedApiHostnameSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdatedAllowedApiHostnameSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedAllowedApiHostnameSubscription, UpdatedAllowedApiHostnameSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedAllowedApiHostnameSubscription, UpdatedAllowedApiHostnameSubscriptionVariables>(UpdatedAllowedApiHostnameDocument, options);
      }
export type UpdatedAllowedApiHostnameSubscriptionHookResult = ReturnType<typeof useUpdatedAllowedApiHostnameSubscription>;
export type UpdatedAllowedApiHostnameSubscriptionResult = Apollo.SubscriptionResult<UpdatedAllowedApiHostnameSubscription>;
export const DeletedAllowedApiHostnameDocument = gql`
    subscription DeletedAllowedApiHostname($filter: AllowedApiHostnameFilterArgs) {
  deletedAllowedApiHostname(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedAllowedApiHostnameSubscription__
 *
 * To run a query within a React component, call `useDeletedAllowedApiHostnameSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedAllowedApiHostnameSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedAllowedApiHostnameSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedAllowedApiHostnameSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedAllowedApiHostnameSubscription, DeletedAllowedApiHostnameSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedAllowedApiHostnameSubscription, DeletedAllowedApiHostnameSubscriptionVariables>(DeletedAllowedApiHostnameDocument, options);
      }
export type DeletedAllowedApiHostnameSubscriptionHookResult = ReturnType<typeof useDeletedAllowedApiHostnameSubscription>;
export type DeletedAllowedApiHostnameSubscriptionResult = Apollo.SubscriptionResult<DeletedAllowedApiHostnameSubscription>;
export const GetAuthorizationCodesDocument = gql`
    query GetAuthorizationCodes($filter: AuthorizationCodeFilterArgs, $paging: PageArgs, $sorting: [AuthorizationCodeSortArgs!], $withTenant: Boolean = false, $withTenantUser: Boolean = false) {
  authorizationCodes(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...authorizationCodeFields
    }
    totalCount
  }
}
    ${AuthorizationCodeFieldsFragmentDoc}`;

/**
 * __useGetAuthorizationCodesQuery__
 *
 * To run a query within a React component, call `useGetAuthorizationCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizationCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizationCodesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withTenant: // value for 'withTenant'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useGetAuthorizationCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthorizationCodesQuery, GetAuthorizationCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizationCodesQuery, GetAuthorizationCodesQueryVariables>(GetAuthorizationCodesDocument, options);
      }
export function useGetAuthorizationCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizationCodesQuery, GetAuthorizationCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizationCodesQuery, GetAuthorizationCodesQueryVariables>(GetAuthorizationCodesDocument, options);
        }
export function useGetAuthorizationCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorizationCodesQuery, GetAuthorizationCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorizationCodesQuery, GetAuthorizationCodesQueryVariables>(GetAuthorizationCodesDocument, options);
        }
export type GetAuthorizationCodesQueryHookResult = ReturnType<typeof useGetAuthorizationCodesQuery>;
export type GetAuthorizationCodesLazyQueryHookResult = ReturnType<typeof useGetAuthorizationCodesLazyQuery>;
export type GetAuthorizationCodesSuspenseQueryHookResult = ReturnType<typeof useGetAuthorizationCodesSuspenseQuery>;
export type GetAuthorizationCodesQueryResult = Apollo.QueryResult<GetAuthorizationCodesQuery, GetAuthorizationCodesQueryVariables>;
export const GetAuthorizationCodeDocument = gql`
    query GetAuthorizationCode($id: ID!, $withTenant: Boolean = false, $withTenantUser: Boolean = false) {
  authorizationCode(id: $id) {
    ...authorizationCodeFields
  }
}
    ${AuthorizationCodeFieldsFragmentDoc}`;

/**
 * __useGetAuthorizationCodeQuery__
 *
 * To run a query within a React component, call `useGetAuthorizationCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizationCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizationCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useGetAuthorizationCodeQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorizationCodeQuery, GetAuthorizationCodeQueryVariables> & ({ variables: GetAuthorizationCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizationCodeQuery, GetAuthorizationCodeQueryVariables>(GetAuthorizationCodeDocument, options);
      }
export function useGetAuthorizationCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizationCodeQuery, GetAuthorizationCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizationCodeQuery, GetAuthorizationCodeQueryVariables>(GetAuthorizationCodeDocument, options);
        }
export function useGetAuthorizationCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorizationCodeQuery, GetAuthorizationCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorizationCodeQuery, GetAuthorizationCodeQueryVariables>(GetAuthorizationCodeDocument, options);
        }
export type GetAuthorizationCodeQueryHookResult = ReturnType<typeof useGetAuthorizationCodeQuery>;
export type GetAuthorizationCodeLazyQueryHookResult = ReturnType<typeof useGetAuthorizationCodeLazyQuery>;
export type GetAuthorizationCodeSuspenseQueryHookResult = ReturnType<typeof useGetAuthorizationCodeSuspenseQuery>;
export type GetAuthorizationCodeQueryResult = Apollo.QueryResult<GetAuthorizationCodeQuery, GetAuthorizationCodeQueryVariables>;
export const GetAllRelatedDataForAuthorizationCodeDocument = gql`
    query GetAllRelatedDataForAuthorizationCode($withTenants: Boolean = false, $withTenantUsers: Boolean = false) {
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  tenantUsers @include(if: $withTenantUsers) {
    items {
      id
      displayField: email
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForAuthorizationCodeQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForAuthorizationCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForAuthorizationCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForAuthorizationCodeQuery({
 *   variables: {
 *      withTenants: // value for 'withTenants'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForAuthorizationCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForAuthorizationCodeQuery, GetAllRelatedDataForAuthorizationCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForAuthorizationCodeQuery, GetAllRelatedDataForAuthorizationCodeQueryVariables>(GetAllRelatedDataForAuthorizationCodeDocument, options);
      }
export function useGetAllRelatedDataForAuthorizationCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForAuthorizationCodeQuery, GetAllRelatedDataForAuthorizationCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForAuthorizationCodeQuery, GetAllRelatedDataForAuthorizationCodeQueryVariables>(GetAllRelatedDataForAuthorizationCodeDocument, options);
        }
export function useGetAllRelatedDataForAuthorizationCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForAuthorizationCodeQuery, GetAllRelatedDataForAuthorizationCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForAuthorizationCodeQuery, GetAllRelatedDataForAuthorizationCodeQueryVariables>(GetAllRelatedDataForAuthorizationCodeDocument, options);
        }
export type GetAllRelatedDataForAuthorizationCodeQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAuthorizationCodeQuery>;
export type GetAllRelatedDataForAuthorizationCodeLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAuthorizationCodeLazyQuery>;
export type GetAllRelatedDataForAuthorizationCodeSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForAuthorizationCodeSuspenseQuery>;
export type GetAllRelatedDataForAuthorizationCodeQueryResult = Apollo.QueryResult<GetAllRelatedDataForAuthorizationCodeQuery, GetAllRelatedDataForAuthorizationCodeQueryVariables>;
export const CreateAuthorizationCodeDocument = gql`
    mutation CreateAuthorizationCode($code: String!, $redirectUri: String!, $tenantId: ID!, $tenantUserId: ID!, $withTenant: Boolean = false, $withTenantUser: Boolean = false) {
  createAuthorizationCode(
    code: $code
    redirectUri: $redirectUri
    tenantId: $tenantId
    tenantUserId: $tenantUserId
  ) {
    ...authorizationCodeFields
  }
}
    ${AuthorizationCodeFieldsFragmentDoc}`;
export type CreateAuthorizationCodeMutationFn = Apollo.MutationFunction<CreateAuthorizationCodeMutation, CreateAuthorizationCodeMutationVariables>;

/**
 * __useCreateAuthorizationCodeMutation__
 *
 * To run a mutation, you first call `useCreateAuthorizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorizationCodeMutation, { data, loading, error }] = useCreateAuthorizationCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *      tenantId: // value for 'tenantId'
 *      tenantUserId: // value for 'tenantUserId'
 *      withTenant: // value for 'withTenant'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useCreateAuthorizationCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthorizationCodeMutation, CreateAuthorizationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuthorizationCodeMutation, CreateAuthorizationCodeMutationVariables>(CreateAuthorizationCodeDocument, options);
      }
export type CreateAuthorizationCodeMutationHookResult = ReturnType<typeof useCreateAuthorizationCodeMutation>;
export type CreateAuthorizationCodeMutationResult = Apollo.MutationResult<CreateAuthorizationCodeMutation>;
export type CreateAuthorizationCodeMutationOptions = Apollo.BaseMutationOptions<CreateAuthorizationCodeMutation, CreateAuthorizationCodeMutationVariables>;
export const UpdateAuthorizationCodeDocument = gql`
    mutation UpdateAuthorizationCode($id: ID!, $code: String, $redirectUri: String, $tenantId: ID, $tenantUserId: ID, $withTenant: Boolean = false, $withTenantUser: Boolean = false) {
  updateAuthorizationCode(
    id: $id
    code: $code
    redirectUri: $redirectUri
    tenantId: $tenantId
    tenantUserId: $tenantUserId
  ) {
    ...authorizationCodeFields
  }
}
    ${AuthorizationCodeFieldsFragmentDoc}`;
export type UpdateAuthorizationCodeMutationFn = Apollo.MutationFunction<UpdateAuthorizationCodeMutation, UpdateAuthorizationCodeMutationVariables>;

/**
 * __useUpdateAuthorizationCodeMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizationCodeMutation, { data, loading, error }] = useUpdateAuthorizationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *      tenantId: // value for 'tenantId'
 *      tenantUserId: // value for 'tenantUserId'
 *      withTenant: // value for 'withTenant'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useUpdateAuthorizationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuthorizationCodeMutation, UpdateAuthorizationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthorizationCodeMutation, UpdateAuthorizationCodeMutationVariables>(UpdateAuthorizationCodeDocument, options);
      }
export type UpdateAuthorizationCodeMutationHookResult = ReturnType<typeof useUpdateAuthorizationCodeMutation>;
export type UpdateAuthorizationCodeMutationResult = Apollo.MutationResult<UpdateAuthorizationCodeMutation>;
export type UpdateAuthorizationCodeMutationOptions = Apollo.BaseMutationOptions<UpdateAuthorizationCodeMutation, UpdateAuthorizationCodeMutationVariables>;
export const DeleteAuthorizationCodeDocument = gql`
    mutation DeleteAuthorizationCode($id: ID!, $withTenant: Boolean = false, $withTenantUser: Boolean = false) {
  deleteAuthorizationCode(id: $id) {
    ...authorizationCodeFields
  }
}
    ${AuthorizationCodeFieldsFragmentDoc}`;
export type DeleteAuthorizationCodeMutationFn = Apollo.MutationFunction<DeleteAuthorizationCodeMutation, DeleteAuthorizationCodeMutationVariables>;

/**
 * __useDeleteAuthorizationCodeMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorizationCodeMutation, { data, loading, error }] = useDeleteAuthorizationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useDeleteAuthorizationCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAuthorizationCodeMutation, DeleteAuthorizationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAuthorizationCodeMutation, DeleteAuthorizationCodeMutationVariables>(DeleteAuthorizationCodeDocument, options);
      }
export type DeleteAuthorizationCodeMutationHookResult = ReturnType<typeof useDeleteAuthorizationCodeMutation>;
export type DeleteAuthorizationCodeMutationResult = Apollo.MutationResult<DeleteAuthorizationCodeMutation>;
export type DeleteAuthorizationCodeMutationOptions = Apollo.BaseMutationOptions<DeleteAuthorizationCodeMutation, DeleteAuthorizationCodeMutationVariables>;
export const CreatedAuthorizationCodeDocument = gql`
    subscription CreatedAuthorizationCode($filter: AuthorizationCodeFilterArgs, $withTenant: Boolean = false, $withTenantUser: Boolean = false) {
  createdAuthorizationCode(filter: $filter) {
    ...authorizationCodeFields
  }
}
    ${AuthorizationCodeFieldsFragmentDoc}`;

/**
 * __useCreatedAuthorizationCodeSubscription__
 *
 * To run a query within a React component, call `useCreatedAuthorizationCodeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedAuthorizationCodeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedAuthorizationCodeSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useCreatedAuthorizationCodeSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedAuthorizationCodeSubscription, CreatedAuthorizationCodeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedAuthorizationCodeSubscription, CreatedAuthorizationCodeSubscriptionVariables>(CreatedAuthorizationCodeDocument, options);
      }
export type CreatedAuthorizationCodeSubscriptionHookResult = ReturnType<typeof useCreatedAuthorizationCodeSubscription>;
export type CreatedAuthorizationCodeSubscriptionResult = Apollo.SubscriptionResult<CreatedAuthorizationCodeSubscription>;
export const UpdatedAuthorizationCodeDocument = gql`
    subscription UpdatedAuthorizationCode($filter: AuthorizationCodeFilterArgs, $withTenant: Boolean = false, $withTenantUser: Boolean = false) {
  updatedAuthorizationCode(filter: $filter) {
    ...authorizationCodeFields
  }
}
    ${AuthorizationCodeFieldsFragmentDoc}`;

/**
 * __useUpdatedAuthorizationCodeSubscription__
 *
 * To run a query within a React component, call `useUpdatedAuthorizationCodeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedAuthorizationCodeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedAuthorizationCodeSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useUpdatedAuthorizationCodeSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedAuthorizationCodeSubscription, UpdatedAuthorizationCodeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedAuthorizationCodeSubscription, UpdatedAuthorizationCodeSubscriptionVariables>(UpdatedAuthorizationCodeDocument, options);
      }
export type UpdatedAuthorizationCodeSubscriptionHookResult = ReturnType<typeof useUpdatedAuthorizationCodeSubscription>;
export type UpdatedAuthorizationCodeSubscriptionResult = Apollo.SubscriptionResult<UpdatedAuthorizationCodeSubscription>;
export const DeletedAuthorizationCodeDocument = gql`
    subscription DeletedAuthorizationCode($filter: AuthorizationCodeFilterArgs) {
  deletedAuthorizationCode(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedAuthorizationCodeSubscription__
 *
 * To run a query within a React component, call `useDeletedAuthorizationCodeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedAuthorizationCodeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedAuthorizationCodeSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedAuthorizationCodeSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedAuthorizationCodeSubscription, DeletedAuthorizationCodeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedAuthorizationCodeSubscription, DeletedAuthorizationCodeSubscriptionVariables>(DeletedAuthorizationCodeDocument, options);
      }
export type DeletedAuthorizationCodeSubscriptionHookResult = ReturnType<typeof useDeletedAuthorizationCodeSubscription>;
export type DeletedAuthorizationCodeSubscriptionResult = Apollo.SubscriptionResult<DeletedAuthorizationCodeSubscription>;
export const GetContentsDocument = gql`
    query GetContents($filter: ContentFilterArgs, $paging: PageArgs, $sorting: [ContentSortArgs!], $withContentFills: Boolean = false, $withTenant: Boolean = false) {
  contents(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...contentFields
    }
    totalCount
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useGetContentsQuery__
 *
 * To run a query within a React component, call `useGetContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withContentFills: // value for 'withContentFills'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
      }
export function useGetContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
        }
export function useGetContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
        }
export type GetContentsQueryHookResult = ReturnType<typeof useGetContentsQuery>;
export type GetContentsLazyQueryHookResult = ReturnType<typeof useGetContentsLazyQuery>;
export type GetContentsSuspenseQueryHookResult = ReturnType<typeof useGetContentsSuspenseQuery>;
export type GetContentsQueryResult = Apollo.QueryResult<GetContentsQuery, GetContentsQueryVariables>;
export const GetContentDocument = gql`
    query GetContent($id: ID!, $withContentFills: Boolean = false, $withTenant: Boolean = false) {
  content(id: $id) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useGetContentQuery__
 *
 * To run a query within a React component, call `useGetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withContentFills: // value for 'withContentFills'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetContentQuery(baseOptions: Apollo.QueryHookOptions<GetContentQuery, GetContentQueryVariables> & ({ variables: GetContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
      }
export function useGetContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export function useGetContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export type GetContentQueryHookResult = ReturnType<typeof useGetContentQuery>;
export type GetContentLazyQueryHookResult = ReturnType<typeof useGetContentLazyQuery>;
export type GetContentSuspenseQueryHookResult = ReturnType<typeof useGetContentSuspenseQuery>;
export type GetContentQueryResult = Apollo.QueryResult<GetContentQuery, GetContentQueryVariables>;
export const GetAllRelatedDataForContentDocument = gql`
    query GetAllRelatedDataForContent($withContentFills: Boolean = false, $withTenants: Boolean = false) {
  contentFills @include(if: $withContentFills) {
    items {
      id
      displayField: id
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForContentQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForContentQuery({
 *   variables: {
 *      withContentFills: // value for 'withContentFills'
 *      withTenants: // value for 'withTenants'
 *   },
 * });
 */
export function useGetAllRelatedDataForContentQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
      }
export function useGetAllRelatedDataForContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
        }
export function useGetAllRelatedDataForContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
        }
export type GetAllRelatedDataForContentQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentQuery>;
export type GetAllRelatedDataForContentLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentLazyQuery>;
export type GetAllRelatedDataForContentSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentSuspenseQuery>;
export type GetAllRelatedDataForContentQueryResult = Apollo.QueryResult<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>;
export const CreateContentDocument = gql`
    mutation CreateContent($machineName: String!, $name: String!, $contentFills: [ID], $tenantId: ID!, $withContentFills: Boolean = false, $withTenant: Boolean = false) {
  createContent(
    machineName: $machineName
    name: $name
    contentFillIds: $contentFills
    tenantId: $tenantId
  ) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type CreateContentMutationFn = Apollo.MutationFunction<CreateContentMutation, CreateContentMutationVariables>;

/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      machineName: // value for 'machineName'
 *      name: // value for 'name'
 *      contentFills: // value for 'contentFills'
 *      tenantId: // value for 'tenantId'
 *      withContentFills: // value for 'withContentFills'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentMutation, CreateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentMutation, CreateContentMutationVariables>(CreateContentDocument, options);
      }
export type CreateContentMutationHookResult = ReturnType<typeof useCreateContentMutation>;
export type CreateContentMutationResult = Apollo.MutationResult<CreateContentMutation>;
export type CreateContentMutationOptions = Apollo.BaseMutationOptions<CreateContentMutation, CreateContentMutationVariables>;
export const UpdateContentDocument = gql`
    mutation UpdateContent($id: ID!, $machineName: String, $name: String, $contentFills: [ID], $tenantId: ID, $withContentFills: Boolean = false, $withTenant: Boolean = false) {
  updateContent(
    id: $id
    machineName: $machineName
    name: $name
    contentFillIds: $contentFills
    tenantId: $tenantId
  ) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type UpdateContentMutationFn = Apollo.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      machineName: // value for 'machineName'
 *      name: // value for 'name'
 *      contentFills: // value for 'contentFills'
 *      tenantId: // value for 'tenantId'
 *      withContentFills: // value for 'withContentFills'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(UpdateContentDocument, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;
export const DeleteContentDocument = gql`
    mutation DeleteContent($id: ID!, $withContentFills: Boolean = false, $withTenant: Boolean = false) {
  deleteContent(id: $id) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type DeleteContentMutationFn = Apollo.MutationFunction<DeleteContentMutation, DeleteContentMutationVariables>;

/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withContentFills: // value for 'withContentFills'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useDeleteContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentMutation, DeleteContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentMutation, DeleteContentMutationVariables>(DeleteContentDocument, options);
      }
export type DeleteContentMutationHookResult = ReturnType<typeof useDeleteContentMutation>;
export type DeleteContentMutationResult = Apollo.MutationResult<DeleteContentMutation>;
export type DeleteContentMutationOptions = Apollo.BaseMutationOptions<DeleteContentMutation, DeleteContentMutationVariables>;
export const CreatedContentDocument = gql`
    subscription CreatedContent($filter: ContentFilterArgs, $withContentFills: Boolean = false, $withTenant: Boolean = false) {
  createdContent(filter: $filter) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useCreatedContentSubscription__
 *
 * To run a query within a React component, call `useCreatedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContentFills: // value for 'withContentFills'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreatedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedContentSubscription, CreatedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedContentSubscription, CreatedContentSubscriptionVariables>(CreatedContentDocument, options);
      }
export type CreatedContentSubscriptionHookResult = ReturnType<typeof useCreatedContentSubscription>;
export type CreatedContentSubscriptionResult = Apollo.SubscriptionResult<CreatedContentSubscription>;
export const UpdatedContentDocument = gql`
    subscription UpdatedContent($filter: ContentFilterArgs, $withContentFills: Boolean = false, $withTenant: Boolean = false) {
  updatedContent(filter: $filter) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useUpdatedContentSubscription__
 *
 * To run a query within a React component, call `useUpdatedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContentFills: // value for 'withContentFills'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdatedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedContentSubscription, UpdatedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedContentSubscription, UpdatedContentSubscriptionVariables>(UpdatedContentDocument, options);
      }
export type UpdatedContentSubscriptionHookResult = ReturnType<typeof useUpdatedContentSubscription>;
export type UpdatedContentSubscriptionResult = Apollo.SubscriptionResult<UpdatedContentSubscription>;
export const DeletedContentDocument = gql`
    subscription DeletedContent($filter: ContentFilterArgs) {
  deletedContent(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedContentSubscription__
 *
 * To run a query within a React component, call `useDeletedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedContentSubscription, DeletedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedContentSubscription, DeletedContentSubscriptionVariables>(DeletedContentDocument, options);
      }
export type DeletedContentSubscriptionHookResult = ReturnType<typeof useDeletedContentSubscription>;
export type DeletedContentSubscriptionResult = Apollo.SubscriptionResult<DeletedContentSubscription>;
export const GetContentFillsDocument = gql`
    query GetContentFills($filter: ContentFillFilterArgs, $paging: PageArgs, $sorting: [ContentFillSortArgs!], $withContent: Boolean = false) {
  contentFills(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...contentFillFields
    }
    totalCount
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useGetContentFillsQuery__
 *
 * To run a query within a React component, call `useGetContentFillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useGetContentFillsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
      }
export function useGetContentFillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
        }
export function useGetContentFillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
        }
export type GetContentFillsQueryHookResult = ReturnType<typeof useGetContentFillsQuery>;
export type GetContentFillsLazyQueryHookResult = ReturnType<typeof useGetContentFillsLazyQuery>;
export type GetContentFillsSuspenseQueryHookResult = ReturnType<typeof useGetContentFillsSuspenseQuery>;
export type GetContentFillsQueryResult = Apollo.QueryResult<GetContentFillsQuery, GetContentFillsQueryVariables>;
export const GetContentFillDocument = gql`
    query GetContentFill($id: ID!, $withContent: Boolean = false) {
  contentFill(id: $id) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useGetContentFillQuery__
 *
 * To run a query within a React component, call `useGetContentFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFillQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useGetContentFillQuery(baseOptions: Apollo.QueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables> & ({ variables: GetContentFillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
      }
export function useGetContentFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
        }
export function useGetContentFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
        }
export type GetContentFillQueryHookResult = ReturnType<typeof useGetContentFillQuery>;
export type GetContentFillLazyQueryHookResult = ReturnType<typeof useGetContentFillLazyQuery>;
export type GetContentFillSuspenseQueryHookResult = ReturnType<typeof useGetContentFillSuspenseQuery>;
export type GetContentFillQueryResult = Apollo.QueryResult<GetContentFillQuery, GetContentFillQueryVariables>;
export const GetAllRelatedDataForContentFillDocument = gql`
    query GetAllRelatedDataForContentFill($withContents: Boolean = false) {
  contents @include(if: $withContents) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForContentFillQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForContentFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForContentFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForContentFillQuery({
 *   variables: {
 *      withContents: // value for 'withContents'
 *   },
 * });
 */
export function useGetAllRelatedDataForContentFillQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
      }
export function useGetAllRelatedDataForContentFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
        }
export function useGetAllRelatedDataForContentFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
        }
export type GetAllRelatedDataForContentFillQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillQuery>;
export type GetAllRelatedDataForContentFillLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillLazyQuery>;
export type GetAllRelatedDataForContentFillSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillSuspenseQuery>;
export type GetAllRelatedDataForContentFillQueryResult = Apollo.QueryResult<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>;
export const CreateContentFillDocument = gql`
    mutation CreateContentFill($fill: String!, $locale: String!, $contentId: ID!, $withContent: Boolean = false) {
  createContentFill(fill: $fill, locale: $locale, contentId: $contentId) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type CreateContentFillMutationFn = Apollo.MutationFunction<CreateContentFillMutation, CreateContentFillMutationVariables>;

/**
 * __useCreateContentFillMutation__
 *
 * To run a mutation, you first call `useCreateContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentFillMutation, { data, loading, error }] = useCreateContentFillMutation({
 *   variables: {
 *      fill: // value for 'fill'
 *      locale: // value for 'locale'
 *      contentId: // value for 'contentId'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useCreateContentFillMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentFillMutation, CreateContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentFillMutation, CreateContentFillMutationVariables>(CreateContentFillDocument, options);
      }
export type CreateContentFillMutationHookResult = ReturnType<typeof useCreateContentFillMutation>;
export type CreateContentFillMutationResult = Apollo.MutationResult<CreateContentFillMutation>;
export type CreateContentFillMutationOptions = Apollo.BaseMutationOptions<CreateContentFillMutation, CreateContentFillMutationVariables>;
export const UpdateContentFillDocument = gql`
    mutation UpdateContentFill($id: ID!, $fill: String, $locale: String, $contentId: ID, $withContent: Boolean = false) {
  updateContentFill(id: $id, fill: $fill, locale: $locale, contentId: $contentId) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type UpdateContentFillMutationFn = Apollo.MutationFunction<UpdateContentFillMutation, UpdateContentFillMutationVariables>;

/**
 * __useUpdateContentFillMutation__
 *
 * To run a mutation, you first call `useUpdateContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentFillMutation, { data, loading, error }] = useUpdateContentFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fill: // value for 'fill'
 *      locale: // value for 'locale'
 *      contentId: // value for 'contentId'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useUpdateContentFillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentFillMutation, UpdateContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentFillMutation, UpdateContentFillMutationVariables>(UpdateContentFillDocument, options);
      }
export type UpdateContentFillMutationHookResult = ReturnType<typeof useUpdateContentFillMutation>;
export type UpdateContentFillMutationResult = Apollo.MutationResult<UpdateContentFillMutation>;
export type UpdateContentFillMutationOptions = Apollo.BaseMutationOptions<UpdateContentFillMutation, UpdateContentFillMutationVariables>;
export const DeleteContentFillDocument = gql`
    mutation DeleteContentFill($id: ID!, $withContent: Boolean = false) {
  deleteContentFill(id: $id) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type DeleteContentFillMutationFn = Apollo.MutationFunction<DeleteContentFillMutation, DeleteContentFillMutationVariables>;

/**
 * __useDeleteContentFillMutation__
 *
 * To run a mutation, you first call `useDeleteContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentFillMutation, { data, loading, error }] = useDeleteContentFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useDeleteContentFillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentFillMutation, DeleteContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentFillMutation, DeleteContentFillMutationVariables>(DeleteContentFillDocument, options);
      }
export type DeleteContentFillMutationHookResult = ReturnType<typeof useDeleteContentFillMutation>;
export type DeleteContentFillMutationResult = Apollo.MutationResult<DeleteContentFillMutation>;
export type DeleteContentFillMutationOptions = Apollo.BaseMutationOptions<DeleteContentFillMutation, DeleteContentFillMutationVariables>;
export const CreatedContentFillDocument = gql`
    subscription CreatedContentFill($filter: ContentFillFilterArgs, $withContent: Boolean = false) {
  createdContentFill(filter: $filter) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useCreatedContentFillSubscription__
 *
 * To run a query within a React component, call `useCreatedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useCreatedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedContentFillSubscription, CreatedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedContentFillSubscription, CreatedContentFillSubscriptionVariables>(CreatedContentFillDocument, options);
      }
export type CreatedContentFillSubscriptionHookResult = ReturnType<typeof useCreatedContentFillSubscription>;
export type CreatedContentFillSubscriptionResult = Apollo.SubscriptionResult<CreatedContentFillSubscription>;
export const UpdatedContentFillDocument = gql`
    subscription UpdatedContentFill($filter: ContentFillFilterArgs, $withContent: Boolean = false) {
  updatedContentFill(filter: $filter) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useUpdatedContentFillSubscription__
 *
 * To run a query within a React component, call `useUpdatedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useUpdatedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedContentFillSubscription, UpdatedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedContentFillSubscription, UpdatedContentFillSubscriptionVariables>(UpdatedContentFillDocument, options);
      }
export type UpdatedContentFillSubscriptionHookResult = ReturnType<typeof useUpdatedContentFillSubscription>;
export type UpdatedContentFillSubscriptionResult = Apollo.SubscriptionResult<UpdatedContentFillSubscription>;
export const DeletedContentFillDocument = gql`
    subscription DeletedContentFill($filter: ContentFillFilterArgs) {
  deletedContentFill(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedContentFillSubscription__
 *
 * To run a query within a React component, call `useDeletedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedContentFillSubscription, DeletedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedContentFillSubscription, DeletedContentFillSubscriptionVariables>(DeletedContentFillDocument, options);
      }
export type DeletedContentFillSubscriptionHookResult = ReturnType<typeof useDeletedContentFillSubscription>;
export type DeletedContentFillSubscriptionResult = Apollo.SubscriptionResult<DeletedContentFillSubscription>;
export const GetErrorLogsDocument = gql`
    query GetErrorLogs($filter: ErrorLogFilterArgs, $paging: PageArgs, $sorting: [ErrorLogSortArgs!]) {
  errorLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...errorLogFields
    }
    totalCount
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useGetErrorLogsQuery__
 *
 * To run a query within a React component, call `useGetErrorLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetErrorLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
      }
export function useGetErrorLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
        }
export function useGetErrorLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
        }
export type GetErrorLogsQueryHookResult = ReturnType<typeof useGetErrorLogsQuery>;
export type GetErrorLogsLazyQueryHookResult = ReturnType<typeof useGetErrorLogsLazyQuery>;
export type GetErrorLogsSuspenseQueryHookResult = ReturnType<typeof useGetErrorLogsSuspenseQuery>;
export type GetErrorLogsQueryResult = Apollo.QueryResult<GetErrorLogsQuery, GetErrorLogsQueryVariables>;
export const GetErrorLogDocument = gql`
    query GetErrorLog($id: ID!) {
  errorLog(id: $id) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useGetErrorLogQuery__
 *
 * To run a query within a React component, call `useGetErrorLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetErrorLogQuery(baseOptions: Apollo.QueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables> & ({ variables: GetErrorLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
      }
export function useGetErrorLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
        }
export function useGetErrorLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
        }
export type GetErrorLogQueryHookResult = ReturnType<typeof useGetErrorLogQuery>;
export type GetErrorLogLazyQueryHookResult = ReturnType<typeof useGetErrorLogLazyQuery>;
export type GetErrorLogSuspenseQueryHookResult = ReturnType<typeof useGetErrorLogSuspenseQuery>;
export type GetErrorLogQueryResult = Apollo.QueryResult<GetErrorLogQuery, GetErrorLogQueryVariables>;
export const CreateErrorLogDocument = gql`
    mutation CreateErrorLog($error: String!, $stack: String, $domain: String!) {
  createErrorLog(error: $error, stack: $stack, domain: $domain) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type CreateErrorLogMutationFn = Apollo.MutationFunction<CreateErrorLogMutation, CreateErrorLogMutationVariables>;

/**
 * __useCreateErrorLogMutation__
 *
 * To run a mutation, you first call `useCreateErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrorLogMutation, { data, loading, error }] = useCreateErrorLogMutation({
 *   variables: {
 *      error: // value for 'error'
 *      stack: // value for 'stack'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useCreateErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrorLogMutation, CreateErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrorLogMutation, CreateErrorLogMutationVariables>(CreateErrorLogDocument, options);
      }
export type CreateErrorLogMutationHookResult = ReturnType<typeof useCreateErrorLogMutation>;
export type CreateErrorLogMutationResult = Apollo.MutationResult<CreateErrorLogMutation>;
export type CreateErrorLogMutationOptions = Apollo.BaseMutationOptions<CreateErrorLogMutation, CreateErrorLogMutationVariables>;
export const UpdateErrorLogDocument = gql`
    mutation UpdateErrorLog($id: ID!, $error: String, $stack: String, $domain: String) {
  updateErrorLog(id: $id, error: $error, stack: $stack, domain: $domain) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type UpdateErrorLogMutationFn = Apollo.MutationFunction<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>;

/**
 * __useUpdateErrorLogMutation__
 *
 * To run a mutation, you first call `useUpdateErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrorLogMutation, { data, loading, error }] = useUpdateErrorLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      error: // value for 'error'
 *      stack: // value for 'stack'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useUpdateErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>(UpdateErrorLogDocument, options);
      }
export type UpdateErrorLogMutationHookResult = ReturnType<typeof useUpdateErrorLogMutation>;
export type UpdateErrorLogMutationResult = Apollo.MutationResult<UpdateErrorLogMutation>;
export type UpdateErrorLogMutationOptions = Apollo.BaseMutationOptions<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>;
export const DeleteErrorLogDocument = gql`
    mutation DeleteErrorLog($id: ID!) {
  deleteErrorLog(id: $id) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type DeleteErrorLogMutationFn = Apollo.MutationFunction<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>;

/**
 * __useDeleteErrorLogMutation__
 *
 * To run a mutation, you first call `useDeleteErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErrorLogMutation, { data, loading, error }] = useDeleteErrorLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>(DeleteErrorLogDocument, options);
      }
export type DeleteErrorLogMutationHookResult = ReturnType<typeof useDeleteErrorLogMutation>;
export type DeleteErrorLogMutationResult = Apollo.MutationResult<DeleteErrorLogMutation>;
export type DeleteErrorLogMutationOptions = Apollo.BaseMutationOptions<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>;
export const CreatedErrorLogDocument = gql`
    subscription CreatedErrorLog($filter: ErrorLogFilterArgs) {
  createdErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useCreatedErrorLogSubscription__
 *
 * To run a query within a React component, call `useCreatedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedErrorLogSubscription, CreatedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedErrorLogSubscription, CreatedErrorLogSubscriptionVariables>(CreatedErrorLogDocument, options);
      }
export type CreatedErrorLogSubscriptionHookResult = ReturnType<typeof useCreatedErrorLogSubscription>;
export type CreatedErrorLogSubscriptionResult = Apollo.SubscriptionResult<CreatedErrorLogSubscription>;
export const UpdatedErrorLogDocument = gql`
    subscription UpdatedErrorLog($filter: ErrorLogFilterArgs) {
  updatedErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useUpdatedErrorLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedErrorLogSubscription, UpdatedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedErrorLogSubscription, UpdatedErrorLogSubscriptionVariables>(UpdatedErrorLogDocument, options);
      }
export type UpdatedErrorLogSubscriptionHookResult = ReturnType<typeof useUpdatedErrorLogSubscription>;
export type UpdatedErrorLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedErrorLogSubscription>;
export const DeletedErrorLogDocument = gql`
    subscription DeletedErrorLog($filter: ErrorLogFilterArgs) {
  deletedErrorLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedErrorLogSubscription__
 *
 * To run a query within a React component, call `useDeletedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedErrorLogSubscription, DeletedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedErrorLogSubscription, DeletedErrorLogSubscriptionVariables>(DeletedErrorLogDocument, options);
      }
export type DeletedErrorLogSubscriptionHookResult = ReturnType<typeof useDeletedErrorLogSubscription>;
export type DeletedErrorLogSubscriptionResult = Apollo.SubscriptionResult<DeletedErrorLogSubscription>;
export const RestoredErrorLogDocument = gql`
    subscription RestoredErrorLog($filter: ErrorLogFilterArgs) {
  restoredErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useRestoredErrorLogSubscription__
 *
 * To run a query within a React component, call `useRestoredErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredErrorLogSubscription, RestoredErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredErrorLogSubscription, RestoredErrorLogSubscriptionVariables>(RestoredErrorLogDocument, options);
      }
export type RestoredErrorLogSubscriptionHookResult = ReturnType<typeof useRestoredErrorLogSubscription>;
export type RestoredErrorLogSubscriptionResult = Apollo.SubscriptionResult<RestoredErrorLogSubscription>;
export const GetEventLogsDocument = gql`
    query GetEventLogs($filter: EventLogFilterArgs, $paging: PageArgs, $sorting: [EventLogSortArgs!]) {
  eventLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...eventLogFields
    }
    totalCount
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useGetEventLogsQuery__
 *
 * To run a query within a React component, call `useGetEventLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetEventLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
      }
export function useGetEventLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
        }
export function useGetEventLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
        }
export type GetEventLogsQueryHookResult = ReturnType<typeof useGetEventLogsQuery>;
export type GetEventLogsLazyQueryHookResult = ReturnType<typeof useGetEventLogsLazyQuery>;
export type GetEventLogsSuspenseQueryHookResult = ReturnType<typeof useGetEventLogsSuspenseQuery>;
export type GetEventLogsQueryResult = Apollo.QueryResult<GetEventLogsQuery, GetEventLogsQueryVariables>;
export const GetEventLogDocument = gql`
    query GetEventLog($id: ID!) {
  eventLog(id: $id) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useGetEventLogQuery__
 *
 * To run a query within a React component, call `useGetEventLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventLogQuery(baseOptions: Apollo.QueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables> & ({ variables: GetEventLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
      }
export function useGetEventLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
        }
export function useGetEventLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
        }
export type GetEventLogQueryHookResult = ReturnType<typeof useGetEventLogQuery>;
export type GetEventLogLazyQueryHookResult = ReturnType<typeof useGetEventLogLazyQuery>;
export type GetEventLogSuspenseQueryHookResult = ReturnType<typeof useGetEventLogSuspenseQuery>;
export type GetEventLogQueryResult = Apollo.QueryResult<GetEventLogQuery, GetEventLogQueryVariables>;
export const CreateEventLogDocument = gql`
    mutation CreateEventLog($log: String!, $type: String!) {
  createEventLog(log: $log, type: $type) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type CreateEventLogMutationFn = Apollo.MutationFunction<CreateEventLogMutation, CreateEventLogMutationVariables>;

/**
 * __useCreateEventLogMutation__
 *
 * To run a mutation, you first call `useCreateEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventLogMutation, { data, loading, error }] = useCreateEventLogMutation({
 *   variables: {
 *      log: // value for 'log'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateEventLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventLogMutation, CreateEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventLogMutation, CreateEventLogMutationVariables>(CreateEventLogDocument, options);
      }
export type CreateEventLogMutationHookResult = ReturnType<typeof useCreateEventLogMutation>;
export type CreateEventLogMutationResult = Apollo.MutationResult<CreateEventLogMutation>;
export type CreateEventLogMutationOptions = Apollo.BaseMutationOptions<CreateEventLogMutation, CreateEventLogMutationVariables>;
export const UpdateEventLogDocument = gql`
    mutation UpdateEventLog($id: ID!, $log: String, $type: String) {
  updateEventLog(id: $id, log: $log, type: $type) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type UpdateEventLogMutationFn = Apollo.MutationFunction<UpdateEventLogMutation, UpdateEventLogMutationVariables>;

/**
 * __useUpdateEventLogMutation__
 *
 * To run a mutation, you first call `useUpdateEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventLogMutation, { data, loading, error }] = useUpdateEventLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      log: // value for 'log'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateEventLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventLogMutation, UpdateEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventLogMutation, UpdateEventLogMutationVariables>(UpdateEventLogDocument, options);
      }
export type UpdateEventLogMutationHookResult = ReturnType<typeof useUpdateEventLogMutation>;
export type UpdateEventLogMutationResult = Apollo.MutationResult<UpdateEventLogMutation>;
export type UpdateEventLogMutationOptions = Apollo.BaseMutationOptions<UpdateEventLogMutation, UpdateEventLogMutationVariables>;
export const DeleteEventLogDocument = gql`
    mutation DeleteEventLog($id: ID!) {
  deleteEventLog(id: $id) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type DeleteEventLogMutationFn = Apollo.MutationFunction<DeleteEventLogMutation, DeleteEventLogMutationVariables>;

/**
 * __useDeleteEventLogMutation__
 *
 * To run a mutation, you first call `useDeleteEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventLogMutation, { data, loading, error }] = useDeleteEventLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventLogMutation, DeleteEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventLogMutation, DeleteEventLogMutationVariables>(DeleteEventLogDocument, options);
      }
export type DeleteEventLogMutationHookResult = ReturnType<typeof useDeleteEventLogMutation>;
export type DeleteEventLogMutationResult = Apollo.MutationResult<DeleteEventLogMutation>;
export type DeleteEventLogMutationOptions = Apollo.BaseMutationOptions<DeleteEventLogMutation, DeleteEventLogMutationVariables>;
export const CreatedEventLogDocument = gql`
    subscription CreatedEventLog($filter: EventLogFilterArgs) {
  createdEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useCreatedEventLogSubscription__
 *
 * To run a query within a React component, call `useCreatedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedEventLogSubscription, CreatedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedEventLogSubscription, CreatedEventLogSubscriptionVariables>(CreatedEventLogDocument, options);
      }
export type CreatedEventLogSubscriptionHookResult = ReturnType<typeof useCreatedEventLogSubscription>;
export type CreatedEventLogSubscriptionResult = Apollo.SubscriptionResult<CreatedEventLogSubscription>;
export const UpdatedEventLogDocument = gql`
    subscription UpdatedEventLog($filter: EventLogFilterArgs) {
  updatedEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useUpdatedEventLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedEventLogSubscription, UpdatedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedEventLogSubscription, UpdatedEventLogSubscriptionVariables>(UpdatedEventLogDocument, options);
      }
export type UpdatedEventLogSubscriptionHookResult = ReturnType<typeof useUpdatedEventLogSubscription>;
export type UpdatedEventLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedEventLogSubscription>;
export const DeletedEventLogDocument = gql`
    subscription DeletedEventLog($filter: EventLogFilterArgs) {
  deletedEventLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedEventLogSubscription__
 *
 * To run a query within a React component, call `useDeletedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedEventLogSubscription, DeletedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedEventLogSubscription, DeletedEventLogSubscriptionVariables>(DeletedEventLogDocument, options);
      }
export type DeletedEventLogSubscriptionHookResult = ReturnType<typeof useDeletedEventLogSubscription>;
export type DeletedEventLogSubscriptionResult = Apollo.SubscriptionResult<DeletedEventLogSubscription>;
export const RestoredEventLogDocument = gql`
    subscription RestoredEventLog($filter: EventLogFilterArgs) {
  restoredEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useRestoredEventLogSubscription__
 *
 * To run a query within a React component, call `useRestoredEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredEventLogSubscription, RestoredEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredEventLogSubscription, RestoredEventLogSubscriptionVariables>(RestoredEventLogDocument, options);
      }
export type RestoredEventLogSubscriptionHookResult = ReturnType<typeof useRestoredEventLogSubscription>;
export type RestoredEventLogSubscriptionResult = Apollo.SubscriptionResult<RestoredEventLogSubscription>;
export const GetJobsDocument = gql`
    query GetJobs($filter: JobFilterArgs, $paging: PageArgs, $sorting: [JobSortArgs!]) {
  jobs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...jobFields
    }
    totalCount
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsSuspenseQueryHookResult = ReturnType<typeof useGetJobsSuspenseQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetJobDocument = gql`
    query GetJob($id: ID!) {
  job(id: $id) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables> & ({ variables: GetJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export function useGetJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobSuspenseQueryHookResult = ReturnType<typeof useGetJobSuspenseQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($queue: String!, $status: String!, $log: String) {
  createJob(queue: $queue, status: $status, log: $log) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      queue: // value for 'queue'
 *      status: // value for 'status'
 *      log: // value for 'log'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($id: ID!, $queue: String, $status: String, $log: String) {
  updateJob(id: $id, queue: $queue, status: $status, log: $log) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      queue: // value for 'queue'
 *      status: // value for 'status'
 *      log: // value for 'log'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const DeleteJobDocument = gql`
    mutation DeleteJob($id: ID!) {
  deleteJob(id: $id) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const CreatedJobDocument = gql`
    subscription CreatedJob($filter: JobFilterArgs) {
  createdJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useCreatedJobSubscription__
 *
 * To run a query within a React component, call `useCreatedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedJobSubscription, CreatedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedJobSubscription, CreatedJobSubscriptionVariables>(CreatedJobDocument, options);
      }
export type CreatedJobSubscriptionHookResult = ReturnType<typeof useCreatedJobSubscription>;
export type CreatedJobSubscriptionResult = Apollo.SubscriptionResult<CreatedJobSubscription>;
export const UpdatedJobDocument = gql`
    subscription UpdatedJob($filter: JobFilterArgs) {
  updatedJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useUpdatedJobSubscription__
 *
 * To run a query within a React component, call `useUpdatedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedJobSubscription, UpdatedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedJobSubscription, UpdatedJobSubscriptionVariables>(UpdatedJobDocument, options);
      }
export type UpdatedJobSubscriptionHookResult = ReturnType<typeof useUpdatedJobSubscription>;
export type UpdatedJobSubscriptionResult = Apollo.SubscriptionResult<UpdatedJobSubscription>;
export const DeletedJobDocument = gql`
    subscription DeletedJob($filter: JobFilterArgs) {
  deletedJob(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedJobSubscription__
 *
 * To run a query within a React component, call `useDeletedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedJobSubscription, DeletedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedJobSubscription, DeletedJobSubscriptionVariables>(DeletedJobDocument, options);
      }
export type DeletedJobSubscriptionHookResult = ReturnType<typeof useDeletedJobSubscription>;
export type DeletedJobSubscriptionResult = Apollo.SubscriptionResult<DeletedJobSubscription>;
export const RestoredJobDocument = gql`
    subscription RestoredJob($filter: JobFilterArgs) {
  restoredJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useRestoredJobSubscription__
 *
 * To run a query within a React component, call `useRestoredJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredJobSubscription, RestoredJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredJobSubscription, RestoredJobSubscriptionVariables>(RestoredJobDocument, options);
      }
export type RestoredJobSubscriptionHookResult = ReturnType<typeof useRestoredJobSubscription>;
export type RestoredJobSubscriptionResult = Apollo.SubscriptionResult<RestoredJobSubscription>;
export const GetMailLayoutsDocument = gql`
    query GetMailLayouts($filter: MailLayoutFilterArgs, $paging: PageArgs, $sorting: [MailLayoutSortArgs!], $withMailLayoutFields: Boolean = false, $withMailTemplates: Boolean = false, $withTenant: Boolean = false) {
  mailLayouts(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailLayoutFields
    }
    totalCount
  }
}
    ${MailLayoutFieldsFragmentDoc}`;

/**
 * __useGetMailLayoutsQuery__
 *
 * To run a query within a React component, call `useGetMailLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLayoutsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailLayoutFields: // value for 'withMailLayoutFields'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetMailLayoutsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailLayoutsQuery, GetMailLayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLayoutsQuery, GetMailLayoutsQueryVariables>(GetMailLayoutsDocument, options);
      }
export function useGetMailLayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLayoutsQuery, GetMailLayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLayoutsQuery, GetMailLayoutsQueryVariables>(GetMailLayoutsDocument, options);
        }
export function useGetMailLayoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLayoutsQuery, GetMailLayoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLayoutsQuery, GetMailLayoutsQueryVariables>(GetMailLayoutsDocument, options);
        }
export type GetMailLayoutsQueryHookResult = ReturnType<typeof useGetMailLayoutsQuery>;
export type GetMailLayoutsLazyQueryHookResult = ReturnType<typeof useGetMailLayoutsLazyQuery>;
export type GetMailLayoutsSuspenseQueryHookResult = ReturnType<typeof useGetMailLayoutsSuspenseQuery>;
export type GetMailLayoutsQueryResult = Apollo.QueryResult<GetMailLayoutsQuery, GetMailLayoutsQueryVariables>;
export const GetMailLayoutDocument = gql`
    query GetMailLayout($id: ID!, $withMailLayoutFields: Boolean = false, $withMailTemplates: Boolean = false, $withTenant: Boolean = false) {
  mailLayout(id: $id) {
    ...mailLayoutFields
  }
}
    ${MailLayoutFieldsFragmentDoc}`;

/**
 * __useGetMailLayoutQuery__
 *
 * To run a query within a React component, call `useGetMailLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailLayoutFields: // value for 'withMailLayoutFields'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetMailLayoutQuery(baseOptions: Apollo.QueryHookOptions<GetMailLayoutQuery, GetMailLayoutQueryVariables> & ({ variables: GetMailLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLayoutQuery, GetMailLayoutQueryVariables>(GetMailLayoutDocument, options);
      }
export function useGetMailLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLayoutQuery, GetMailLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLayoutQuery, GetMailLayoutQueryVariables>(GetMailLayoutDocument, options);
        }
export function useGetMailLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLayoutQuery, GetMailLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLayoutQuery, GetMailLayoutQueryVariables>(GetMailLayoutDocument, options);
        }
export type GetMailLayoutQueryHookResult = ReturnType<typeof useGetMailLayoutQuery>;
export type GetMailLayoutLazyQueryHookResult = ReturnType<typeof useGetMailLayoutLazyQuery>;
export type GetMailLayoutSuspenseQueryHookResult = ReturnType<typeof useGetMailLayoutSuspenseQuery>;
export type GetMailLayoutQueryResult = Apollo.QueryResult<GetMailLayoutQuery, GetMailLayoutQueryVariables>;
export const GetAllRelatedDataForMailLayoutDocument = gql`
    query GetAllRelatedDataForMailLayout($withMailLayoutFields: Boolean = false, $withMailTemplates: Boolean = false, $withTenants: Boolean = false) {
  mailLayoutFields @include(if: $withMailLayoutFields) {
    items {
      id
      displayField: name
    }
  }
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      displayField: machineName
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailLayoutQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailLayoutQuery({
 *   variables: {
 *      withMailLayoutFields: // value for 'withMailLayoutFields'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withTenants: // value for 'withTenants'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailLayoutQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailLayoutQuery, GetAllRelatedDataForMailLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailLayoutQuery, GetAllRelatedDataForMailLayoutQueryVariables>(GetAllRelatedDataForMailLayoutDocument, options);
      }
export function useGetAllRelatedDataForMailLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailLayoutQuery, GetAllRelatedDataForMailLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailLayoutQuery, GetAllRelatedDataForMailLayoutQueryVariables>(GetAllRelatedDataForMailLayoutDocument, options);
        }
export function useGetAllRelatedDataForMailLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailLayoutQuery, GetAllRelatedDataForMailLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailLayoutQuery, GetAllRelatedDataForMailLayoutQueryVariables>(GetAllRelatedDataForMailLayoutDocument, options);
        }
export type GetAllRelatedDataForMailLayoutQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailLayoutQuery>;
export type GetAllRelatedDataForMailLayoutLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailLayoutLazyQuery>;
export type GetAllRelatedDataForMailLayoutSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailLayoutSuspenseQuery>;
export type GetAllRelatedDataForMailLayoutQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailLayoutQuery, GetAllRelatedDataForMailLayoutQueryVariables>;
export const CreateMailLayoutDocument = gql`
    mutation CreateMailLayout($name: String!, $machineName: String!, $description: String, $layout: String!, $default: Boolean!, $mailLayoutFields: [ID], $mailTemplates: [ID], $tenantId: ID, $withMailLayoutFields: Boolean = false, $withMailTemplates: Boolean = false, $withTenant: Boolean = false) {
  createMailLayout(
    name: $name
    machineName: $machineName
    description: $description
    layout: $layout
    default: $default
    mailLayoutFieldIds: $mailLayoutFields
    mailTemplateIds: $mailTemplates
    tenantId: $tenantId
  ) {
    ...mailLayoutFields
  }
}
    ${MailLayoutFieldsFragmentDoc}`;
export type CreateMailLayoutMutationFn = Apollo.MutationFunction<CreateMailLayoutMutation, CreateMailLayoutMutationVariables>;

/**
 * __useCreateMailLayoutMutation__
 *
 * To run a mutation, you first call `useCreateMailLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailLayoutMutation, { data, loading, error }] = useCreateMailLayoutMutation({
 *   variables: {
 *      name: // value for 'name'
 *      machineName: // value for 'machineName'
 *      description: // value for 'description'
 *      layout: // value for 'layout'
 *      default: // value for 'default'
 *      mailLayoutFields: // value for 'mailLayoutFields'
 *      mailTemplates: // value for 'mailTemplates'
 *      tenantId: // value for 'tenantId'
 *      withMailLayoutFields: // value for 'withMailLayoutFields'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreateMailLayoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailLayoutMutation, CreateMailLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailLayoutMutation, CreateMailLayoutMutationVariables>(CreateMailLayoutDocument, options);
      }
export type CreateMailLayoutMutationHookResult = ReturnType<typeof useCreateMailLayoutMutation>;
export type CreateMailLayoutMutationResult = Apollo.MutationResult<CreateMailLayoutMutation>;
export type CreateMailLayoutMutationOptions = Apollo.BaseMutationOptions<CreateMailLayoutMutation, CreateMailLayoutMutationVariables>;
export const UpdateMailLayoutDocument = gql`
    mutation UpdateMailLayout($id: ID!, $name: String, $machineName: String, $description: String, $layout: String, $default: Boolean, $mailLayoutFields: [ID], $mailTemplates: [ID], $tenantId: ID, $withMailLayoutFields: Boolean = false, $withMailTemplates: Boolean = false, $withTenant: Boolean = false) {
  updateMailLayout(
    id: $id
    name: $name
    machineName: $machineName
    description: $description
    layout: $layout
    default: $default
    mailLayoutFieldIds: $mailLayoutFields
    mailTemplateIds: $mailTemplates
    tenantId: $tenantId
  ) {
    ...mailLayoutFields
  }
}
    ${MailLayoutFieldsFragmentDoc}`;
export type UpdateMailLayoutMutationFn = Apollo.MutationFunction<UpdateMailLayoutMutation, UpdateMailLayoutMutationVariables>;

/**
 * __useUpdateMailLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateMailLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailLayoutMutation, { data, loading, error }] = useUpdateMailLayoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      machineName: // value for 'machineName'
 *      description: // value for 'description'
 *      layout: // value for 'layout'
 *      default: // value for 'default'
 *      mailLayoutFields: // value for 'mailLayoutFields'
 *      mailTemplates: // value for 'mailTemplates'
 *      tenantId: // value for 'tenantId'
 *      withMailLayoutFields: // value for 'withMailLayoutFields'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdateMailLayoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailLayoutMutation, UpdateMailLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailLayoutMutation, UpdateMailLayoutMutationVariables>(UpdateMailLayoutDocument, options);
      }
export type UpdateMailLayoutMutationHookResult = ReturnType<typeof useUpdateMailLayoutMutation>;
export type UpdateMailLayoutMutationResult = Apollo.MutationResult<UpdateMailLayoutMutation>;
export type UpdateMailLayoutMutationOptions = Apollo.BaseMutationOptions<UpdateMailLayoutMutation, UpdateMailLayoutMutationVariables>;
export const DeleteMailLayoutDocument = gql`
    mutation DeleteMailLayout($id: ID!, $withMailLayoutFields: Boolean = false, $withMailTemplates: Boolean = false, $withTenant: Boolean = false) {
  deleteMailLayout(id: $id) {
    ...mailLayoutFields
  }
}
    ${MailLayoutFieldsFragmentDoc}`;
export type DeleteMailLayoutMutationFn = Apollo.MutationFunction<DeleteMailLayoutMutation, DeleteMailLayoutMutationVariables>;

/**
 * __useDeleteMailLayoutMutation__
 *
 * To run a mutation, you first call `useDeleteMailLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailLayoutMutation, { data, loading, error }] = useDeleteMailLayoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailLayoutFields: // value for 'withMailLayoutFields'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useDeleteMailLayoutMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailLayoutMutation, DeleteMailLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailLayoutMutation, DeleteMailLayoutMutationVariables>(DeleteMailLayoutDocument, options);
      }
export type DeleteMailLayoutMutationHookResult = ReturnType<typeof useDeleteMailLayoutMutation>;
export type DeleteMailLayoutMutationResult = Apollo.MutationResult<DeleteMailLayoutMutation>;
export type DeleteMailLayoutMutationOptions = Apollo.BaseMutationOptions<DeleteMailLayoutMutation, DeleteMailLayoutMutationVariables>;
export const CreatedMailLayoutDocument = gql`
    subscription CreatedMailLayout($filter: MailLayoutFilterArgs, $withMailLayoutFields: Boolean = false, $withMailTemplates: Boolean = false, $withTenant: Boolean = false) {
  createdMailLayout(filter: $filter) {
    ...mailLayoutFields
  }
}
    ${MailLayoutFieldsFragmentDoc}`;

/**
 * __useCreatedMailLayoutSubscription__
 *
 * To run a query within a React component, call `useCreatedMailLayoutSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailLayoutSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailLayoutSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailLayoutFields: // value for 'withMailLayoutFields'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreatedMailLayoutSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailLayoutSubscription, CreatedMailLayoutSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailLayoutSubscription, CreatedMailLayoutSubscriptionVariables>(CreatedMailLayoutDocument, options);
      }
export type CreatedMailLayoutSubscriptionHookResult = ReturnType<typeof useCreatedMailLayoutSubscription>;
export type CreatedMailLayoutSubscriptionResult = Apollo.SubscriptionResult<CreatedMailLayoutSubscription>;
export const UpdatedMailLayoutDocument = gql`
    subscription UpdatedMailLayout($filter: MailLayoutFilterArgs, $withMailLayoutFields: Boolean = false, $withMailTemplates: Boolean = false, $withTenant: Boolean = false) {
  updatedMailLayout(filter: $filter) {
    ...mailLayoutFields
  }
}
    ${MailLayoutFieldsFragmentDoc}`;

/**
 * __useUpdatedMailLayoutSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailLayoutSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailLayoutSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailLayoutSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailLayoutFields: // value for 'withMailLayoutFields'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdatedMailLayoutSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailLayoutSubscription, UpdatedMailLayoutSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailLayoutSubscription, UpdatedMailLayoutSubscriptionVariables>(UpdatedMailLayoutDocument, options);
      }
export type UpdatedMailLayoutSubscriptionHookResult = ReturnType<typeof useUpdatedMailLayoutSubscription>;
export type UpdatedMailLayoutSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailLayoutSubscription>;
export const DeletedMailLayoutDocument = gql`
    subscription DeletedMailLayout($filter: MailLayoutFilterArgs) {
  deletedMailLayout(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailLayoutSubscription__
 *
 * To run a query within a React component, call `useDeletedMailLayoutSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailLayoutSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailLayoutSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailLayoutSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailLayoutSubscription, DeletedMailLayoutSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailLayoutSubscription, DeletedMailLayoutSubscriptionVariables>(DeletedMailLayoutDocument, options);
      }
export type DeletedMailLayoutSubscriptionHookResult = ReturnType<typeof useDeletedMailLayoutSubscription>;
export type DeletedMailLayoutSubscriptionResult = Apollo.SubscriptionResult<DeletedMailLayoutSubscription>;
export const GetMailLayoutFieldsDocument = gql`
    query GetMailLayoutFields($filter: MailLayoutFieldFilterArgs, $paging: PageArgs, $sorting: [MailLayoutFieldSortArgs!], $withMailLayout: Boolean = false) {
  mailLayoutFields(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailLayoutFieldFields
    }
    totalCount
  }
}
    ${MailLayoutFieldFieldsFragmentDoc}`;

/**
 * __useGetMailLayoutFieldsQuery__
 *
 * To run a query within a React component, call `useGetMailLayoutFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLayoutFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLayoutFieldsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailLayout: // value for 'withMailLayout'
 *   },
 * });
 */
export function useGetMailLayoutFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailLayoutFieldsQuery, GetMailLayoutFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLayoutFieldsQuery, GetMailLayoutFieldsQueryVariables>(GetMailLayoutFieldsDocument, options);
      }
export function useGetMailLayoutFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLayoutFieldsQuery, GetMailLayoutFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLayoutFieldsQuery, GetMailLayoutFieldsQueryVariables>(GetMailLayoutFieldsDocument, options);
        }
export function useGetMailLayoutFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLayoutFieldsQuery, GetMailLayoutFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLayoutFieldsQuery, GetMailLayoutFieldsQueryVariables>(GetMailLayoutFieldsDocument, options);
        }
export type GetMailLayoutFieldsQueryHookResult = ReturnType<typeof useGetMailLayoutFieldsQuery>;
export type GetMailLayoutFieldsLazyQueryHookResult = ReturnType<typeof useGetMailLayoutFieldsLazyQuery>;
export type GetMailLayoutFieldsSuspenseQueryHookResult = ReturnType<typeof useGetMailLayoutFieldsSuspenseQuery>;
export type GetMailLayoutFieldsQueryResult = Apollo.QueryResult<GetMailLayoutFieldsQuery, GetMailLayoutFieldsQueryVariables>;
export const GetMailLayoutFieldDocument = gql`
    query GetMailLayoutField($id: ID!, $withMailLayout: Boolean = false) {
  mailLayoutField(id: $id) {
    ...mailLayoutFieldFields
  }
}
    ${MailLayoutFieldFieldsFragmentDoc}`;

/**
 * __useGetMailLayoutFieldQuery__
 *
 * To run a query within a React component, call `useGetMailLayoutFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLayoutFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLayoutFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailLayout: // value for 'withMailLayout'
 *   },
 * });
 */
export function useGetMailLayoutFieldQuery(baseOptions: Apollo.QueryHookOptions<GetMailLayoutFieldQuery, GetMailLayoutFieldQueryVariables> & ({ variables: GetMailLayoutFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLayoutFieldQuery, GetMailLayoutFieldQueryVariables>(GetMailLayoutFieldDocument, options);
      }
export function useGetMailLayoutFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLayoutFieldQuery, GetMailLayoutFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLayoutFieldQuery, GetMailLayoutFieldQueryVariables>(GetMailLayoutFieldDocument, options);
        }
export function useGetMailLayoutFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLayoutFieldQuery, GetMailLayoutFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLayoutFieldQuery, GetMailLayoutFieldQueryVariables>(GetMailLayoutFieldDocument, options);
        }
export type GetMailLayoutFieldQueryHookResult = ReturnType<typeof useGetMailLayoutFieldQuery>;
export type GetMailLayoutFieldLazyQueryHookResult = ReturnType<typeof useGetMailLayoutFieldLazyQuery>;
export type GetMailLayoutFieldSuspenseQueryHookResult = ReturnType<typeof useGetMailLayoutFieldSuspenseQuery>;
export type GetMailLayoutFieldQueryResult = Apollo.QueryResult<GetMailLayoutFieldQuery, GetMailLayoutFieldQueryVariables>;
export const GetAllRelatedDataForMailLayoutFieldDocument = gql`
    query GetAllRelatedDataForMailLayoutField($withMailLayouts: Boolean = false) {
  mailLayouts @include(if: $withMailLayouts) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailLayoutFieldQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailLayoutFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailLayoutFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailLayoutFieldQuery({
 *   variables: {
 *      withMailLayouts: // value for 'withMailLayouts'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailLayoutFieldQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailLayoutFieldQuery, GetAllRelatedDataForMailLayoutFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailLayoutFieldQuery, GetAllRelatedDataForMailLayoutFieldQueryVariables>(GetAllRelatedDataForMailLayoutFieldDocument, options);
      }
export function useGetAllRelatedDataForMailLayoutFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailLayoutFieldQuery, GetAllRelatedDataForMailLayoutFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailLayoutFieldQuery, GetAllRelatedDataForMailLayoutFieldQueryVariables>(GetAllRelatedDataForMailLayoutFieldDocument, options);
        }
export function useGetAllRelatedDataForMailLayoutFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailLayoutFieldQuery, GetAllRelatedDataForMailLayoutFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailLayoutFieldQuery, GetAllRelatedDataForMailLayoutFieldQueryVariables>(GetAllRelatedDataForMailLayoutFieldDocument, options);
        }
export type GetAllRelatedDataForMailLayoutFieldQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailLayoutFieldQuery>;
export type GetAllRelatedDataForMailLayoutFieldLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailLayoutFieldLazyQuery>;
export type GetAllRelatedDataForMailLayoutFieldSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailLayoutFieldSuspenseQuery>;
export type GetAllRelatedDataForMailLayoutFieldQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailLayoutFieldQuery, GetAllRelatedDataForMailLayoutFieldQueryVariables>;
export const CreateMailLayoutFieldDocument = gql`
    mutation CreateMailLayoutField($name: String!, $machineName: String!, $description: String, $required: Boolean!, $mailLayoutId: ID!, $withMailLayout: Boolean = false) {
  createMailLayoutField(
    name: $name
    machineName: $machineName
    description: $description
    required: $required
    mailLayoutId: $mailLayoutId
  ) {
    ...mailLayoutFieldFields
  }
}
    ${MailLayoutFieldFieldsFragmentDoc}`;
export type CreateMailLayoutFieldMutationFn = Apollo.MutationFunction<CreateMailLayoutFieldMutation, CreateMailLayoutFieldMutationVariables>;

/**
 * __useCreateMailLayoutFieldMutation__
 *
 * To run a mutation, you first call `useCreateMailLayoutFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailLayoutFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailLayoutFieldMutation, { data, loading, error }] = useCreateMailLayoutFieldMutation({
 *   variables: {
 *      name: // value for 'name'
 *      machineName: // value for 'machineName'
 *      description: // value for 'description'
 *      required: // value for 'required'
 *      mailLayoutId: // value for 'mailLayoutId'
 *      withMailLayout: // value for 'withMailLayout'
 *   },
 * });
 */
export function useCreateMailLayoutFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailLayoutFieldMutation, CreateMailLayoutFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailLayoutFieldMutation, CreateMailLayoutFieldMutationVariables>(CreateMailLayoutFieldDocument, options);
      }
export type CreateMailLayoutFieldMutationHookResult = ReturnType<typeof useCreateMailLayoutFieldMutation>;
export type CreateMailLayoutFieldMutationResult = Apollo.MutationResult<CreateMailLayoutFieldMutation>;
export type CreateMailLayoutFieldMutationOptions = Apollo.BaseMutationOptions<CreateMailLayoutFieldMutation, CreateMailLayoutFieldMutationVariables>;
export const UpdateMailLayoutFieldDocument = gql`
    mutation UpdateMailLayoutField($id: ID!, $name: String, $machineName: String, $description: String, $required: Boolean, $mailLayoutId: ID, $withMailLayout: Boolean = false) {
  updateMailLayoutField(
    id: $id
    name: $name
    machineName: $machineName
    description: $description
    required: $required
    mailLayoutId: $mailLayoutId
  ) {
    ...mailLayoutFieldFields
  }
}
    ${MailLayoutFieldFieldsFragmentDoc}`;
export type UpdateMailLayoutFieldMutationFn = Apollo.MutationFunction<UpdateMailLayoutFieldMutation, UpdateMailLayoutFieldMutationVariables>;

/**
 * __useUpdateMailLayoutFieldMutation__
 *
 * To run a mutation, you first call `useUpdateMailLayoutFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailLayoutFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailLayoutFieldMutation, { data, loading, error }] = useUpdateMailLayoutFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      machineName: // value for 'machineName'
 *      description: // value for 'description'
 *      required: // value for 'required'
 *      mailLayoutId: // value for 'mailLayoutId'
 *      withMailLayout: // value for 'withMailLayout'
 *   },
 * });
 */
export function useUpdateMailLayoutFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailLayoutFieldMutation, UpdateMailLayoutFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailLayoutFieldMutation, UpdateMailLayoutFieldMutationVariables>(UpdateMailLayoutFieldDocument, options);
      }
export type UpdateMailLayoutFieldMutationHookResult = ReturnType<typeof useUpdateMailLayoutFieldMutation>;
export type UpdateMailLayoutFieldMutationResult = Apollo.MutationResult<UpdateMailLayoutFieldMutation>;
export type UpdateMailLayoutFieldMutationOptions = Apollo.BaseMutationOptions<UpdateMailLayoutFieldMutation, UpdateMailLayoutFieldMutationVariables>;
export const DeleteMailLayoutFieldDocument = gql`
    mutation DeleteMailLayoutField($id: ID!, $withMailLayout: Boolean = false) {
  deleteMailLayoutField(id: $id) {
    ...mailLayoutFieldFields
  }
}
    ${MailLayoutFieldFieldsFragmentDoc}`;
export type DeleteMailLayoutFieldMutationFn = Apollo.MutationFunction<DeleteMailLayoutFieldMutation, DeleteMailLayoutFieldMutationVariables>;

/**
 * __useDeleteMailLayoutFieldMutation__
 *
 * To run a mutation, you first call `useDeleteMailLayoutFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailLayoutFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailLayoutFieldMutation, { data, loading, error }] = useDeleteMailLayoutFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailLayout: // value for 'withMailLayout'
 *   },
 * });
 */
export function useDeleteMailLayoutFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailLayoutFieldMutation, DeleteMailLayoutFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailLayoutFieldMutation, DeleteMailLayoutFieldMutationVariables>(DeleteMailLayoutFieldDocument, options);
      }
export type DeleteMailLayoutFieldMutationHookResult = ReturnType<typeof useDeleteMailLayoutFieldMutation>;
export type DeleteMailLayoutFieldMutationResult = Apollo.MutationResult<DeleteMailLayoutFieldMutation>;
export type DeleteMailLayoutFieldMutationOptions = Apollo.BaseMutationOptions<DeleteMailLayoutFieldMutation, DeleteMailLayoutFieldMutationVariables>;
export const CreatedMailLayoutFieldDocument = gql`
    subscription CreatedMailLayoutField($filter: MailLayoutFieldFilterArgs, $withMailLayout: Boolean = false) {
  createdMailLayoutField(filter: $filter) {
    ...mailLayoutFieldFields
  }
}
    ${MailLayoutFieldFieldsFragmentDoc}`;

/**
 * __useCreatedMailLayoutFieldSubscription__
 *
 * To run a query within a React component, call `useCreatedMailLayoutFieldSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailLayoutFieldSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailLayoutFieldSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailLayout: // value for 'withMailLayout'
 *   },
 * });
 */
export function useCreatedMailLayoutFieldSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailLayoutFieldSubscription, CreatedMailLayoutFieldSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailLayoutFieldSubscription, CreatedMailLayoutFieldSubscriptionVariables>(CreatedMailLayoutFieldDocument, options);
      }
export type CreatedMailLayoutFieldSubscriptionHookResult = ReturnType<typeof useCreatedMailLayoutFieldSubscription>;
export type CreatedMailLayoutFieldSubscriptionResult = Apollo.SubscriptionResult<CreatedMailLayoutFieldSubscription>;
export const UpdatedMailLayoutFieldDocument = gql`
    subscription UpdatedMailLayoutField($filter: MailLayoutFieldFilterArgs, $withMailLayout: Boolean = false) {
  updatedMailLayoutField(filter: $filter) {
    ...mailLayoutFieldFields
  }
}
    ${MailLayoutFieldFieldsFragmentDoc}`;

/**
 * __useUpdatedMailLayoutFieldSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailLayoutFieldSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailLayoutFieldSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailLayoutFieldSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailLayout: // value for 'withMailLayout'
 *   },
 * });
 */
export function useUpdatedMailLayoutFieldSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailLayoutFieldSubscription, UpdatedMailLayoutFieldSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailLayoutFieldSubscription, UpdatedMailLayoutFieldSubscriptionVariables>(UpdatedMailLayoutFieldDocument, options);
      }
export type UpdatedMailLayoutFieldSubscriptionHookResult = ReturnType<typeof useUpdatedMailLayoutFieldSubscription>;
export type UpdatedMailLayoutFieldSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailLayoutFieldSubscription>;
export const DeletedMailLayoutFieldDocument = gql`
    subscription DeletedMailLayoutField($filter: MailLayoutFieldFilterArgs) {
  deletedMailLayoutField(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailLayoutFieldSubscription__
 *
 * To run a query within a React component, call `useDeletedMailLayoutFieldSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailLayoutFieldSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailLayoutFieldSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailLayoutFieldSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailLayoutFieldSubscription, DeletedMailLayoutFieldSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailLayoutFieldSubscription, DeletedMailLayoutFieldSubscriptionVariables>(DeletedMailLayoutFieldDocument, options);
      }
export type DeletedMailLayoutFieldSubscriptionHookResult = ReturnType<typeof useDeletedMailLayoutFieldSubscription>;
export type DeletedMailLayoutFieldSubscriptionResult = Apollo.SubscriptionResult<DeletedMailLayoutFieldSubscription>;
export const GetMailLogsDocument = gql`
    query GetMailLogs($filter: MailLogFilterArgs, $paging: PageArgs, $sorting: [MailLogSortArgs!]) {
  mailLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailLogFields
    }
    totalCount
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useGetMailLogsQuery__
 *
 * To run a query within a React component, call `useGetMailLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetMailLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
      }
export function useGetMailLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
        }
export function useGetMailLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
        }
export type GetMailLogsQueryHookResult = ReturnType<typeof useGetMailLogsQuery>;
export type GetMailLogsLazyQueryHookResult = ReturnType<typeof useGetMailLogsLazyQuery>;
export type GetMailLogsSuspenseQueryHookResult = ReturnType<typeof useGetMailLogsSuspenseQuery>;
export type GetMailLogsQueryResult = Apollo.QueryResult<GetMailLogsQuery, GetMailLogsQueryVariables>;
export const GetMailLogDocument = gql`
    query GetMailLog($id: ID!) {
  mailLog(id: $id) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useGetMailLogQuery__
 *
 * To run a query within a React component, call `useGetMailLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMailLogQuery(baseOptions: Apollo.QueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables> & ({ variables: GetMailLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
      }
export function useGetMailLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
        }
export function useGetMailLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
        }
export type GetMailLogQueryHookResult = ReturnType<typeof useGetMailLogQuery>;
export type GetMailLogLazyQueryHookResult = ReturnType<typeof useGetMailLogLazyQuery>;
export type GetMailLogSuspenseQueryHookResult = ReturnType<typeof useGetMailLogSuspenseQuery>;
export type GetMailLogQueryResult = Apollo.QueryResult<GetMailLogQuery, GetMailLogQueryVariables>;
export const CreateMailLogDocument = gql`
    mutation CreateMailLog($sentTo: String!, $sentBy: String!, $emailTemplate: String, $status: String, $message: String, $reason: String, $locale: String, $mailOptions: String) {
  createMailLog(
    sentTo: $sentTo
    sentBy: $sentBy
    emailTemplate: $emailTemplate
    status: $status
    message: $message
    reason: $reason
    locale: $locale
    mailOptions: $mailOptions
  ) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type CreateMailLogMutationFn = Apollo.MutationFunction<CreateMailLogMutation, CreateMailLogMutationVariables>;

/**
 * __useCreateMailLogMutation__
 *
 * To run a mutation, you first call `useCreateMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailLogMutation, { data, loading, error }] = useCreateMailLogMutation({
 *   variables: {
 *      sentTo: // value for 'sentTo'
 *      sentBy: // value for 'sentBy'
 *      emailTemplate: // value for 'emailTemplate'
 *      status: // value for 'status'
 *      message: // value for 'message'
 *      reason: // value for 'reason'
 *      locale: // value for 'locale'
 *      mailOptions: // value for 'mailOptions'
 *   },
 * });
 */
export function useCreateMailLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailLogMutation, CreateMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailLogMutation, CreateMailLogMutationVariables>(CreateMailLogDocument, options);
      }
export type CreateMailLogMutationHookResult = ReturnType<typeof useCreateMailLogMutation>;
export type CreateMailLogMutationResult = Apollo.MutationResult<CreateMailLogMutation>;
export type CreateMailLogMutationOptions = Apollo.BaseMutationOptions<CreateMailLogMutation, CreateMailLogMutationVariables>;
export const UpdateMailLogDocument = gql`
    mutation UpdateMailLog($id: ID!, $sentTo: String, $sentBy: String, $emailTemplate: String, $status: String, $message: String, $reason: String, $locale: String, $mailOptions: String) {
  updateMailLog(
    id: $id
    sentTo: $sentTo
    sentBy: $sentBy
    emailTemplate: $emailTemplate
    status: $status
    message: $message
    reason: $reason
    locale: $locale
    mailOptions: $mailOptions
  ) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type UpdateMailLogMutationFn = Apollo.MutationFunction<UpdateMailLogMutation, UpdateMailLogMutationVariables>;

/**
 * __useUpdateMailLogMutation__
 *
 * To run a mutation, you first call `useUpdateMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailLogMutation, { data, loading, error }] = useUpdateMailLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sentTo: // value for 'sentTo'
 *      sentBy: // value for 'sentBy'
 *      emailTemplate: // value for 'emailTemplate'
 *      status: // value for 'status'
 *      message: // value for 'message'
 *      reason: // value for 'reason'
 *      locale: // value for 'locale'
 *      mailOptions: // value for 'mailOptions'
 *   },
 * });
 */
export function useUpdateMailLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailLogMutation, UpdateMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailLogMutation, UpdateMailLogMutationVariables>(UpdateMailLogDocument, options);
      }
export type UpdateMailLogMutationHookResult = ReturnType<typeof useUpdateMailLogMutation>;
export type UpdateMailLogMutationResult = Apollo.MutationResult<UpdateMailLogMutation>;
export type UpdateMailLogMutationOptions = Apollo.BaseMutationOptions<UpdateMailLogMutation, UpdateMailLogMutationVariables>;
export const DeleteMailLogDocument = gql`
    mutation DeleteMailLog($id: ID!) {
  deleteMailLog(id: $id) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type DeleteMailLogMutationFn = Apollo.MutationFunction<DeleteMailLogMutation, DeleteMailLogMutationVariables>;

/**
 * __useDeleteMailLogMutation__
 *
 * To run a mutation, you first call `useDeleteMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailLogMutation, { data, loading, error }] = useDeleteMailLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMailLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailLogMutation, DeleteMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailLogMutation, DeleteMailLogMutationVariables>(DeleteMailLogDocument, options);
      }
export type DeleteMailLogMutationHookResult = ReturnType<typeof useDeleteMailLogMutation>;
export type DeleteMailLogMutationResult = Apollo.MutationResult<DeleteMailLogMutation>;
export type DeleteMailLogMutationOptions = Apollo.BaseMutationOptions<DeleteMailLogMutation, DeleteMailLogMutationVariables>;
export const CreatedMailLogDocument = gql`
    subscription CreatedMailLog($filter: MailLogFilterArgs) {
  createdMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useCreatedMailLogSubscription__
 *
 * To run a query within a React component, call `useCreatedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailLogSubscription, CreatedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailLogSubscription, CreatedMailLogSubscriptionVariables>(CreatedMailLogDocument, options);
      }
export type CreatedMailLogSubscriptionHookResult = ReturnType<typeof useCreatedMailLogSubscription>;
export type CreatedMailLogSubscriptionResult = Apollo.SubscriptionResult<CreatedMailLogSubscription>;
export const UpdatedMailLogDocument = gql`
    subscription UpdatedMailLog($filter: MailLogFilterArgs) {
  updatedMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useUpdatedMailLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailLogSubscription, UpdatedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailLogSubscription, UpdatedMailLogSubscriptionVariables>(UpdatedMailLogDocument, options);
      }
export type UpdatedMailLogSubscriptionHookResult = ReturnType<typeof useUpdatedMailLogSubscription>;
export type UpdatedMailLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailLogSubscription>;
export const DeletedMailLogDocument = gql`
    subscription DeletedMailLog($filter: MailLogFilterArgs) {
  deletedMailLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailLogSubscription__
 *
 * To run a query within a React component, call `useDeletedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailLogSubscription, DeletedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailLogSubscription, DeletedMailLogSubscriptionVariables>(DeletedMailLogDocument, options);
      }
export type DeletedMailLogSubscriptionHookResult = ReturnType<typeof useDeletedMailLogSubscription>;
export type DeletedMailLogSubscriptionResult = Apollo.SubscriptionResult<DeletedMailLogSubscription>;
export const RestoredMailLogDocument = gql`
    subscription RestoredMailLog($filter: MailLogFilterArgs) {
  restoredMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useRestoredMailLogSubscription__
 *
 * To run a query within a React component, call `useRestoredMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredMailLogSubscription, RestoredMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredMailLogSubscription, RestoredMailLogSubscriptionVariables>(RestoredMailLogDocument, options);
      }
export type RestoredMailLogSubscriptionHookResult = ReturnType<typeof useRestoredMailLogSubscription>;
export type RestoredMailLogSubscriptionResult = Apollo.SubscriptionResult<RestoredMailLogSubscription>;
export const GetMailTemplatesDocument = gql`
    query GetMailTemplates($filter: MailTemplateFilterArgs, $paging: PageArgs, $sorting: [MailTemplateSortArgs!], $withMailTemplateFills: Boolean = false, $withMailLayout: Boolean = false, $withMailTemplateFields: Boolean = false, $withTenant: Boolean = false) {
  mailTemplates(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailTemplateFields
    }
    totalCount
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useGetMailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withMailLayout: // value for 'withMailLayout'
 *      withMailTemplateFields: // value for 'withMailTemplateFields'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetMailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
      }
export function useGetMailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
        }
export function useGetMailTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
        }
export type GetMailTemplatesQueryHookResult = ReturnType<typeof useGetMailTemplatesQuery>;
export type GetMailTemplatesLazyQueryHookResult = ReturnType<typeof useGetMailTemplatesLazyQuery>;
export type GetMailTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplatesSuspenseQuery>;
export type GetMailTemplatesQueryResult = Apollo.QueryResult<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>;
export const GetMailTemplateDocument = gql`
    query GetMailTemplate($id: ID!, $withMailTemplateFills: Boolean = false, $withMailLayout: Boolean = false, $withMailTemplateFields: Boolean = false, $withTenant: Boolean = false) {
  mailTemplate(id: $id) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withMailLayout: // value for 'withMailLayout'
 *      withMailTemplateFields: // value for 'withMailTemplateFields'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetMailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables> & ({ variables: GetMailTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
      }
export function useGetMailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
        }
export function useGetMailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
        }
export type GetMailTemplateQueryHookResult = ReturnType<typeof useGetMailTemplateQuery>;
export type GetMailTemplateLazyQueryHookResult = ReturnType<typeof useGetMailTemplateLazyQuery>;
export type GetMailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateSuspenseQuery>;
export type GetMailTemplateQueryResult = Apollo.QueryResult<GetMailTemplateQuery, GetMailTemplateQueryVariables>;
export const GetAllRelatedDataForMailTemplateDocument = gql`
    query GetAllRelatedDataForMailTemplate($withMailTemplateFills: Boolean = false, $withMailLayouts: Boolean = false, $withMailTemplateFields: Boolean = false, $withTenants: Boolean = false) {
  mailTemplateFills @include(if: $withMailTemplateFills) {
    items {
      id
      displayField: id
    }
  }
  mailLayouts @include(if: $withMailLayouts) {
    items {
      id
      displayField: name
    }
  }
  mailTemplateFields @include(if: $withMailTemplateFields) {
    items {
      id
      displayField: name
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailTemplateQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailTemplateQuery({
 *   variables: {
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMailTemplateFields: // value for 'withMailTemplateFields'
 *      withTenants: // value for 'withTenants'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailTemplateQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
      }
export function useGetAllRelatedDataForMailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
        }
export function useGetAllRelatedDataForMailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
        }
export type GetAllRelatedDataForMailTemplateQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateQuery>;
export type GetAllRelatedDataForMailTemplateLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateLazyQuery>;
export type GetAllRelatedDataForMailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateSuspenseQuery>;
export type GetAllRelatedDataForMailTemplateQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>;
export const CreateMailTemplateDocument = gql`
    mutation CreateMailTemplate($machineName: String!, $name: String!, $description: String, $mailTemplateFills: [ID], $mailLayoutId: ID!, $mailTemplateFields: [ID], $tenantId: ID!, $withMailTemplateFills: Boolean = false, $withMailLayout: Boolean = false, $withMailTemplateFields: Boolean = false, $withTenant: Boolean = false) {
  createMailTemplate(
    machineName: $machineName
    name: $name
    description: $description
    mailTemplateFillIds: $mailTemplateFills
    mailLayoutId: $mailLayoutId
    mailTemplateFieldIds: $mailTemplateFields
    tenantId: $tenantId
  ) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type CreateMailTemplateMutationFn = Apollo.MutationFunction<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;

/**
 * __useCreateMailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailTemplateMutation, { data, loading, error }] = useCreateMailTemplateMutation({
 *   variables: {
 *      machineName: // value for 'machineName'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      mailTemplateFills: // value for 'mailTemplateFills'
 *      mailLayoutId: // value for 'mailLayoutId'
 *      mailTemplateFields: // value for 'mailTemplateFields'
 *      tenantId: // value for 'tenantId'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withMailLayout: // value for 'withMailLayout'
 *      withMailTemplateFields: // value for 'withMailTemplateFields'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreateMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>(CreateMailTemplateDocument, options);
      }
export type CreateMailTemplateMutationHookResult = ReturnType<typeof useCreateMailTemplateMutation>;
export type CreateMailTemplateMutationResult = Apollo.MutationResult<CreateMailTemplateMutation>;
export type CreateMailTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;
export const UpdateMailTemplateDocument = gql`
    mutation UpdateMailTemplate($id: ID!, $machineName: String, $name: String, $description: String, $mailTemplateFills: [ID], $mailLayoutId: ID, $mailTemplateFields: [ID], $tenantId: ID, $withMailTemplateFills: Boolean = false, $withMailLayout: Boolean = false, $withMailTemplateFields: Boolean = false, $withTenant: Boolean = false) {
  updateMailTemplate(
    id: $id
    machineName: $machineName
    name: $name
    description: $description
    mailTemplateFillIds: $mailTemplateFills
    mailLayoutId: $mailLayoutId
    mailTemplateFieldIds: $mailTemplateFields
    tenantId: $tenantId
  ) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type UpdateMailTemplateMutationFn = Apollo.MutationFunction<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;

/**
 * __useUpdateMailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailTemplateMutation, { data, loading, error }] = useUpdateMailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      machineName: // value for 'machineName'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      mailTemplateFills: // value for 'mailTemplateFills'
 *      mailLayoutId: // value for 'mailLayoutId'
 *      mailTemplateFields: // value for 'mailTemplateFields'
 *      tenantId: // value for 'tenantId'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withMailLayout: // value for 'withMailLayout'
 *      withMailTemplateFields: // value for 'withMailTemplateFields'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdateMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>(UpdateMailTemplateDocument, options);
      }
export type UpdateMailTemplateMutationHookResult = ReturnType<typeof useUpdateMailTemplateMutation>;
export type UpdateMailTemplateMutationResult = Apollo.MutationResult<UpdateMailTemplateMutation>;
export type UpdateMailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;
export const DeleteMailTemplateDocument = gql`
    mutation DeleteMailTemplate($id: ID!, $withMailTemplateFills: Boolean = false, $withMailLayout: Boolean = false, $withMailTemplateFields: Boolean = false, $withTenant: Boolean = false) {
  deleteMailTemplate(id: $id) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type DeleteMailTemplateMutationFn = Apollo.MutationFunction<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>;

/**
 * __useDeleteMailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailTemplateMutation, { data, loading, error }] = useDeleteMailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withMailLayout: // value for 'withMailLayout'
 *      withMailTemplateFields: // value for 'withMailTemplateFields'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useDeleteMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>(DeleteMailTemplateDocument, options);
      }
export type DeleteMailTemplateMutationHookResult = ReturnType<typeof useDeleteMailTemplateMutation>;
export type DeleteMailTemplateMutationResult = Apollo.MutationResult<DeleteMailTemplateMutation>;
export type DeleteMailTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>;
export const CreatedMailTemplateDocument = gql`
    subscription CreatedMailTemplate($filter: MailTemplateFilterArgs, $withMailTemplateFills: Boolean = false, $withMailLayout: Boolean = false, $withMailTemplateFields: Boolean = false, $withTenant: Boolean = false) {
  createdMailTemplate(filter: $filter) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useCreatedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useCreatedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withMailLayout: // value for 'withMailLayout'
 *      withMailTemplateFields: // value for 'withMailTemplateFields'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreatedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailTemplateSubscription, CreatedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailTemplateSubscription, CreatedMailTemplateSubscriptionVariables>(CreatedMailTemplateDocument, options);
      }
export type CreatedMailTemplateSubscriptionHookResult = ReturnType<typeof useCreatedMailTemplateSubscription>;
export type CreatedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<CreatedMailTemplateSubscription>;
export const UpdatedMailTemplateDocument = gql`
    subscription UpdatedMailTemplate($filter: MailTemplateFilterArgs, $withMailTemplateFills: Boolean = false, $withMailLayout: Boolean = false, $withMailTemplateFields: Boolean = false, $withTenant: Boolean = false) {
  updatedMailTemplate(filter: $filter) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useUpdatedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withMailLayout: // value for 'withMailLayout'
 *      withMailTemplateFields: // value for 'withMailTemplateFields'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdatedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailTemplateSubscription, UpdatedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailTemplateSubscription, UpdatedMailTemplateSubscriptionVariables>(UpdatedMailTemplateDocument, options);
      }
export type UpdatedMailTemplateSubscriptionHookResult = ReturnType<typeof useUpdatedMailTemplateSubscription>;
export type UpdatedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailTemplateSubscription>;
export const DeletedMailTemplateDocument = gql`
    subscription DeletedMailTemplate($filter: MailTemplateFilterArgs) {
  deletedMailTemplate(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useDeletedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailTemplateSubscription, DeletedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailTemplateSubscription, DeletedMailTemplateSubscriptionVariables>(DeletedMailTemplateDocument, options);
      }
export type DeletedMailTemplateSubscriptionHookResult = ReturnType<typeof useDeletedMailTemplateSubscription>;
export type DeletedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<DeletedMailTemplateSubscription>;
export const GetMailTemplateFieldsDocument = gql`
    query GetMailTemplateFields($filter: MailTemplateFieldFilterArgs, $paging: PageArgs, $sorting: [MailTemplateFieldSortArgs!], $withMailTemplate: Boolean = false) {
  mailTemplateFields(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailTemplateFieldFields
    }
    totalCount
  }
}
    ${MailTemplateFieldFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateFieldsQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateFieldsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetMailTemplateFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailTemplateFieldsQuery, GetMailTemplateFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateFieldsQuery, GetMailTemplateFieldsQueryVariables>(GetMailTemplateFieldsDocument, options);
      }
export function useGetMailTemplateFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateFieldsQuery, GetMailTemplateFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateFieldsQuery, GetMailTemplateFieldsQueryVariables>(GetMailTemplateFieldsDocument, options);
        }
export function useGetMailTemplateFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateFieldsQuery, GetMailTemplateFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateFieldsQuery, GetMailTemplateFieldsQueryVariables>(GetMailTemplateFieldsDocument, options);
        }
export type GetMailTemplateFieldsQueryHookResult = ReturnType<typeof useGetMailTemplateFieldsQuery>;
export type GetMailTemplateFieldsLazyQueryHookResult = ReturnType<typeof useGetMailTemplateFieldsLazyQuery>;
export type GetMailTemplateFieldsSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateFieldsSuspenseQuery>;
export type GetMailTemplateFieldsQueryResult = Apollo.QueryResult<GetMailTemplateFieldsQuery, GetMailTemplateFieldsQueryVariables>;
export const GetMailTemplateFieldDocument = gql`
    query GetMailTemplateField($id: ID!, $withMailTemplate: Boolean = false) {
  mailTemplateField(id: $id) {
    ...mailTemplateFieldFields
  }
}
    ${MailTemplateFieldFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateFieldQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetMailTemplateFieldQuery(baseOptions: Apollo.QueryHookOptions<GetMailTemplateFieldQuery, GetMailTemplateFieldQueryVariables> & ({ variables: GetMailTemplateFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateFieldQuery, GetMailTemplateFieldQueryVariables>(GetMailTemplateFieldDocument, options);
      }
export function useGetMailTemplateFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateFieldQuery, GetMailTemplateFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateFieldQuery, GetMailTemplateFieldQueryVariables>(GetMailTemplateFieldDocument, options);
        }
export function useGetMailTemplateFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateFieldQuery, GetMailTemplateFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateFieldQuery, GetMailTemplateFieldQueryVariables>(GetMailTemplateFieldDocument, options);
        }
export type GetMailTemplateFieldQueryHookResult = ReturnType<typeof useGetMailTemplateFieldQuery>;
export type GetMailTemplateFieldLazyQueryHookResult = ReturnType<typeof useGetMailTemplateFieldLazyQuery>;
export type GetMailTemplateFieldSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateFieldSuspenseQuery>;
export type GetMailTemplateFieldQueryResult = Apollo.QueryResult<GetMailTemplateFieldQuery, GetMailTemplateFieldQueryVariables>;
export const GetAllRelatedDataForMailTemplateFieldDocument = gql`
    query GetAllRelatedDataForMailTemplateField($withMailTemplates: Boolean = false) {
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      displayField: machineName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailTemplateFieldQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailTemplateFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailTemplateFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailTemplateFieldQuery({
 *   variables: {
 *      withMailTemplates: // value for 'withMailTemplates'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailTemplateFieldQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailTemplateFieldQuery, GetAllRelatedDataForMailTemplateFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailTemplateFieldQuery, GetAllRelatedDataForMailTemplateFieldQueryVariables>(GetAllRelatedDataForMailTemplateFieldDocument, options);
      }
export function useGetAllRelatedDataForMailTemplateFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailTemplateFieldQuery, GetAllRelatedDataForMailTemplateFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailTemplateFieldQuery, GetAllRelatedDataForMailTemplateFieldQueryVariables>(GetAllRelatedDataForMailTemplateFieldDocument, options);
        }
export function useGetAllRelatedDataForMailTemplateFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailTemplateFieldQuery, GetAllRelatedDataForMailTemplateFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailTemplateFieldQuery, GetAllRelatedDataForMailTemplateFieldQueryVariables>(GetAllRelatedDataForMailTemplateFieldDocument, options);
        }
export type GetAllRelatedDataForMailTemplateFieldQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFieldQuery>;
export type GetAllRelatedDataForMailTemplateFieldLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFieldLazyQuery>;
export type GetAllRelatedDataForMailTemplateFieldSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFieldSuspenseQuery>;
export type GetAllRelatedDataForMailTemplateFieldQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailTemplateFieldQuery, GetAllRelatedDataForMailTemplateFieldQueryVariables>;
export const CreateMailTemplateFieldDocument = gql`
    mutation CreateMailTemplateField($name: String!, $machineName: String!, $description: String, $required: Boolean!, $mailTemplateId: ID!, $withMailTemplate: Boolean = false) {
  createMailTemplateField(
    name: $name
    machineName: $machineName
    description: $description
    required: $required
    mailTemplateId: $mailTemplateId
  ) {
    ...mailTemplateFieldFields
  }
}
    ${MailTemplateFieldFieldsFragmentDoc}`;
export type CreateMailTemplateFieldMutationFn = Apollo.MutationFunction<CreateMailTemplateFieldMutation, CreateMailTemplateFieldMutationVariables>;

/**
 * __useCreateMailTemplateFieldMutation__
 *
 * To run a mutation, you first call `useCreateMailTemplateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailTemplateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailTemplateFieldMutation, { data, loading, error }] = useCreateMailTemplateFieldMutation({
 *   variables: {
 *      name: // value for 'name'
 *      machineName: // value for 'machineName'
 *      description: // value for 'description'
 *      required: // value for 'required'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreateMailTemplateFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailTemplateFieldMutation, CreateMailTemplateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailTemplateFieldMutation, CreateMailTemplateFieldMutationVariables>(CreateMailTemplateFieldDocument, options);
      }
export type CreateMailTemplateFieldMutationHookResult = ReturnType<typeof useCreateMailTemplateFieldMutation>;
export type CreateMailTemplateFieldMutationResult = Apollo.MutationResult<CreateMailTemplateFieldMutation>;
export type CreateMailTemplateFieldMutationOptions = Apollo.BaseMutationOptions<CreateMailTemplateFieldMutation, CreateMailTemplateFieldMutationVariables>;
export const UpdateMailTemplateFieldDocument = gql`
    mutation UpdateMailTemplateField($id: ID!, $name: String, $machineName: String, $description: String, $required: Boolean, $mailTemplateId: ID, $withMailTemplate: Boolean = false) {
  updateMailTemplateField(
    id: $id
    name: $name
    machineName: $machineName
    description: $description
    required: $required
    mailTemplateId: $mailTemplateId
  ) {
    ...mailTemplateFieldFields
  }
}
    ${MailTemplateFieldFieldsFragmentDoc}`;
export type UpdateMailTemplateFieldMutationFn = Apollo.MutationFunction<UpdateMailTemplateFieldMutation, UpdateMailTemplateFieldMutationVariables>;

/**
 * __useUpdateMailTemplateFieldMutation__
 *
 * To run a mutation, you first call `useUpdateMailTemplateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailTemplateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailTemplateFieldMutation, { data, loading, error }] = useUpdateMailTemplateFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      machineName: // value for 'machineName'
 *      description: // value for 'description'
 *      required: // value for 'required'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdateMailTemplateFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailTemplateFieldMutation, UpdateMailTemplateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailTemplateFieldMutation, UpdateMailTemplateFieldMutationVariables>(UpdateMailTemplateFieldDocument, options);
      }
export type UpdateMailTemplateFieldMutationHookResult = ReturnType<typeof useUpdateMailTemplateFieldMutation>;
export type UpdateMailTemplateFieldMutationResult = Apollo.MutationResult<UpdateMailTemplateFieldMutation>;
export type UpdateMailTemplateFieldMutationOptions = Apollo.BaseMutationOptions<UpdateMailTemplateFieldMutation, UpdateMailTemplateFieldMutationVariables>;
export const DeleteMailTemplateFieldDocument = gql`
    mutation DeleteMailTemplateField($id: ID!, $withMailTemplate: Boolean = false) {
  deleteMailTemplateField(id: $id) {
    ...mailTemplateFieldFields
  }
}
    ${MailTemplateFieldFieldsFragmentDoc}`;
export type DeleteMailTemplateFieldMutationFn = Apollo.MutationFunction<DeleteMailTemplateFieldMutation, DeleteMailTemplateFieldMutationVariables>;

/**
 * __useDeleteMailTemplateFieldMutation__
 *
 * To run a mutation, you first call `useDeleteMailTemplateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailTemplateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailTemplateFieldMutation, { data, loading, error }] = useDeleteMailTemplateFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useDeleteMailTemplateFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailTemplateFieldMutation, DeleteMailTemplateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailTemplateFieldMutation, DeleteMailTemplateFieldMutationVariables>(DeleteMailTemplateFieldDocument, options);
      }
export type DeleteMailTemplateFieldMutationHookResult = ReturnType<typeof useDeleteMailTemplateFieldMutation>;
export type DeleteMailTemplateFieldMutationResult = Apollo.MutationResult<DeleteMailTemplateFieldMutation>;
export type DeleteMailTemplateFieldMutationOptions = Apollo.BaseMutationOptions<DeleteMailTemplateFieldMutation, DeleteMailTemplateFieldMutationVariables>;
export const CreatedMailTemplateFieldDocument = gql`
    subscription CreatedMailTemplateField($filter: MailTemplateFieldFilterArgs, $withMailTemplate: Boolean = false) {
  createdMailTemplateField(filter: $filter) {
    ...mailTemplateFieldFields
  }
}
    ${MailTemplateFieldFieldsFragmentDoc}`;

/**
 * __useCreatedMailTemplateFieldSubscription__
 *
 * To run a query within a React component, call `useCreatedMailTemplateFieldSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailTemplateFieldSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailTemplateFieldSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreatedMailTemplateFieldSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailTemplateFieldSubscription, CreatedMailTemplateFieldSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailTemplateFieldSubscription, CreatedMailTemplateFieldSubscriptionVariables>(CreatedMailTemplateFieldDocument, options);
      }
export type CreatedMailTemplateFieldSubscriptionHookResult = ReturnType<typeof useCreatedMailTemplateFieldSubscription>;
export type CreatedMailTemplateFieldSubscriptionResult = Apollo.SubscriptionResult<CreatedMailTemplateFieldSubscription>;
export const UpdatedMailTemplateFieldDocument = gql`
    subscription UpdatedMailTemplateField($filter: MailTemplateFieldFilterArgs, $withMailTemplate: Boolean = false) {
  updatedMailTemplateField(filter: $filter) {
    ...mailTemplateFieldFields
  }
}
    ${MailTemplateFieldFieldsFragmentDoc}`;

/**
 * __useUpdatedMailTemplateFieldSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailTemplateFieldSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailTemplateFieldSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailTemplateFieldSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdatedMailTemplateFieldSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailTemplateFieldSubscription, UpdatedMailTemplateFieldSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailTemplateFieldSubscription, UpdatedMailTemplateFieldSubscriptionVariables>(UpdatedMailTemplateFieldDocument, options);
      }
export type UpdatedMailTemplateFieldSubscriptionHookResult = ReturnType<typeof useUpdatedMailTemplateFieldSubscription>;
export type UpdatedMailTemplateFieldSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailTemplateFieldSubscription>;
export const DeletedMailTemplateFieldDocument = gql`
    subscription DeletedMailTemplateField($filter: MailTemplateFieldFilterArgs) {
  deletedMailTemplateField(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailTemplateFieldSubscription__
 *
 * To run a query within a React component, call `useDeletedMailTemplateFieldSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailTemplateFieldSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailTemplateFieldSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailTemplateFieldSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailTemplateFieldSubscription, DeletedMailTemplateFieldSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailTemplateFieldSubscription, DeletedMailTemplateFieldSubscriptionVariables>(DeletedMailTemplateFieldDocument, options);
      }
export type DeletedMailTemplateFieldSubscriptionHookResult = ReturnType<typeof useDeletedMailTemplateFieldSubscription>;
export type DeletedMailTemplateFieldSubscriptionResult = Apollo.SubscriptionResult<DeletedMailTemplateFieldSubscription>;
export const GetMailTemplateFillsDocument = gql`
    query GetMailTemplateFills($filter: MailTemplateFillFilterArgs, $paging: PageArgs, $sorting: [MailTemplateFillSortArgs!], $withMailTemplate: Boolean = false) {
  mailTemplateFills(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailTemplateFillFields
    }
    totalCount
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateFillsQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateFillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateFillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateFillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetMailTemplateFillsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
      }
export function useGetMailTemplateFillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
        }
export function useGetMailTemplateFillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
        }
export type GetMailTemplateFillsQueryHookResult = ReturnType<typeof useGetMailTemplateFillsQuery>;
export type GetMailTemplateFillsLazyQueryHookResult = ReturnType<typeof useGetMailTemplateFillsLazyQuery>;
export type GetMailTemplateFillsSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateFillsSuspenseQuery>;
export type GetMailTemplateFillsQueryResult = Apollo.QueryResult<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>;
export const GetMailTemplateFillDocument = gql`
    query GetMailTemplateFill($id: ID!, $withMailTemplate: Boolean = false) {
  mailTemplateFill(id: $id) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateFillQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateFillQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetMailTemplateFillQuery(baseOptions: Apollo.QueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables> & ({ variables: GetMailTemplateFillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
      }
export function useGetMailTemplateFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
        }
export function useGetMailTemplateFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
        }
export type GetMailTemplateFillQueryHookResult = ReturnType<typeof useGetMailTemplateFillQuery>;
export type GetMailTemplateFillLazyQueryHookResult = ReturnType<typeof useGetMailTemplateFillLazyQuery>;
export type GetMailTemplateFillSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateFillSuspenseQuery>;
export type GetMailTemplateFillQueryResult = Apollo.QueryResult<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>;
export const GetAllRelatedDataForMailTemplateFillDocument = gql`
    query GetAllRelatedDataForMailTemplateFill($withMailTemplates: Boolean = false) {
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      displayField: machineName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailTemplateFillQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailTemplateFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailTemplateFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailTemplateFillQuery({
 *   variables: {
 *      withMailTemplates: // value for 'withMailTemplates'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailTemplateFillQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
      }
export function useGetAllRelatedDataForMailTemplateFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
        }
export function useGetAllRelatedDataForMailTemplateFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
        }
export type GetAllRelatedDataForMailTemplateFillQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillQuery>;
export type GetAllRelatedDataForMailTemplateFillLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillLazyQuery>;
export type GetAllRelatedDataForMailTemplateFillSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillSuspenseQuery>;
export type GetAllRelatedDataForMailTemplateFillQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>;
export const CreateMailTemplateFillDocument = gql`
    mutation CreateMailTemplateFill($subject: String!, $fields: String!, $locale: String!, $mailTemplateId: ID!, $withMailTemplate: Boolean = false) {
  createMailTemplateFill(
    subject: $subject
    fields: $fields
    locale: $locale
    mailTemplateId: $mailTemplateId
  ) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type CreateMailTemplateFillMutationFn = Apollo.MutationFunction<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>;

/**
 * __useCreateMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useCreateMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailTemplateFillMutation, { data, loading, error }] = useCreateMailTemplateFillMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      fields: // value for 'fields'
 *      locale: // value for 'locale'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreateMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>(CreateMailTemplateFillDocument, options);
      }
export type CreateMailTemplateFillMutationHookResult = ReturnType<typeof useCreateMailTemplateFillMutation>;
export type CreateMailTemplateFillMutationResult = Apollo.MutationResult<CreateMailTemplateFillMutation>;
export type CreateMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>;
export const UpdateMailTemplateFillDocument = gql`
    mutation UpdateMailTemplateFill($id: ID!, $subject: String, $fields: String, $locale: String, $mailTemplateId: ID, $withMailTemplate: Boolean = false) {
  updateMailTemplateFill(
    id: $id
    subject: $subject
    fields: $fields
    locale: $locale
    mailTemplateId: $mailTemplateId
  ) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type UpdateMailTemplateFillMutationFn = Apollo.MutationFunction<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>;

/**
 * __useUpdateMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useUpdateMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailTemplateFillMutation, { data, loading, error }] = useUpdateMailTemplateFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      subject: // value for 'subject'
 *      fields: // value for 'fields'
 *      locale: // value for 'locale'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdateMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>(UpdateMailTemplateFillDocument, options);
      }
export type UpdateMailTemplateFillMutationHookResult = ReturnType<typeof useUpdateMailTemplateFillMutation>;
export type UpdateMailTemplateFillMutationResult = Apollo.MutationResult<UpdateMailTemplateFillMutation>;
export type UpdateMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>;
export const DeleteMailTemplateFillDocument = gql`
    mutation DeleteMailTemplateFill($id: ID!, $withMailTemplate: Boolean = false) {
  deleteMailTemplateFill(id: $id) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type DeleteMailTemplateFillMutationFn = Apollo.MutationFunction<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>;

/**
 * __useDeleteMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useDeleteMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailTemplateFillMutation, { data, loading, error }] = useDeleteMailTemplateFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useDeleteMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>(DeleteMailTemplateFillDocument, options);
      }
export type DeleteMailTemplateFillMutationHookResult = ReturnType<typeof useDeleteMailTemplateFillMutation>;
export type DeleteMailTemplateFillMutationResult = Apollo.MutationResult<DeleteMailTemplateFillMutation>;
export type DeleteMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>;
export const CreatedMailTemplateFillDocument = gql`
    subscription CreatedMailTemplateFill($filter: MailTemplateFillFilterArgs, $withMailTemplate: Boolean = false) {
  createdMailTemplateFill(filter: $filter) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useCreatedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useCreatedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreatedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailTemplateFillSubscription, CreatedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailTemplateFillSubscription, CreatedMailTemplateFillSubscriptionVariables>(CreatedMailTemplateFillDocument, options);
      }
export type CreatedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useCreatedMailTemplateFillSubscription>;
export type CreatedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<CreatedMailTemplateFillSubscription>;
export const UpdatedMailTemplateFillDocument = gql`
    subscription UpdatedMailTemplateFill($filter: MailTemplateFillFilterArgs, $withMailTemplate: Boolean = false) {
  updatedMailTemplateFill(filter: $filter) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useUpdatedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdatedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailTemplateFillSubscription, UpdatedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailTemplateFillSubscription, UpdatedMailTemplateFillSubscriptionVariables>(UpdatedMailTemplateFillDocument, options);
      }
export type UpdatedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useUpdatedMailTemplateFillSubscription>;
export type UpdatedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailTemplateFillSubscription>;
export const DeletedMailTemplateFillDocument = gql`
    subscription DeletedMailTemplateFill($filter: MailTemplateFillFilterArgs) {
  deletedMailTemplateFill(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useDeletedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailTemplateFillSubscription, DeletedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailTemplateFillSubscription, DeletedMailTemplateFillSubscriptionVariables>(DeletedMailTemplateFillDocument, options);
      }
export type DeletedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useDeletedMailTemplateFillSubscription>;
export type DeletedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<DeletedMailTemplateFillSubscription>;
export const GetMissingContentsDocument = gql`
    query GetMissingContents($filter: MissingContentFilterArgs, $paging: PageArgs, $sorting: [MissingContentSortArgs!], $withTenant: Boolean = false) {
  missingContents(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...missingContentFields
    }
    totalCount
  }
}
    ${MissingContentFieldsFragmentDoc}`;

/**
 * __useGetMissingContentsQuery__
 *
 * To run a query within a React component, call `useGetMissingContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingContentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetMissingContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetMissingContentsQuery, GetMissingContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMissingContentsQuery, GetMissingContentsQueryVariables>(GetMissingContentsDocument, options);
      }
export function useGetMissingContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMissingContentsQuery, GetMissingContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMissingContentsQuery, GetMissingContentsQueryVariables>(GetMissingContentsDocument, options);
        }
export function useGetMissingContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMissingContentsQuery, GetMissingContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMissingContentsQuery, GetMissingContentsQueryVariables>(GetMissingContentsDocument, options);
        }
export type GetMissingContentsQueryHookResult = ReturnType<typeof useGetMissingContentsQuery>;
export type GetMissingContentsLazyQueryHookResult = ReturnType<typeof useGetMissingContentsLazyQuery>;
export type GetMissingContentsSuspenseQueryHookResult = ReturnType<typeof useGetMissingContentsSuspenseQuery>;
export type GetMissingContentsQueryResult = Apollo.QueryResult<GetMissingContentsQuery, GetMissingContentsQueryVariables>;
export const GetMissingContentDocument = gql`
    query GetMissingContent($id: ID!, $withTenant: Boolean = false) {
  missingContent(id: $id) {
    ...missingContentFields
  }
}
    ${MissingContentFieldsFragmentDoc}`;

/**
 * __useGetMissingContentQuery__
 *
 * To run a query within a React component, call `useGetMissingContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetMissingContentQuery(baseOptions: Apollo.QueryHookOptions<GetMissingContentQuery, GetMissingContentQueryVariables> & ({ variables: GetMissingContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMissingContentQuery, GetMissingContentQueryVariables>(GetMissingContentDocument, options);
      }
export function useGetMissingContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMissingContentQuery, GetMissingContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMissingContentQuery, GetMissingContentQueryVariables>(GetMissingContentDocument, options);
        }
export function useGetMissingContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMissingContentQuery, GetMissingContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMissingContentQuery, GetMissingContentQueryVariables>(GetMissingContentDocument, options);
        }
export type GetMissingContentQueryHookResult = ReturnType<typeof useGetMissingContentQuery>;
export type GetMissingContentLazyQueryHookResult = ReturnType<typeof useGetMissingContentLazyQuery>;
export type GetMissingContentSuspenseQueryHookResult = ReturnType<typeof useGetMissingContentSuspenseQuery>;
export type GetMissingContentQueryResult = Apollo.QueryResult<GetMissingContentQuery, GetMissingContentQueryVariables>;
export const GetAllRelatedDataForMissingContentDocument = gql`
    query GetAllRelatedDataForMissingContent($withTenants: Boolean = false) {
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMissingContentQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMissingContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMissingContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMissingContentQuery({
 *   variables: {
 *      withTenants: // value for 'withTenants'
 *   },
 * });
 */
export function useGetAllRelatedDataForMissingContentQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMissingContentQuery, GetAllRelatedDataForMissingContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMissingContentQuery, GetAllRelatedDataForMissingContentQueryVariables>(GetAllRelatedDataForMissingContentDocument, options);
      }
export function useGetAllRelatedDataForMissingContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMissingContentQuery, GetAllRelatedDataForMissingContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMissingContentQuery, GetAllRelatedDataForMissingContentQueryVariables>(GetAllRelatedDataForMissingContentDocument, options);
        }
export function useGetAllRelatedDataForMissingContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMissingContentQuery, GetAllRelatedDataForMissingContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMissingContentQuery, GetAllRelatedDataForMissingContentQueryVariables>(GetAllRelatedDataForMissingContentDocument, options);
        }
export type GetAllRelatedDataForMissingContentQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMissingContentQuery>;
export type GetAllRelatedDataForMissingContentLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMissingContentLazyQuery>;
export type GetAllRelatedDataForMissingContentSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMissingContentSuspenseQuery>;
export type GetAllRelatedDataForMissingContentQueryResult = Apollo.QueryResult<GetAllRelatedDataForMissingContentQuery, GetAllRelatedDataForMissingContentQueryVariables>;
export const CreateMissingContentDocument = gql`
    mutation CreateMissingContent($machineName: String!, $locale: String, $tenantId: ID!, $withTenant: Boolean = false) {
  createMissingContent(
    machineName: $machineName
    locale: $locale
    tenantId: $tenantId
  ) {
    ...missingContentFields
  }
}
    ${MissingContentFieldsFragmentDoc}`;
export type CreateMissingContentMutationFn = Apollo.MutationFunction<CreateMissingContentMutation, CreateMissingContentMutationVariables>;

/**
 * __useCreateMissingContentMutation__
 *
 * To run a mutation, you first call `useCreateMissingContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMissingContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMissingContentMutation, { data, loading, error }] = useCreateMissingContentMutation({
 *   variables: {
 *      machineName: // value for 'machineName'
 *      locale: // value for 'locale'
 *      tenantId: // value for 'tenantId'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreateMissingContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMissingContentMutation, CreateMissingContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMissingContentMutation, CreateMissingContentMutationVariables>(CreateMissingContentDocument, options);
      }
export type CreateMissingContentMutationHookResult = ReturnType<typeof useCreateMissingContentMutation>;
export type CreateMissingContentMutationResult = Apollo.MutationResult<CreateMissingContentMutation>;
export type CreateMissingContentMutationOptions = Apollo.BaseMutationOptions<CreateMissingContentMutation, CreateMissingContentMutationVariables>;
export const UpdateMissingContentDocument = gql`
    mutation UpdateMissingContent($id: ID!, $machineName: String, $locale: String, $tenantId: ID, $withTenant: Boolean = false) {
  updateMissingContent(
    id: $id
    machineName: $machineName
    locale: $locale
    tenantId: $tenantId
  ) {
    ...missingContentFields
  }
}
    ${MissingContentFieldsFragmentDoc}`;
export type UpdateMissingContentMutationFn = Apollo.MutationFunction<UpdateMissingContentMutation, UpdateMissingContentMutationVariables>;

/**
 * __useUpdateMissingContentMutation__
 *
 * To run a mutation, you first call `useUpdateMissingContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMissingContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMissingContentMutation, { data, loading, error }] = useUpdateMissingContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      machineName: // value for 'machineName'
 *      locale: // value for 'locale'
 *      tenantId: // value for 'tenantId'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdateMissingContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMissingContentMutation, UpdateMissingContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMissingContentMutation, UpdateMissingContentMutationVariables>(UpdateMissingContentDocument, options);
      }
export type UpdateMissingContentMutationHookResult = ReturnType<typeof useUpdateMissingContentMutation>;
export type UpdateMissingContentMutationResult = Apollo.MutationResult<UpdateMissingContentMutation>;
export type UpdateMissingContentMutationOptions = Apollo.BaseMutationOptions<UpdateMissingContentMutation, UpdateMissingContentMutationVariables>;
export const DeleteMissingContentDocument = gql`
    mutation DeleteMissingContent($id: ID!, $withTenant: Boolean = false) {
  deleteMissingContent(id: $id) {
    ...missingContentFields
  }
}
    ${MissingContentFieldsFragmentDoc}`;
export type DeleteMissingContentMutationFn = Apollo.MutationFunction<DeleteMissingContentMutation, DeleteMissingContentMutationVariables>;

/**
 * __useDeleteMissingContentMutation__
 *
 * To run a mutation, you first call `useDeleteMissingContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMissingContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMissingContentMutation, { data, loading, error }] = useDeleteMissingContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useDeleteMissingContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMissingContentMutation, DeleteMissingContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMissingContentMutation, DeleteMissingContentMutationVariables>(DeleteMissingContentDocument, options);
      }
export type DeleteMissingContentMutationHookResult = ReturnType<typeof useDeleteMissingContentMutation>;
export type DeleteMissingContentMutationResult = Apollo.MutationResult<DeleteMissingContentMutation>;
export type DeleteMissingContentMutationOptions = Apollo.BaseMutationOptions<DeleteMissingContentMutation, DeleteMissingContentMutationVariables>;
export const CreatedMissingContentDocument = gql`
    subscription CreatedMissingContent($filter: MissingContentFilterArgs, $withTenant: Boolean = false) {
  createdMissingContent(filter: $filter) {
    ...missingContentFields
  }
}
    ${MissingContentFieldsFragmentDoc}`;

/**
 * __useCreatedMissingContentSubscription__
 *
 * To run a query within a React component, call `useCreatedMissingContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMissingContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMissingContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreatedMissingContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMissingContentSubscription, CreatedMissingContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMissingContentSubscription, CreatedMissingContentSubscriptionVariables>(CreatedMissingContentDocument, options);
      }
export type CreatedMissingContentSubscriptionHookResult = ReturnType<typeof useCreatedMissingContentSubscription>;
export type CreatedMissingContentSubscriptionResult = Apollo.SubscriptionResult<CreatedMissingContentSubscription>;
export const UpdatedMissingContentDocument = gql`
    subscription UpdatedMissingContent($filter: MissingContentFilterArgs, $withTenant: Boolean = false) {
  updatedMissingContent(filter: $filter) {
    ...missingContentFields
  }
}
    ${MissingContentFieldsFragmentDoc}`;

/**
 * __useUpdatedMissingContentSubscription__
 *
 * To run a query within a React component, call `useUpdatedMissingContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMissingContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMissingContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdatedMissingContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMissingContentSubscription, UpdatedMissingContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMissingContentSubscription, UpdatedMissingContentSubscriptionVariables>(UpdatedMissingContentDocument, options);
      }
export type UpdatedMissingContentSubscriptionHookResult = ReturnType<typeof useUpdatedMissingContentSubscription>;
export type UpdatedMissingContentSubscriptionResult = Apollo.SubscriptionResult<UpdatedMissingContentSubscription>;
export const DeletedMissingContentDocument = gql`
    subscription DeletedMissingContent($filter: MissingContentFilterArgs) {
  deletedMissingContent(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMissingContentSubscription__
 *
 * To run a query within a React component, call `useDeletedMissingContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMissingContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMissingContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMissingContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMissingContentSubscription, DeletedMissingContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMissingContentSubscription, DeletedMissingContentSubscriptionVariables>(DeletedMissingContentDocument, options);
      }
export type DeletedMissingContentSubscriptionHookResult = ReturnType<typeof useDeletedMissingContentSubscription>;
export type DeletedMissingContentSubscriptionResult = Apollo.SubscriptionResult<DeletedMissingContentSubscription>;
export const GetPermissionsDocument = gql`
    query GetPermissions($filter: PermissionFilterArgs, $paging: PageArgs, $sorting: [PermissionSortArgs!], $withRoles: Boolean = false) {
  permissions(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...permissionFields
    }
    totalCount
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionsSuspenseQuery>;
export type GetPermissionsQueryResult = Apollo.QueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const GetPermissionDocument = gql`
    query GetPermission($id: ID!, $withRoles: Boolean = false) {
  permission(id: $id) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useGetPermissionQuery__
 *
 * To run a query within a React component, call `useGetPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetPermissionQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables> & ({ variables: GetPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
      }
export function useGetPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export function useGetPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export type GetPermissionQueryHookResult = ReturnType<typeof useGetPermissionQuery>;
export type GetPermissionLazyQueryHookResult = ReturnType<typeof useGetPermissionLazyQuery>;
export type GetPermissionSuspenseQueryHookResult = ReturnType<typeof useGetPermissionSuspenseQuery>;
export type GetPermissionQueryResult = Apollo.QueryResult<GetPermissionQuery, GetPermissionQueryVariables>;
export const GetAllRelatedDataForPermissionDocument = gql`
    query GetAllRelatedDataForPermission($withRoles: Boolean = false) {
  roles @include(if: $withRoles) {
    items {
      id
      displayField: displayName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForPermissionQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForPermissionQuery({
 *   variables: {
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
      }
export function useGetAllRelatedDataForPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
        }
export function useGetAllRelatedDataForPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
        }
export type GetAllRelatedDataForPermissionQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionQuery>;
export type GetAllRelatedDataForPermissionLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionLazyQuery>;
export type GetAllRelatedDataForPermissionSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionSuspenseQuery>;
export type GetAllRelatedDataForPermissionQueryResult = Apollo.QueryResult<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>;
export const CreatePermissionDocument = gql`
    mutation CreatePermission($name: String!, $description: String!, $roles: [ID], $withRoles: Boolean = false) {
  createPermission(name: $name, description: $description, roleIds: $roles) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type CreatePermissionMutationFn = Apollo.MutationFunction<CreatePermissionMutation, CreatePermissionMutationVariables>;

/**
 * __useCreatePermissionMutation__
 *
 * To run a mutation, you first call `useCreatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionMutation, { data, loading, error }] = useCreatePermissionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      roles: // value for 'roles'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useCreatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionMutation, CreatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionMutation, CreatePermissionMutationVariables>(CreatePermissionDocument, options);
      }
export type CreatePermissionMutationHookResult = ReturnType<typeof useCreatePermissionMutation>;
export type CreatePermissionMutationResult = Apollo.MutationResult<CreatePermissionMutation>;
export type CreatePermissionMutationOptions = Apollo.BaseMutationOptions<CreatePermissionMutation, CreatePermissionMutationVariables>;
export const UpdatePermissionDocument = gql`
    mutation UpdatePermission($id: ID!, $name: String, $description: String, $roles: [ID], $withRoles: Boolean = false) {
  updatePermission(
    id: $id
    name: $name
    description: $description
    roleIds: $roles
  ) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type UpdatePermissionMutationFn = Apollo.MutationFunction<UpdatePermissionMutation, UpdatePermissionMutationVariables>;

/**
 * __useUpdatePermissionMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionMutation, { data, loading, error }] = useUpdatePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      roles: // value for 'roles'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useUpdatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionMutation, UpdatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionMutation, UpdatePermissionMutationVariables>(UpdatePermissionDocument, options);
      }
export type UpdatePermissionMutationHookResult = ReturnType<typeof useUpdatePermissionMutation>;
export type UpdatePermissionMutationResult = Apollo.MutationResult<UpdatePermissionMutation>;
export type UpdatePermissionMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionMutation, UpdatePermissionMutationVariables>;
export const DeletePermissionDocument = gql`
    mutation DeletePermission($id: ID!, $withRoles: Boolean = false) {
  deletePermission(id: $id) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type DeletePermissionMutationFn = Apollo.MutationFunction<DeletePermissionMutation, DeletePermissionMutationVariables>;

/**
 * __useDeletePermissionMutation__
 *
 * To run a mutation, you first call `useDeletePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermissionMutation, { data, loading, error }] = useDeletePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useDeletePermissionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePermissionMutation, DeletePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePermissionMutation, DeletePermissionMutationVariables>(DeletePermissionDocument, options);
      }
export type DeletePermissionMutationHookResult = ReturnType<typeof useDeletePermissionMutation>;
export type DeletePermissionMutationResult = Apollo.MutationResult<DeletePermissionMutation>;
export type DeletePermissionMutationOptions = Apollo.BaseMutationOptions<DeletePermissionMutation, DeletePermissionMutationVariables>;
export const CreatedPermissionDocument = gql`
    subscription CreatedPermission($filter: PermissionFilterArgs, $withRoles: Boolean = false) {
  createdPermission(filter: $filter) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useCreatedPermissionSubscription__
 *
 * To run a query within a React component, call `useCreatedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useCreatedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedPermissionSubscription, CreatedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedPermissionSubscription, CreatedPermissionSubscriptionVariables>(CreatedPermissionDocument, options);
      }
export type CreatedPermissionSubscriptionHookResult = ReturnType<typeof useCreatedPermissionSubscription>;
export type CreatedPermissionSubscriptionResult = Apollo.SubscriptionResult<CreatedPermissionSubscription>;
export const UpdatedPermissionDocument = gql`
    subscription UpdatedPermission($filter: PermissionFilterArgs, $withRoles: Boolean = false) {
  updatedPermission(filter: $filter) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useUpdatedPermissionSubscription__
 *
 * To run a query within a React component, call `useUpdatedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useUpdatedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedPermissionSubscription, UpdatedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedPermissionSubscription, UpdatedPermissionSubscriptionVariables>(UpdatedPermissionDocument, options);
      }
export type UpdatedPermissionSubscriptionHookResult = ReturnType<typeof useUpdatedPermissionSubscription>;
export type UpdatedPermissionSubscriptionResult = Apollo.SubscriptionResult<UpdatedPermissionSubscription>;
export const DeletedPermissionDocument = gql`
    subscription DeletedPermission($filter: PermissionFilterArgs) {
  deletedPermission(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedPermissionSubscription__
 *
 * To run a query within a React component, call `useDeletedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedPermissionSubscription, DeletedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedPermissionSubscription, DeletedPermissionSubscriptionVariables>(DeletedPermissionDocument, options);
      }
export type DeletedPermissionSubscriptionHookResult = ReturnType<typeof useDeletedPermissionSubscription>;
export type DeletedPermissionSubscriptionResult = Apollo.SubscriptionResult<DeletedPermissionSubscription>;
export const GetResetPasswordsDocument = gql`
    query GetResetPasswords($filter: ResetPasswordFilterArgs, $paging: PageArgs, $sorting: [ResetPasswordSortArgs!]) {
  resetPasswords(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...resetPasswordFields
    }
    totalCount
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useGetResetPasswordsQuery__
 *
 * To run a query within a React component, call `useGetResetPasswordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResetPasswordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResetPasswordsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetResetPasswordsQuery(baseOptions?: Apollo.QueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
      }
export function useGetResetPasswordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
        }
export function useGetResetPasswordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
        }
export type GetResetPasswordsQueryHookResult = ReturnType<typeof useGetResetPasswordsQuery>;
export type GetResetPasswordsLazyQueryHookResult = ReturnType<typeof useGetResetPasswordsLazyQuery>;
export type GetResetPasswordsSuspenseQueryHookResult = ReturnType<typeof useGetResetPasswordsSuspenseQuery>;
export type GetResetPasswordsQueryResult = Apollo.QueryResult<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>;
export const GetResetPasswordDocument = gql`
    query GetResetPassword($id: ID!) {
  resetPassword(id: $id) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useGetResetPasswordQuery__
 *
 * To run a query within a React component, call `useGetResetPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResetPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResetPasswordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResetPasswordQuery(baseOptions: Apollo.QueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables> & ({ variables: GetResetPasswordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
      }
export function useGetResetPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
        }
export function useGetResetPasswordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
        }
export type GetResetPasswordQueryHookResult = ReturnType<typeof useGetResetPasswordQuery>;
export type GetResetPasswordLazyQueryHookResult = ReturnType<typeof useGetResetPasswordLazyQuery>;
export type GetResetPasswordSuspenseQueryHookResult = ReturnType<typeof useGetResetPasswordSuspenseQuery>;
export type GetResetPasswordQueryResult = Apollo.QueryResult<GetResetPasswordQuery, GetResetPasswordQueryVariables>;
export const CreateResetPasswordDocument = gql`
    mutation CreateResetPassword($email: String!, $token: String!, $type: String!) {
  createResetPassword(email: $email, token: $token, type: $type) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type CreateResetPasswordMutationFn = Apollo.MutationFunction<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>;

/**
 * __useCreateResetPasswordMutation__
 *
 * To run a mutation, you first call `useCreateResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResetPasswordMutation, { data, loading, error }] = useCreateResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>(CreateResetPasswordDocument, options);
      }
export type CreateResetPasswordMutationHookResult = ReturnType<typeof useCreateResetPasswordMutation>;
export type CreateResetPasswordMutationResult = Apollo.MutationResult<CreateResetPasswordMutation>;
export type CreateResetPasswordMutationOptions = Apollo.BaseMutationOptions<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>;
export const UpdateResetPasswordDocument = gql`
    mutation UpdateResetPassword($id: ID!, $email: String, $token: String, $type: String) {
  updateResetPassword(id: $id, email: $email, token: $token, type: $type) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type UpdateResetPasswordMutationFn = Apollo.MutationFunction<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>;

/**
 * __useUpdateResetPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResetPasswordMutation, { data, loading, error }] = useUpdateResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>(UpdateResetPasswordDocument, options);
      }
export type UpdateResetPasswordMutationHookResult = ReturnType<typeof useUpdateResetPasswordMutation>;
export type UpdateResetPasswordMutationResult = Apollo.MutationResult<UpdateResetPasswordMutation>;
export type UpdateResetPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>;
export const DeleteResetPasswordDocument = gql`
    mutation DeleteResetPassword($id: ID!) {
  deleteResetPassword(id: $id) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type DeleteResetPasswordMutationFn = Apollo.MutationFunction<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>;

/**
 * __useDeleteResetPasswordMutation__
 *
 * To run a mutation, you first call `useDeleteResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResetPasswordMutation, { data, loading, error }] = useDeleteResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>(DeleteResetPasswordDocument, options);
      }
export type DeleteResetPasswordMutationHookResult = ReturnType<typeof useDeleteResetPasswordMutation>;
export type DeleteResetPasswordMutationResult = Apollo.MutationResult<DeleteResetPasswordMutation>;
export type DeleteResetPasswordMutationOptions = Apollo.BaseMutationOptions<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>;
export const CreatedResetPasswordDocument = gql`
    subscription CreatedResetPassword($filter: ResetPasswordFilterArgs) {
  createdResetPassword(filter: $filter) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useCreatedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useCreatedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedResetPasswordSubscription, CreatedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedResetPasswordSubscription, CreatedResetPasswordSubscriptionVariables>(CreatedResetPasswordDocument, options);
      }
export type CreatedResetPasswordSubscriptionHookResult = ReturnType<typeof useCreatedResetPasswordSubscription>;
export type CreatedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<CreatedResetPasswordSubscription>;
export const UpdatedResetPasswordDocument = gql`
    subscription UpdatedResetPassword($filter: ResetPasswordFilterArgs) {
  updatedResetPassword(filter: $filter) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useUpdatedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useUpdatedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedResetPasswordSubscription, UpdatedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedResetPasswordSubscription, UpdatedResetPasswordSubscriptionVariables>(UpdatedResetPasswordDocument, options);
      }
export type UpdatedResetPasswordSubscriptionHookResult = ReturnType<typeof useUpdatedResetPasswordSubscription>;
export type UpdatedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<UpdatedResetPasswordSubscription>;
export const DeletedResetPasswordDocument = gql`
    subscription DeletedResetPassword($filter: ResetPasswordFilterArgs) {
  deletedResetPassword(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useDeletedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedResetPasswordSubscription, DeletedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedResetPasswordSubscription, DeletedResetPasswordSubscriptionVariables>(DeletedResetPasswordDocument, options);
      }
export type DeletedResetPasswordSubscriptionHookResult = ReturnType<typeof useDeletedResetPasswordSubscription>;
export type DeletedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<DeletedResetPasswordSubscription>;
export const GetRolesDocument = gql`
    query GetRoles($filter: RoleFilterArgs, $paging: PageArgs, $sorting: [RoleSortArgs!], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  roles(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...roleFields
    }
    totalCount
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetRoleDocument = gql`
    query GetRole($id: ID!, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  role(id: $id) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> & ({ variables: GetRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<typeof useGetRoleSuspenseQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetAllRelatedDataForRoleDocument = gql`
    query GetAllRelatedDataForRole($withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  permissions @include(if: $withPermissions) {
    items {
      id
      displayField: name
    }
  }
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForRoleQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForRoleQuery({
 *   variables: {
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
      }
export function useGetAllRelatedDataForRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
        }
export function useGetAllRelatedDataForRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
        }
export type GetAllRelatedDataForRoleQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleQuery>;
export type GetAllRelatedDataForRoleLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleLazyQuery>;
export type GetAllRelatedDataForRoleSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleSuspenseQuery>;
export type GetAllRelatedDataForRoleQueryResult = Apollo.QueryResult<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($displayName: String!, $description: String!, $permissions: [ID], $userTenantRoles: [ID], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  createRole(
    displayName: $displayName
    description: $description
    permissionIds: $permissions
    userTenantRoleIds: $userTenantRoles
  ) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      permissions: // value for 'permissions'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($id: ID!, $displayName: String, $description: String, $permissions: [ID], $userTenantRoles: [ID], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  updateRole(
    id: $id
    displayName: $displayName
    description: $description
    permissionIds: $permissions
    userTenantRoleIds: $userTenantRoles
  ) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      permissions: // value for 'permissions'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($id: ID!, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  deleteRole(id: $id) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const CreatedRoleDocument = gql`
    subscription CreatedRole($filter: RoleFilterArgs, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  createdRole(filter: $filter) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useCreatedRoleSubscription__
 *
 * To run a query within a React component, call `useCreatedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useCreatedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedRoleSubscription, CreatedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedRoleSubscription, CreatedRoleSubscriptionVariables>(CreatedRoleDocument, options);
      }
export type CreatedRoleSubscriptionHookResult = ReturnType<typeof useCreatedRoleSubscription>;
export type CreatedRoleSubscriptionResult = Apollo.SubscriptionResult<CreatedRoleSubscription>;
export const UpdatedRoleDocument = gql`
    subscription UpdatedRole($filter: RoleFilterArgs, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  updatedRole(filter: $filter) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useUpdatedRoleSubscription__
 *
 * To run a query within a React component, call `useUpdatedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useUpdatedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedRoleSubscription, UpdatedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedRoleSubscription, UpdatedRoleSubscriptionVariables>(UpdatedRoleDocument, options);
      }
export type UpdatedRoleSubscriptionHookResult = ReturnType<typeof useUpdatedRoleSubscription>;
export type UpdatedRoleSubscriptionResult = Apollo.SubscriptionResult<UpdatedRoleSubscription>;
export const DeletedRoleDocument = gql`
    subscription DeletedRole($filter: RoleFilterArgs) {
  deletedRole(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedRoleSubscription__
 *
 * To run a query within a React component, call `useDeletedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedRoleSubscription, DeletedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedRoleSubscription, DeletedRoleSubscriptionVariables>(DeletedRoleDocument, options);
      }
export type DeletedRoleSubscriptionHookResult = ReturnType<typeof useDeletedRoleSubscription>;
export type DeletedRoleSubscriptionResult = Apollo.SubscriptionResult<DeletedRoleSubscription>;
export const GetTenantsDocument = gql`
    query GetTenants($filter: TenantFilterArgs, $paging: PageArgs, $sorting: [TenantSortArgs!], $withUserTenantRoles: Boolean = false, $withContents: Boolean = false, $withAllowedApiHostnames: Boolean = false, $withMailTemplates: Boolean = false, $withMailLayouts: Boolean = false, $withMissingContents: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUsers: Boolean = false) {
  tenants(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...tenantFields
    }
    totalCount
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useGetTenantsQuery__
 *
 * To run a query within a React component, call `useGetTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContents: // value for 'withContents'
 *      withAllowedApiHostnames: // value for 'withAllowedApiHostnames'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMissingContents: // value for 'withMissingContents'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useGetTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
      }
export function useGetTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export function useGetTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export type GetTenantsQueryHookResult = ReturnType<typeof useGetTenantsQuery>;
export type GetTenantsLazyQueryHookResult = ReturnType<typeof useGetTenantsLazyQuery>;
export type GetTenantsSuspenseQueryHookResult = ReturnType<typeof useGetTenantsSuspenseQuery>;
export type GetTenantsQueryResult = Apollo.QueryResult<GetTenantsQuery, GetTenantsQueryVariables>;
export const GetTenantDocument = gql`
    query GetTenant($id: ID!, $withUserTenantRoles: Boolean = false, $withContents: Boolean = false, $withAllowedApiHostnames: Boolean = false, $withMailTemplates: Boolean = false, $withMailLayouts: Boolean = false, $withMissingContents: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUsers: Boolean = false) {
  tenant(id: $id) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useGetTenantQuery__
 *
 * To run a query within a React component, call `useGetTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContents: // value for 'withContents'
 *      withAllowedApiHostnames: // value for 'withAllowedApiHostnames'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMissingContents: // value for 'withMissingContents'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useGetTenantQuery(baseOptions: Apollo.QueryHookOptions<GetTenantQuery, GetTenantQueryVariables> & ({ variables: GetTenantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
      }
export function useGetTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
export function useGetTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
export type GetTenantQueryHookResult = ReturnType<typeof useGetTenantQuery>;
export type GetTenantLazyQueryHookResult = ReturnType<typeof useGetTenantLazyQuery>;
export type GetTenantSuspenseQueryHookResult = ReturnType<typeof useGetTenantSuspenseQuery>;
export type GetTenantQueryResult = Apollo.QueryResult<GetTenantQuery, GetTenantQueryVariables>;
export const GetAllRelatedDataForTenantDocument = gql`
    query GetAllRelatedDataForTenant($withUserTenantRoles: Boolean = false, $withContents: Boolean = false, $withAllowedApiHostnames: Boolean = false, $withMailTemplates: Boolean = false, $withMailLayouts: Boolean = false, $withMissingContents: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUsers: Boolean = false) {
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
  contents @include(if: $withContents) {
    items {
      id
      displayField: name
    }
  }
  allowedApiHostnames @include(if: $withAllowedApiHostnames) {
    items {
      id
      displayField: id
    }
  }
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      displayField: machineName
    }
  }
  mailLayouts @include(if: $withMailLayouts) {
    items {
      id
      displayField: name
    }
  }
  missingContents @include(if: $withMissingContents) {
    items {
      id
      displayField: machineName
    }
  }
  authorizationCodes @include(if: $withAuthorizationCodes) {
    items {
      id
      displayField: id
    }
  }
  tenantUsers @include(if: $withTenantUsers) {
    items {
      id
      displayField: email
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForTenantQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForTenantQuery({
 *   variables: {
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContents: // value for 'withContents'
 *      withAllowedApiHostnames: // value for 'withAllowedApiHostnames'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMissingContents: // value for 'withMissingContents'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForTenantQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
      }
export function useGetAllRelatedDataForTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
        }
export function useGetAllRelatedDataForTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
        }
export type GetAllRelatedDataForTenantQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantQuery>;
export type GetAllRelatedDataForTenantLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantLazyQuery>;
export type GetAllRelatedDataForTenantSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantSuspenseQuery>;
export type GetAllRelatedDataForTenantQueryResult = Apollo.QueryResult<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>;
export const CreateTenantDocument = gql`
    mutation CreateTenant($name: String!, $timeZone: String!, $redirectUri: String, $termsAndConditions: String, $frontendBaseUri: String, $googleAuthEnabled: Boolean!, $googleId: String, $googleSecret: String, $microsoftAuthEnabled: Boolean!, $microsoftId: String, $microsoftSecret: String, $microsoftTenantId: String, $inviteExpiration: Int, $passwordResetExpiration: Int, $registerEnabled: Boolean!, $confirmAccountEnabled: Boolean!, $userTenantRoles: [ID], $contents: [ID], $allowedApiHostnames: [ID], $mailTemplates: [ID], $mailLayouts: [ID], $missingContents: [ID], $authorizationCodes: [ID], $tenantUsers: [ID], $withUserTenantRoles: Boolean = false, $withContents: Boolean = false, $withAllowedApiHostnames: Boolean = false, $withMailTemplates: Boolean = false, $withMailLayouts: Boolean = false, $withMissingContents: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUsers: Boolean = false) {
  createTenant(
    name: $name
    timeZone: $timeZone
    redirectUri: $redirectUri
    termsAndConditions: $termsAndConditions
    frontendBaseUri: $frontendBaseUri
    googleAuthEnabled: $googleAuthEnabled
    googleId: $googleId
    googleSecret: $googleSecret
    microsoftAuthEnabled: $microsoftAuthEnabled
    microsoftId: $microsoftId
    microsoftSecret: $microsoftSecret
    microsoftTenantId: $microsoftTenantId
    inviteExpiration: $inviteExpiration
    passwordResetExpiration: $passwordResetExpiration
    registerEnabled: $registerEnabled
    confirmAccountEnabled: $confirmAccountEnabled
    userTenantRoleIds: $userTenantRoles
    contentIds: $contents
    allowedApiHostnameIds: $allowedApiHostnames
    mailTemplateIds: $mailTemplates
    mailLayoutIds: $mailLayouts
    missingContentIds: $missingContents
    authorizationCodeIds: $authorizationCodes
    tenantUserIds: $tenantUsers
  ) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type CreateTenantMutationFn = Apollo.MutationFunction<CreateTenantMutation, CreateTenantMutationVariables>;

/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      name: // value for 'name'
 *      timeZone: // value for 'timeZone'
 *      redirectUri: // value for 'redirectUri'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      frontendBaseUri: // value for 'frontendBaseUri'
 *      googleAuthEnabled: // value for 'googleAuthEnabled'
 *      googleId: // value for 'googleId'
 *      googleSecret: // value for 'googleSecret'
 *      microsoftAuthEnabled: // value for 'microsoftAuthEnabled'
 *      microsoftId: // value for 'microsoftId'
 *      microsoftSecret: // value for 'microsoftSecret'
 *      microsoftTenantId: // value for 'microsoftTenantId'
 *      inviteExpiration: // value for 'inviteExpiration'
 *      passwordResetExpiration: // value for 'passwordResetExpiration'
 *      registerEnabled: // value for 'registerEnabled'
 *      confirmAccountEnabled: // value for 'confirmAccountEnabled'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      contents: // value for 'contents'
 *      allowedApiHostnames: // value for 'allowedApiHostnames'
 *      mailTemplates: // value for 'mailTemplates'
 *      mailLayouts: // value for 'mailLayouts'
 *      missingContents: // value for 'missingContents'
 *      authorizationCodes: // value for 'authorizationCodes'
 *      tenantUsers: // value for 'tenantUsers'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContents: // value for 'withContents'
 *      withAllowedApiHostnames: // value for 'withAllowedApiHostnames'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMissingContents: // value for 'withMissingContents'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useCreateTenantMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantMutation, CreateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, options);
      }
export type CreateTenantMutationHookResult = ReturnType<typeof useCreateTenantMutation>;
export type CreateTenantMutationResult = Apollo.MutationResult<CreateTenantMutation>;
export type CreateTenantMutationOptions = Apollo.BaseMutationOptions<CreateTenantMutation, CreateTenantMutationVariables>;
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($id: ID!, $name: String, $timeZone: String, $redirectUri: String, $termsAndConditions: String, $frontendBaseUri: String, $googleAuthEnabled: Boolean, $googleId: String, $googleSecret: String, $microsoftAuthEnabled: Boolean, $microsoftId: String, $microsoftSecret: String, $microsoftTenantId: String, $inviteExpiration: Int, $passwordResetExpiration: Int, $registerEnabled: Boolean, $confirmAccountEnabled: Boolean, $userTenantRoles: [ID], $contents: [ID], $allowedApiHostnames: [ID], $mailTemplates: [ID], $mailLayouts: [ID], $missingContents: [ID], $authorizationCodes: [ID], $tenantUsers: [ID], $withUserTenantRoles: Boolean = false, $withContents: Boolean = false, $withAllowedApiHostnames: Boolean = false, $withMailTemplates: Boolean = false, $withMailLayouts: Boolean = false, $withMissingContents: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUsers: Boolean = false) {
  updateTenant(
    id: $id
    name: $name
    timeZone: $timeZone
    redirectUri: $redirectUri
    termsAndConditions: $termsAndConditions
    frontendBaseUri: $frontendBaseUri
    googleAuthEnabled: $googleAuthEnabled
    googleId: $googleId
    googleSecret: $googleSecret
    microsoftAuthEnabled: $microsoftAuthEnabled
    microsoftId: $microsoftId
    microsoftSecret: $microsoftSecret
    microsoftTenantId: $microsoftTenantId
    inviteExpiration: $inviteExpiration
    passwordResetExpiration: $passwordResetExpiration
    registerEnabled: $registerEnabled
    confirmAccountEnabled: $confirmAccountEnabled
    userTenantRoleIds: $userTenantRoles
    contentIds: $contents
    allowedApiHostnameIds: $allowedApiHostnames
    mailTemplateIds: $mailTemplates
    mailLayoutIds: $mailLayouts
    missingContentIds: $missingContents
    authorizationCodeIds: $authorizationCodes
    tenantUserIds: $tenantUsers
  ) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      timeZone: // value for 'timeZone'
 *      redirectUri: // value for 'redirectUri'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      frontendBaseUri: // value for 'frontendBaseUri'
 *      googleAuthEnabled: // value for 'googleAuthEnabled'
 *      googleId: // value for 'googleId'
 *      googleSecret: // value for 'googleSecret'
 *      microsoftAuthEnabled: // value for 'microsoftAuthEnabled'
 *      microsoftId: // value for 'microsoftId'
 *      microsoftSecret: // value for 'microsoftSecret'
 *      microsoftTenantId: // value for 'microsoftTenantId'
 *      inviteExpiration: // value for 'inviteExpiration'
 *      passwordResetExpiration: // value for 'passwordResetExpiration'
 *      registerEnabled: // value for 'registerEnabled'
 *      confirmAccountEnabled: // value for 'confirmAccountEnabled'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      contents: // value for 'contents'
 *      allowedApiHostnames: // value for 'allowedApiHostnames'
 *      mailTemplates: // value for 'mailTemplates'
 *      mailLayouts: // value for 'mailLayouts'
 *      missingContents: // value for 'missingContents'
 *      authorizationCodes: // value for 'authorizationCodes'
 *      tenantUsers: // value for 'tenantUsers'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContents: // value for 'withContents'
 *      withAllowedApiHostnames: // value for 'withAllowedApiHostnames'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMissingContents: // value for 'withMissingContents'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const DeleteTenantDocument = gql`
    mutation DeleteTenant($id: ID!, $withUserTenantRoles: Boolean = false, $withContents: Boolean = false, $withAllowedApiHostnames: Boolean = false, $withMailTemplates: Boolean = false, $withMailLayouts: Boolean = false, $withMissingContents: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUsers: Boolean = false) {
  deleteTenant(id: $id) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type DeleteTenantMutationFn = Apollo.MutationFunction<DeleteTenantMutation, DeleteTenantMutationVariables>;

/**
 * __useDeleteTenantMutation__
 *
 * To run a mutation, you first call `useDeleteTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantMutation, { data, loading, error }] = useDeleteTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContents: // value for 'withContents'
 *      withAllowedApiHostnames: // value for 'withAllowedApiHostnames'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMissingContents: // value for 'withMissingContents'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useDeleteTenantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantMutation, DeleteTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantMutation, DeleteTenantMutationVariables>(DeleteTenantDocument, options);
      }
export type DeleteTenantMutationHookResult = ReturnType<typeof useDeleteTenantMutation>;
export type DeleteTenantMutationResult = Apollo.MutationResult<DeleteTenantMutation>;
export type DeleteTenantMutationOptions = Apollo.BaseMutationOptions<DeleteTenantMutation, DeleteTenantMutationVariables>;
export const CreatedTenantDocument = gql`
    subscription CreatedTenant($filter: TenantFilterArgs, $withUserTenantRoles: Boolean = false, $withContents: Boolean = false, $withAllowedApiHostnames: Boolean = false, $withMailTemplates: Boolean = false, $withMailLayouts: Boolean = false, $withMissingContents: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUsers: Boolean = false) {
  createdTenant(filter: $filter) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useCreatedTenantSubscription__
 *
 * To run a query within a React component, call `useCreatedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContents: // value for 'withContents'
 *      withAllowedApiHostnames: // value for 'withAllowedApiHostnames'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMissingContents: // value for 'withMissingContents'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useCreatedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedTenantSubscription, CreatedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedTenantSubscription, CreatedTenantSubscriptionVariables>(CreatedTenantDocument, options);
      }
export type CreatedTenantSubscriptionHookResult = ReturnType<typeof useCreatedTenantSubscription>;
export type CreatedTenantSubscriptionResult = Apollo.SubscriptionResult<CreatedTenantSubscription>;
export const UpdatedTenantDocument = gql`
    subscription UpdatedTenant($filter: TenantFilterArgs, $withUserTenantRoles: Boolean = false, $withContents: Boolean = false, $withAllowedApiHostnames: Boolean = false, $withMailTemplates: Boolean = false, $withMailLayouts: Boolean = false, $withMissingContents: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUsers: Boolean = false) {
  updatedTenant(filter: $filter) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useUpdatedTenantSubscription__
 *
 * To run a query within a React component, call `useUpdatedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withContents: // value for 'withContents'
 *      withAllowedApiHostnames: // value for 'withAllowedApiHostnames'
 *      withMailTemplates: // value for 'withMailTemplates'
 *      withMailLayouts: // value for 'withMailLayouts'
 *      withMissingContents: // value for 'withMissingContents'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useUpdatedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedTenantSubscription, UpdatedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedTenantSubscription, UpdatedTenantSubscriptionVariables>(UpdatedTenantDocument, options);
      }
export type UpdatedTenantSubscriptionHookResult = ReturnType<typeof useUpdatedTenantSubscription>;
export type UpdatedTenantSubscriptionResult = Apollo.SubscriptionResult<UpdatedTenantSubscription>;
export const DeletedTenantDocument = gql`
    subscription DeletedTenant($filter: TenantFilterArgs) {
  deletedTenant(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedTenantSubscription__
 *
 * To run a query within a React component, call `useDeletedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedTenantSubscription, DeletedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedTenantSubscription, DeletedTenantSubscriptionVariables>(DeletedTenantDocument, options);
      }
export type DeletedTenantSubscriptionHookResult = ReturnType<typeof useDeletedTenantSubscription>;
export type DeletedTenantSubscriptionResult = Apollo.SubscriptionResult<DeletedTenantSubscription>;
export const GetTenantUsersDocument = gql`
    query GetTenantUsers($filter: TenantUserFilterArgs, $paging: PageArgs, $sorting: [TenantUserSortArgs!], $withTenant: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  tenantUsers(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...tenantUserFields
    }
    totalCount
  }
}
    ${TenantUserFieldsFragmentDoc}`;

/**
 * __useGetTenantUsersQuery__
 *
 * To run a query within a React component, call `useGetTenantUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withTenant: // value for 'withTenant'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useGetTenantUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantUsersQuery, GetTenantUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantUsersQuery, GetTenantUsersQueryVariables>(GetTenantUsersDocument, options);
      }
export function useGetTenantUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantUsersQuery, GetTenantUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantUsersQuery, GetTenantUsersQueryVariables>(GetTenantUsersDocument, options);
        }
export function useGetTenantUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantUsersQuery, GetTenantUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantUsersQuery, GetTenantUsersQueryVariables>(GetTenantUsersDocument, options);
        }
export type GetTenantUsersQueryHookResult = ReturnType<typeof useGetTenantUsersQuery>;
export type GetTenantUsersLazyQueryHookResult = ReturnType<typeof useGetTenantUsersLazyQuery>;
export type GetTenantUsersSuspenseQueryHookResult = ReturnType<typeof useGetTenantUsersSuspenseQuery>;
export type GetTenantUsersQueryResult = Apollo.QueryResult<GetTenantUsersQuery, GetTenantUsersQueryVariables>;
export const GetTenantUserDocument = gql`
    query GetTenantUser($id: ID!, $withTenant: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  tenantUser(id: $id) {
    ...tenantUserFields
  }
}
    ${TenantUserFieldsFragmentDoc}`;

/**
 * __useGetTenantUserQuery__
 *
 * To run a query within a React component, call `useGetTenantUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useGetTenantUserQuery(baseOptions: Apollo.QueryHookOptions<GetTenantUserQuery, GetTenantUserQueryVariables> & ({ variables: GetTenantUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantUserQuery, GetTenantUserQueryVariables>(GetTenantUserDocument, options);
      }
export function useGetTenantUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantUserQuery, GetTenantUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantUserQuery, GetTenantUserQueryVariables>(GetTenantUserDocument, options);
        }
export function useGetTenantUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantUserQuery, GetTenantUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantUserQuery, GetTenantUserQueryVariables>(GetTenantUserDocument, options);
        }
export type GetTenantUserQueryHookResult = ReturnType<typeof useGetTenantUserQuery>;
export type GetTenantUserLazyQueryHookResult = ReturnType<typeof useGetTenantUserLazyQuery>;
export type GetTenantUserSuspenseQueryHookResult = ReturnType<typeof useGetTenantUserSuspenseQuery>;
export type GetTenantUserQueryResult = Apollo.QueryResult<GetTenantUserQuery, GetTenantUserQueryVariables>;
export const GetAllRelatedDataForTenantUserDocument = gql`
    query GetAllRelatedDataForTenantUser($withTenants: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  authorizationCodes @include(if: $withAuthorizationCodes) {
    items {
      id
      displayField: id
    }
  }
  tenantUserResetPasswords @include(if: $withTenantUserResetPasswords) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForTenantUserQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForTenantUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForTenantUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForTenantUserQuery({
 *   variables: {
 *      withTenants: // value for 'withTenants'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useGetAllRelatedDataForTenantUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForTenantUserQuery, GetAllRelatedDataForTenantUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForTenantUserQuery, GetAllRelatedDataForTenantUserQueryVariables>(GetAllRelatedDataForTenantUserDocument, options);
      }
export function useGetAllRelatedDataForTenantUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForTenantUserQuery, GetAllRelatedDataForTenantUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForTenantUserQuery, GetAllRelatedDataForTenantUserQueryVariables>(GetAllRelatedDataForTenantUserDocument, options);
        }
export function useGetAllRelatedDataForTenantUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForTenantUserQuery, GetAllRelatedDataForTenantUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForTenantUserQuery, GetAllRelatedDataForTenantUserQueryVariables>(GetAllRelatedDataForTenantUserDocument, options);
        }
export type GetAllRelatedDataForTenantUserQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantUserQuery>;
export type GetAllRelatedDataForTenantUserLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantUserLazyQuery>;
export type GetAllRelatedDataForTenantUserSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantUserSuspenseQuery>;
export type GetAllRelatedDataForTenantUserQueryResult = Apollo.QueryResult<GetAllRelatedDataForTenantUserQuery, GetAllRelatedDataForTenantUserQueryVariables>;
export const CreateTenantUserDocument = gql`
    mutation CreateTenantUser($email: String!, $termsAndConditions: Boolean, $active: Boolean!, $tenantId: ID!, $authorizationCodes: [ID], $tenantUserResetPasswords: [ID], $withTenant: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  createTenantUser(
    email: $email
    termsAndConditions: $termsAndConditions
    active: $active
    tenantId: $tenantId
    authorizationCodeIds: $authorizationCodes
    tenantUserResetPasswordIds: $tenantUserResetPasswords
  ) {
    ...tenantUserFields
  }
}
    ${TenantUserFieldsFragmentDoc}`;
export type CreateTenantUserMutationFn = Apollo.MutationFunction<CreateTenantUserMutation, CreateTenantUserMutationVariables>;

/**
 * __useCreateTenantUserMutation__
 *
 * To run a mutation, you first call `useCreateTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantUserMutation, { data, loading, error }] = useCreateTenantUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      active: // value for 'active'
 *      tenantId: // value for 'tenantId'
 *      authorizationCodes: // value for 'authorizationCodes'
 *      tenantUserResetPasswords: // value for 'tenantUserResetPasswords'
 *      withTenant: // value for 'withTenant'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useCreateTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantUserMutation, CreateTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantUserMutation, CreateTenantUserMutationVariables>(CreateTenantUserDocument, options);
      }
export type CreateTenantUserMutationHookResult = ReturnType<typeof useCreateTenantUserMutation>;
export type CreateTenantUserMutationResult = Apollo.MutationResult<CreateTenantUserMutation>;
export type CreateTenantUserMutationOptions = Apollo.BaseMutationOptions<CreateTenantUserMutation, CreateTenantUserMutationVariables>;
export const UpdateTenantUserDocument = gql`
    mutation UpdateTenantUser($id: ID!, $email: String, $termsAndConditions: Boolean, $active: Boolean, $tenantId: ID, $authorizationCodes: [ID], $tenantUserResetPasswords: [ID], $withTenant: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  updateTenantUser(
    id: $id
    email: $email
    termsAndConditions: $termsAndConditions
    active: $active
    tenantId: $tenantId
    authorizationCodeIds: $authorizationCodes
    tenantUserResetPasswordIds: $tenantUserResetPasswords
  ) {
    ...tenantUserFields
  }
}
    ${TenantUserFieldsFragmentDoc}`;
export type UpdateTenantUserMutationFn = Apollo.MutationFunction<UpdateTenantUserMutation, UpdateTenantUserMutationVariables>;

/**
 * __useUpdateTenantUserMutation__
 *
 * To run a mutation, you first call `useUpdateTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantUserMutation, { data, loading, error }] = useUpdateTenantUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      active: // value for 'active'
 *      tenantId: // value for 'tenantId'
 *      authorizationCodes: // value for 'authorizationCodes'
 *      tenantUserResetPasswords: // value for 'tenantUserResetPasswords'
 *      withTenant: // value for 'withTenant'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useUpdateTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantUserMutation, UpdateTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantUserMutation, UpdateTenantUserMutationVariables>(UpdateTenantUserDocument, options);
      }
export type UpdateTenantUserMutationHookResult = ReturnType<typeof useUpdateTenantUserMutation>;
export type UpdateTenantUserMutationResult = Apollo.MutationResult<UpdateTenantUserMutation>;
export type UpdateTenantUserMutationOptions = Apollo.BaseMutationOptions<UpdateTenantUserMutation, UpdateTenantUserMutationVariables>;
export const DeleteTenantUserDocument = gql`
    mutation DeleteTenantUser($id: ID!, $withTenant: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  deleteTenantUser(id: $id) {
    ...tenantUserFields
  }
}
    ${TenantUserFieldsFragmentDoc}`;
export type DeleteTenantUserMutationFn = Apollo.MutationFunction<DeleteTenantUserMutation, DeleteTenantUserMutationVariables>;

/**
 * __useDeleteTenantUserMutation__
 *
 * To run a mutation, you first call `useDeleteTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantUserMutation, { data, loading, error }] = useDeleteTenantUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useDeleteTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantUserMutation, DeleteTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantUserMutation, DeleteTenantUserMutationVariables>(DeleteTenantUserDocument, options);
      }
export type DeleteTenantUserMutationHookResult = ReturnType<typeof useDeleteTenantUserMutation>;
export type DeleteTenantUserMutationResult = Apollo.MutationResult<DeleteTenantUserMutation>;
export type DeleteTenantUserMutationOptions = Apollo.BaseMutationOptions<DeleteTenantUserMutation, DeleteTenantUserMutationVariables>;
export const CreatedTenantUserDocument = gql`
    subscription CreatedTenantUser($filter: TenantUserFilterArgs, $withTenant: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  createdTenantUser(filter: $filter) {
    ...tenantUserFields
  }
}
    ${TenantUserFieldsFragmentDoc}`;

/**
 * __useCreatedTenantUserSubscription__
 *
 * To run a query within a React component, call `useCreatedTenantUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedTenantUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedTenantUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useCreatedTenantUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedTenantUserSubscription, CreatedTenantUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedTenantUserSubscription, CreatedTenantUserSubscriptionVariables>(CreatedTenantUserDocument, options);
      }
export type CreatedTenantUserSubscriptionHookResult = ReturnType<typeof useCreatedTenantUserSubscription>;
export type CreatedTenantUserSubscriptionResult = Apollo.SubscriptionResult<CreatedTenantUserSubscription>;
export const UpdatedTenantUserDocument = gql`
    subscription UpdatedTenantUser($filter: TenantUserFilterArgs, $withTenant: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  updatedTenantUser(filter: $filter) {
    ...tenantUserFields
  }
}
    ${TenantUserFieldsFragmentDoc}`;

/**
 * __useUpdatedTenantUserSubscription__
 *
 * To run a query within a React component, call `useUpdatedTenantUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedTenantUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedTenantUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useUpdatedTenantUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedTenantUserSubscription, UpdatedTenantUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedTenantUserSubscription, UpdatedTenantUserSubscriptionVariables>(UpdatedTenantUserDocument, options);
      }
export type UpdatedTenantUserSubscriptionHookResult = ReturnType<typeof useUpdatedTenantUserSubscription>;
export type UpdatedTenantUserSubscriptionResult = Apollo.SubscriptionResult<UpdatedTenantUserSubscription>;
export const DeletedTenantUserDocument = gql`
    subscription DeletedTenantUser($filter: TenantUserFilterArgs) {
  deletedTenantUser(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedTenantUserSubscription__
 *
 * To run a query within a React component, call `useDeletedTenantUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedTenantUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedTenantUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedTenantUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedTenantUserSubscription, DeletedTenantUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedTenantUserSubscription, DeletedTenantUserSubscriptionVariables>(DeletedTenantUserDocument, options);
      }
export type DeletedTenantUserSubscriptionHookResult = ReturnType<typeof useDeletedTenantUserSubscription>;
export type DeletedTenantUserSubscriptionResult = Apollo.SubscriptionResult<DeletedTenantUserSubscription>;
export const RestoredTenantUserDocument = gql`
    subscription RestoredTenantUser($filter: TenantUserFilterArgs, $withTenant: Boolean = false, $withAuthorizationCodes: Boolean = false, $withTenantUserResetPasswords: Boolean = false) {
  restoredTenantUser(filter: $filter) {
    ...tenantUserFields
  }
}
    ${TenantUserFieldsFragmentDoc}`;

/**
 * __useRestoredTenantUserSubscription__
 *
 * To run a query within a React component, call `useRestoredTenantUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredTenantUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredTenantUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *      withAuthorizationCodes: // value for 'withAuthorizationCodes'
 *      withTenantUserResetPasswords: // value for 'withTenantUserResetPasswords'
 *   },
 * });
 */
export function useRestoredTenantUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredTenantUserSubscription, RestoredTenantUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredTenantUserSubscription, RestoredTenantUserSubscriptionVariables>(RestoredTenantUserDocument, options);
      }
export type RestoredTenantUserSubscriptionHookResult = ReturnType<typeof useRestoredTenantUserSubscription>;
export type RestoredTenantUserSubscriptionResult = Apollo.SubscriptionResult<RestoredTenantUserSubscription>;
export const GetTenantUserResetPasswordsDocument = gql`
    query GetTenantUserResetPasswords($filter: TenantUserResetPasswordFilterArgs, $paging: PageArgs, $sorting: [TenantUserResetPasswordSortArgs!], $withTenantUser: Boolean = false) {
  tenantUserResetPasswords(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...tenantUserResetPasswordFields
    }
    totalCount
  }
}
    ${TenantUserResetPasswordFieldsFragmentDoc}`;

/**
 * __useGetTenantUserResetPasswordsQuery__
 *
 * To run a query within a React component, call `useGetTenantUserResetPasswordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantUserResetPasswordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantUserResetPasswordsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useGetTenantUserResetPasswordsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantUserResetPasswordsQuery, GetTenantUserResetPasswordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantUserResetPasswordsQuery, GetTenantUserResetPasswordsQueryVariables>(GetTenantUserResetPasswordsDocument, options);
      }
export function useGetTenantUserResetPasswordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantUserResetPasswordsQuery, GetTenantUserResetPasswordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantUserResetPasswordsQuery, GetTenantUserResetPasswordsQueryVariables>(GetTenantUserResetPasswordsDocument, options);
        }
export function useGetTenantUserResetPasswordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantUserResetPasswordsQuery, GetTenantUserResetPasswordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantUserResetPasswordsQuery, GetTenantUserResetPasswordsQueryVariables>(GetTenantUserResetPasswordsDocument, options);
        }
export type GetTenantUserResetPasswordsQueryHookResult = ReturnType<typeof useGetTenantUserResetPasswordsQuery>;
export type GetTenantUserResetPasswordsLazyQueryHookResult = ReturnType<typeof useGetTenantUserResetPasswordsLazyQuery>;
export type GetTenantUserResetPasswordsSuspenseQueryHookResult = ReturnType<typeof useGetTenantUserResetPasswordsSuspenseQuery>;
export type GetTenantUserResetPasswordsQueryResult = Apollo.QueryResult<GetTenantUserResetPasswordsQuery, GetTenantUserResetPasswordsQueryVariables>;
export const GetTenantUserResetPasswordDocument = gql`
    query GetTenantUserResetPassword($id: ID!, $withTenantUser: Boolean = false) {
  tenantUserResetPassword(id: $id) {
    ...tenantUserResetPasswordFields
  }
}
    ${TenantUserResetPasswordFieldsFragmentDoc}`;

/**
 * __useGetTenantUserResetPasswordQuery__
 *
 * To run a query within a React component, call `useGetTenantUserResetPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantUserResetPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantUserResetPasswordQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useGetTenantUserResetPasswordQuery(baseOptions: Apollo.QueryHookOptions<GetTenantUserResetPasswordQuery, GetTenantUserResetPasswordQueryVariables> & ({ variables: GetTenantUserResetPasswordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantUserResetPasswordQuery, GetTenantUserResetPasswordQueryVariables>(GetTenantUserResetPasswordDocument, options);
      }
export function useGetTenantUserResetPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantUserResetPasswordQuery, GetTenantUserResetPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantUserResetPasswordQuery, GetTenantUserResetPasswordQueryVariables>(GetTenantUserResetPasswordDocument, options);
        }
export function useGetTenantUserResetPasswordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantUserResetPasswordQuery, GetTenantUserResetPasswordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantUserResetPasswordQuery, GetTenantUserResetPasswordQueryVariables>(GetTenantUserResetPasswordDocument, options);
        }
export type GetTenantUserResetPasswordQueryHookResult = ReturnType<typeof useGetTenantUserResetPasswordQuery>;
export type GetTenantUserResetPasswordLazyQueryHookResult = ReturnType<typeof useGetTenantUserResetPasswordLazyQuery>;
export type GetTenantUserResetPasswordSuspenseQueryHookResult = ReturnType<typeof useGetTenantUserResetPasswordSuspenseQuery>;
export type GetTenantUserResetPasswordQueryResult = Apollo.QueryResult<GetTenantUserResetPasswordQuery, GetTenantUserResetPasswordQueryVariables>;
export const GetAllRelatedDataForTenantUserResetPasswordDocument = gql`
    query GetAllRelatedDataForTenantUserResetPassword($withTenantUsers: Boolean = false) {
  tenantUsers @include(if: $withTenantUsers) {
    items {
      id
      displayField: email
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForTenantUserResetPasswordQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForTenantUserResetPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForTenantUserResetPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForTenantUserResetPasswordQuery({
 *   variables: {
 *      withTenantUsers: // value for 'withTenantUsers'
 *   },
 * });
 */
export function useGetAllRelatedDataForTenantUserResetPasswordQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForTenantUserResetPasswordQuery, GetAllRelatedDataForTenantUserResetPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForTenantUserResetPasswordQuery, GetAllRelatedDataForTenantUserResetPasswordQueryVariables>(GetAllRelatedDataForTenantUserResetPasswordDocument, options);
      }
export function useGetAllRelatedDataForTenantUserResetPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForTenantUserResetPasswordQuery, GetAllRelatedDataForTenantUserResetPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForTenantUserResetPasswordQuery, GetAllRelatedDataForTenantUserResetPasswordQueryVariables>(GetAllRelatedDataForTenantUserResetPasswordDocument, options);
        }
export function useGetAllRelatedDataForTenantUserResetPasswordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForTenantUserResetPasswordQuery, GetAllRelatedDataForTenantUserResetPasswordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForTenantUserResetPasswordQuery, GetAllRelatedDataForTenantUserResetPasswordQueryVariables>(GetAllRelatedDataForTenantUserResetPasswordDocument, options);
        }
export type GetAllRelatedDataForTenantUserResetPasswordQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantUserResetPasswordQuery>;
export type GetAllRelatedDataForTenantUserResetPasswordLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantUserResetPasswordLazyQuery>;
export type GetAllRelatedDataForTenantUserResetPasswordSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantUserResetPasswordSuspenseQuery>;
export type GetAllRelatedDataForTenantUserResetPasswordQueryResult = Apollo.QueryResult<GetAllRelatedDataForTenantUserResetPasswordQuery, GetAllRelatedDataForTenantUserResetPasswordQueryVariables>;
export const CreateTenantUserResetPasswordDocument = gql`
    mutation CreateTenantUserResetPassword($type: String!, $tenantUserId: ID!, $withTenantUser: Boolean = false) {
  createTenantUserResetPassword(type: $type, tenantUserId: $tenantUserId) {
    ...tenantUserResetPasswordFields
  }
}
    ${TenantUserResetPasswordFieldsFragmentDoc}`;
export type CreateTenantUserResetPasswordMutationFn = Apollo.MutationFunction<CreateTenantUserResetPasswordMutation, CreateTenantUserResetPasswordMutationVariables>;

/**
 * __useCreateTenantUserResetPasswordMutation__
 *
 * To run a mutation, you first call `useCreateTenantUserResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantUserResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantUserResetPasswordMutation, { data, loading, error }] = useCreateTenantUserResetPasswordMutation({
 *   variables: {
 *      type: // value for 'type'
 *      tenantUserId: // value for 'tenantUserId'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useCreateTenantUserResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantUserResetPasswordMutation, CreateTenantUserResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantUserResetPasswordMutation, CreateTenantUserResetPasswordMutationVariables>(CreateTenantUserResetPasswordDocument, options);
      }
export type CreateTenantUserResetPasswordMutationHookResult = ReturnType<typeof useCreateTenantUserResetPasswordMutation>;
export type CreateTenantUserResetPasswordMutationResult = Apollo.MutationResult<CreateTenantUserResetPasswordMutation>;
export type CreateTenantUserResetPasswordMutationOptions = Apollo.BaseMutationOptions<CreateTenantUserResetPasswordMutation, CreateTenantUserResetPasswordMutationVariables>;
export const UpdateTenantUserResetPasswordDocument = gql`
    mutation UpdateTenantUserResetPassword($id: ID!, $type: String, $tenantUserId: ID, $withTenantUser: Boolean = false) {
  updateTenantUserResetPassword(id: $id, type: $type, tenantUserId: $tenantUserId) {
    ...tenantUserResetPasswordFields
  }
}
    ${TenantUserResetPasswordFieldsFragmentDoc}`;
export type UpdateTenantUserResetPasswordMutationFn = Apollo.MutationFunction<UpdateTenantUserResetPasswordMutation, UpdateTenantUserResetPasswordMutationVariables>;

/**
 * __useUpdateTenantUserResetPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateTenantUserResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantUserResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantUserResetPasswordMutation, { data, loading, error }] = useUpdateTenantUserResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      tenantUserId: // value for 'tenantUserId'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useUpdateTenantUserResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantUserResetPasswordMutation, UpdateTenantUserResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantUserResetPasswordMutation, UpdateTenantUserResetPasswordMutationVariables>(UpdateTenantUserResetPasswordDocument, options);
      }
export type UpdateTenantUserResetPasswordMutationHookResult = ReturnType<typeof useUpdateTenantUserResetPasswordMutation>;
export type UpdateTenantUserResetPasswordMutationResult = Apollo.MutationResult<UpdateTenantUserResetPasswordMutation>;
export type UpdateTenantUserResetPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateTenantUserResetPasswordMutation, UpdateTenantUserResetPasswordMutationVariables>;
export const DeleteTenantUserResetPasswordDocument = gql`
    mutation DeleteTenantUserResetPassword($id: ID!, $withTenantUser: Boolean = false) {
  deleteTenantUserResetPassword(id: $id) {
    ...tenantUserResetPasswordFields
  }
}
    ${TenantUserResetPasswordFieldsFragmentDoc}`;
export type DeleteTenantUserResetPasswordMutationFn = Apollo.MutationFunction<DeleteTenantUserResetPasswordMutation, DeleteTenantUserResetPasswordMutationVariables>;

/**
 * __useDeleteTenantUserResetPasswordMutation__
 *
 * To run a mutation, you first call `useDeleteTenantUserResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantUserResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantUserResetPasswordMutation, { data, loading, error }] = useDeleteTenantUserResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useDeleteTenantUserResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantUserResetPasswordMutation, DeleteTenantUserResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantUserResetPasswordMutation, DeleteTenantUserResetPasswordMutationVariables>(DeleteTenantUserResetPasswordDocument, options);
      }
export type DeleteTenantUserResetPasswordMutationHookResult = ReturnType<typeof useDeleteTenantUserResetPasswordMutation>;
export type DeleteTenantUserResetPasswordMutationResult = Apollo.MutationResult<DeleteTenantUserResetPasswordMutation>;
export type DeleteTenantUserResetPasswordMutationOptions = Apollo.BaseMutationOptions<DeleteTenantUserResetPasswordMutation, DeleteTenantUserResetPasswordMutationVariables>;
export const CreatedTenantUserResetPasswordDocument = gql`
    subscription CreatedTenantUserResetPassword($filter: TenantUserResetPasswordFilterArgs, $withTenantUser: Boolean = false) {
  createdTenantUserResetPassword(filter: $filter) {
    ...tenantUserResetPasswordFields
  }
}
    ${TenantUserResetPasswordFieldsFragmentDoc}`;

/**
 * __useCreatedTenantUserResetPasswordSubscription__
 *
 * To run a query within a React component, call `useCreatedTenantUserResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedTenantUserResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedTenantUserResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useCreatedTenantUserResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedTenantUserResetPasswordSubscription, CreatedTenantUserResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedTenantUserResetPasswordSubscription, CreatedTenantUserResetPasswordSubscriptionVariables>(CreatedTenantUserResetPasswordDocument, options);
      }
export type CreatedTenantUserResetPasswordSubscriptionHookResult = ReturnType<typeof useCreatedTenantUserResetPasswordSubscription>;
export type CreatedTenantUserResetPasswordSubscriptionResult = Apollo.SubscriptionResult<CreatedTenantUserResetPasswordSubscription>;
export const UpdatedTenantUserResetPasswordDocument = gql`
    subscription UpdatedTenantUserResetPassword($filter: TenantUserResetPasswordFilterArgs, $withTenantUser: Boolean = false) {
  updatedTenantUserResetPassword(filter: $filter) {
    ...tenantUserResetPasswordFields
  }
}
    ${TenantUserResetPasswordFieldsFragmentDoc}`;

/**
 * __useUpdatedTenantUserResetPasswordSubscription__
 *
 * To run a query within a React component, call `useUpdatedTenantUserResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedTenantUserResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedTenantUserResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useUpdatedTenantUserResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedTenantUserResetPasswordSubscription, UpdatedTenantUserResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedTenantUserResetPasswordSubscription, UpdatedTenantUserResetPasswordSubscriptionVariables>(UpdatedTenantUserResetPasswordDocument, options);
      }
export type UpdatedTenantUserResetPasswordSubscriptionHookResult = ReturnType<typeof useUpdatedTenantUserResetPasswordSubscription>;
export type UpdatedTenantUserResetPasswordSubscriptionResult = Apollo.SubscriptionResult<UpdatedTenantUserResetPasswordSubscription>;
export const DeletedTenantUserResetPasswordDocument = gql`
    subscription DeletedTenantUserResetPassword($filter: TenantUserResetPasswordFilterArgs) {
  deletedTenantUserResetPassword(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedTenantUserResetPasswordSubscription__
 *
 * To run a query within a React component, call `useDeletedTenantUserResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedTenantUserResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedTenantUserResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedTenantUserResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedTenantUserResetPasswordSubscription, DeletedTenantUserResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedTenantUserResetPasswordSubscription, DeletedTenantUserResetPasswordSubscriptionVariables>(DeletedTenantUserResetPasswordDocument, options);
      }
export type DeletedTenantUserResetPasswordSubscriptionHookResult = ReturnType<typeof useDeletedTenantUserResetPasswordSubscription>;
export type DeletedTenantUserResetPasswordSubscriptionResult = Apollo.SubscriptionResult<DeletedTenantUserResetPasswordSubscription>;
export const RestoredTenantUserResetPasswordDocument = gql`
    subscription RestoredTenantUserResetPassword($filter: TenantUserResetPasswordFilterArgs, $withTenantUser: Boolean = false) {
  restoredTenantUserResetPassword(filter: $filter) {
    ...tenantUserResetPasswordFields
  }
}
    ${TenantUserResetPasswordFieldsFragmentDoc}`;

/**
 * __useRestoredTenantUserResetPasswordSubscription__
 *
 * To run a query within a React component, call `useRestoredTenantUserResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredTenantUserResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredTenantUserResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenantUser: // value for 'withTenantUser'
 *   },
 * });
 */
export function useRestoredTenantUserResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredTenantUserResetPasswordSubscription, RestoredTenantUserResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredTenantUserResetPasswordSubscription, RestoredTenantUserResetPasswordSubscriptionVariables>(RestoredTenantUserResetPasswordDocument, options);
      }
export type RestoredTenantUserResetPasswordSubscriptionHookResult = ReturnType<typeof useRestoredTenantUserResetPasswordSubscription>;
export type RestoredTenantUserResetPasswordSubscriptionResult = Apollo.SubscriptionResult<RestoredTenantUserResetPasswordSubscription>;
export const GetUsersDocument = gql`
    query GetUsers($filter: UserFilterArgs, $paging: PageArgs, $sorting: [UserSortArgs!], $withUserTenantRoles: Boolean = false) {
  users(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...userFields
    }
    totalCount
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: ID!, $withUserTenantRoles: Boolean = false) {
  user(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetAllRelatedDataForUserDocument = gql`
    query GetAllRelatedDataForUser($withUserTenantRoles: Boolean = false) {
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForUserQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForUserQuery({
 *   variables: {
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
      }
export function useGetAllRelatedDataForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
        }
export function useGetAllRelatedDataForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
        }
export type GetAllRelatedDataForUserQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserQuery>;
export type GetAllRelatedDataForUserLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserLazyQuery>;
export type GetAllRelatedDataForUserSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserSuspenseQuery>;
export type GetAllRelatedDataForUserQueryResult = Apollo.QueryResult<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($name: String!, $email: String!, $active: Boolean!, $avatar: String, $termsAndConditions: Boolean, $locale: String!, $timeZone: String!, $userTenantRoles: [ID], $withUserTenantRoles: Boolean = false) {
  createUser(
    name: $name
    email: $email
    active: $active
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    locale: $locale
    timeZone: $timeZone
    userTenantRoleIds: $userTenantRoles
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $name: String, $email: String, $active: Boolean, $avatar: String, $termsAndConditions: Boolean, $locale: String, $timeZone: String, $userTenantRoles: [ID], $withUserTenantRoles: Boolean = false) {
  updateUser(
    id: $id
    name: $name
    email: $email
    active: $active
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    locale: $locale
    timeZone: $timeZone
    userTenantRoleIds: $userTenantRoles
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!, $withUserTenantRoles: Boolean = false) {
  deleteUser(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const CreatedUserDocument = gql`
    subscription CreatedUser($filter: UserFilterArgs, $withUserTenantRoles: Boolean = false) {
  createdUser(filter: $filter) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCreatedUserSubscription__
 *
 * To run a query within a React component, call `useCreatedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useCreatedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedUserSubscription, CreatedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedUserSubscription, CreatedUserSubscriptionVariables>(CreatedUserDocument, options);
      }
export type CreatedUserSubscriptionHookResult = ReturnType<typeof useCreatedUserSubscription>;
export type CreatedUserSubscriptionResult = Apollo.SubscriptionResult<CreatedUserSubscription>;
export const UpdatedUserDocument = gql`
    subscription UpdatedUser($filter: UserFilterArgs, $withUserTenantRoles: Boolean = false) {
  updatedUser(filter: $filter) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUpdatedUserSubscription__
 *
 * To run a query within a React component, call `useUpdatedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useUpdatedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedUserSubscription, UpdatedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedUserSubscription, UpdatedUserSubscriptionVariables>(UpdatedUserDocument, options);
      }
export type UpdatedUserSubscriptionHookResult = ReturnType<typeof useUpdatedUserSubscription>;
export type UpdatedUserSubscriptionResult = Apollo.SubscriptionResult<UpdatedUserSubscription>;
export const DeletedUserDocument = gql`
    subscription DeletedUser($filter: UserFilterArgs) {
  deletedUser(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedUserSubscription__
 *
 * To run a query within a React component, call `useDeletedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedUserSubscription, DeletedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedUserSubscription, DeletedUserSubscriptionVariables>(DeletedUserDocument, options);
      }
export type DeletedUserSubscriptionHookResult = ReturnType<typeof useDeletedUserSubscription>;
export type DeletedUserSubscriptionResult = Apollo.SubscriptionResult<DeletedUserSubscription>;
export const RestoredUserDocument = gql`
    subscription RestoredUser($filter: UserFilterArgs, $withUserTenantRoles: Boolean = false) {
  restoredUser(filter: $filter) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useRestoredUserSubscription__
 *
 * To run a query within a React component, call `useRestoredUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useRestoredUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredUserSubscription, RestoredUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredUserSubscription, RestoredUserSubscriptionVariables>(RestoredUserDocument, options);
      }
export type RestoredUserSubscriptionHookResult = ReturnType<typeof useRestoredUserSubscription>;
export type RestoredUserSubscriptionResult = Apollo.SubscriptionResult<RestoredUserSubscription>;
export const GetUserTenantRolesDocument = gql`
    query GetUserTenantRoles($filter: UserTenantRoleFilterArgs, $paging: PageArgs, $sorting: [UserTenantRoleSortArgs!], $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  userTenantRoles(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...userTenantRoleFields
    }
    totalCount
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useGetUserTenantRolesQuery__
 *
 * To run a query within a React component, call `useGetUserTenantRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTenantRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTenantRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useGetUserTenantRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
      }
export function useGetUserTenantRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
        }
export function useGetUserTenantRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
        }
export type GetUserTenantRolesQueryHookResult = ReturnType<typeof useGetUserTenantRolesQuery>;
export type GetUserTenantRolesLazyQueryHookResult = ReturnType<typeof useGetUserTenantRolesLazyQuery>;
export type GetUserTenantRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserTenantRolesSuspenseQuery>;
export type GetUserTenantRolesQueryResult = Apollo.QueryResult<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>;
export const GetUserTenantRoleDocument = gql`
    query GetUserTenantRole($id: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  userTenantRole(id: $id) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useGetUserTenantRoleQuery__
 *
 * To run a query within a React component, call `useGetUserTenantRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTenantRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTenantRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useGetUserTenantRoleQuery(baseOptions: Apollo.QueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables> & ({ variables: GetUserTenantRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
      }
export function useGetUserTenantRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
        }
export function useGetUserTenantRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
        }
export type GetUserTenantRoleQueryHookResult = ReturnType<typeof useGetUserTenantRoleQuery>;
export type GetUserTenantRoleLazyQueryHookResult = ReturnType<typeof useGetUserTenantRoleLazyQuery>;
export type GetUserTenantRoleSuspenseQueryHookResult = ReturnType<typeof useGetUserTenantRoleSuspenseQuery>;
export type GetUserTenantRoleQueryResult = Apollo.QueryResult<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>;
export const GetAllRelatedDataForUserTenantRoleDocument = gql`
    query GetAllRelatedDataForUserTenantRole($withUsers: Boolean = false, $withTenants: Boolean = false, $withRoles: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: name
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  roles @include(if: $withRoles) {
    items {
      id
      displayField: displayName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForUserTenantRoleQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForUserTenantRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForUserTenantRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForUserTenantRoleQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *      withTenants: // value for 'withTenants'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForUserTenantRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
      }
export function useGetAllRelatedDataForUserTenantRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
        }
export function useGetAllRelatedDataForUserTenantRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
        }
export type GetAllRelatedDataForUserTenantRoleQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleQuery>;
export type GetAllRelatedDataForUserTenantRoleLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleLazyQuery>;
export type GetAllRelatedDataForUserTenantRoleSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleSuspenseQuery>;
export type GetAllRelatedDataForUserTenantRoleQueryResult = Apollo.QueryResult<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>;
export const CreateUserTenantRoleDocument = gql`
    mutation CreateUserTenantRole($userId: ID!, $tenantId: ID!, $roleId: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  createUserTenantRole(userId: $userId, tenantId: $tenantId, roleId: $roleId) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type CreateUserTenantRoleMutationFn = Apollo.MutationFunction<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>;

/**
 * __useCreateUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserTenantRoleMutation, { data, loading, error }] = useCreateUserTenantRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      roleId: // value for 'roleId'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useCreateUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>(CreateUserTenantRoleDocument, options);
      }
export type CreateUserTenantRoleMutationHookResult = ReturnType<typeof useCreateUserTenantRoleMutation>;
export type CreateUserTenantRoleMutationResult = Apollo.MutationResult<CreateUserTenantRoleMutation>;
export type CreateUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>;
export const UpdateUserTenantRoleDocument = gql`
    mutation UpdateUserTenantRole($id: ID!, $userId: ID, $tenantId: ID, $roleId: ID, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  updateUserTenantRole(
    id: $id
    userId: $userId
    tenantId: $tenantId
    roleId: $roleId
  ) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type UpdateUserTenantRoleMutationFn = Apollo.MutationFunction<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>;

/**
 * __useUpdateUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTenantRoleMutation, { data, loading, error }] = useUpdateUserTenantRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      roleId: // value for 'roleId'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useUpdateUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>(UpdateUserTenantRoleDocument, options);
      }
export type UpdateUserTenantRoleMutationHookResult = ReturnType<typeof useUpdateUserTenantRoleMutation>;
export type UpdateUserTenantRoleMutationResult = Apollo.MutationResult<UpdateUserTenantRoleMutation>;
export type UpdateUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>;
export const DeleteUserTenantRoleDocument = gql`
    mutation DeleteUserTenantRole($id: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  deleteUserTenantRole(id: $id) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type DeleteUserTenantRoleMutationFn = Apollo.MutationFunction<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>;

/**
 * __useDeleteUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useDeleteUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTenantRoleMutation, { data, loading, error }] = useDeleteUserTenantRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useDeleteUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>(DeleteUserTenantRoleDocument, options);
      }
export type DeleteUserTenantRoleMutationHookResult = ReturnType<typeof useDeleteUserTenantRoleMutation>;
export type DeleteUserTenantRoleMutationResult = Apollo.MutationResult<DeleteUserTenantRoleMutation>;
export type DeleteUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>;
export const CreatedUserTenantRoleDocument = gql`
    subscription CreatedUserTenantRole($filter: UserTenantRoleFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  createdUserTenantRole(filter: $filter) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useCreatedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useCreatedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useCreatedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedUserTenantRoleSubscription, CreatedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedUserTenantRoleSubscription, CreatedUserTenantRoleSubscriptionVariables>(CreatedUserTenantRoleDocument, options);
      }
export type CreatedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useCreatedUserTenantRoleSubscription>;
export type CreatedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<CreatedUserTenantRoleSubscription>;
export const UpdatedUserTenantRoleDocument = gql`
    subscription UpdatedUserTenantRole($filter: UserTenantRoleFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  updatedUserTenantRole(filter: $filter) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useUpdatedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useUpdatedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useUpdatedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedUserTenantRoleSubscription, UpdatedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedUserTenantRoleSubscription, UpdatedUserTenantRoleSubscriptionVariables>(UpdatedUserTenantRoleDocument, options);
      }
export type UpdatedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useUpdatedUserTenantRoleSubscription>;
export type UpdatedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<UpdatedUserTenantRoleSubscription>;
export const DeletedUserTenantRoleDocument = gql`
    subscription DeletedUserTenantRole($filter: UserTenantRoleFilterArgs) {
  deletedUserTenantRole(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useDeletedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedUserTenantRoleSubscription, DeletedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedUserTenantRoleSubscription, DeletedUserTenantRoleSubscriptionVariables>(DeletedUserTenantRoleDocument, options);
      }
export type DeletedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useDeletedUserTenantRoleSubscription>;
export type DeletedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<DeletedUserTenantRoleSubscription>;
export const GetFullUserDocument = gql`
    query GetFullUser($id: ID!) {
  user(id: $id) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    userTenantRoles {
      items {
        id
        userId
        tenantId
        roleId
        role {
          id
          machineName
          displayField: machineName
        }
        tenant {
          id
          name
          displayField: name
        }
        displayField: id
      }
      totalCount
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useGetFullUserQuery__
 *
 * To run a query within a React component, call `useGetFullUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullUserQuery(baseOptions: Apollo.QueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables> & ({ variables: GetFullUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
      }
export function useGetFullUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
        }
export function useGetFullUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
        }
export type GetFullUserQueryHookResult = ReturnType<typeof useGetFullUserQuery>;
export type GetFullUserLazyQueryHookResult = ReturnType<typeof useGetFullUserLazyQuery>;
export type GetFullUserSuspenseQueryHookResult = ReturnType<typeof useGetFullUserSuspenseQuery>;
export type GetFullUserQueryResult = Apollo.QueryResult<GetFullUserQuery, GetFullUserQueryVariables>;
export const CreateUserWithTenantRoleDocument = gql`
    mutation CreateUserWithTenantRole($name: String!, $email: String!, $active: Boolean!, $avatar: String, $termsAndConditions: Boolean, $userTenantRoles: [ID], $tenantId: String, $roleId: String, $invite: Boolean, $locale: String!, $timeZone: String!, $withUserTenantRoles: Boolean = false) {
  createUser(
    name: $name
    email: $email
    active: $active
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    userTenantRoleIds: $userTenantRoles
    tenantId: $tenantId
    roleId: $roleId
    invite: $invite
    locale: $locale
    timeZone: $timeZone
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserWithTenantRoleMutationFn = Apollo.MutationFunction<CreateUserWithTenantRoleMutation, CreateUserWithTenantRoleMutationVariables>;

/**
 * __useCreateUserWithTenantRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserWithTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserWithTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserWithTenantRoleMutation, { data, loading, error }] = useCreateUserWithTenantRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      tenantId: // value for 'tenantId'
 *      roleId: // value for 'roleId'
 *      invite: // value for 'invite'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useCreateUserWithTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserWithTenantRoleMutation, CreateUserWithTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserWithTenantRoleMutation, CreateUserWithTenantRoleMutationVariables>(CreateUserWithTenantRoleDocument, options);
      }
export type CreateUserWithTenantRoleMutationHookResult = ReturnType<typeof useCreateUserWithTenantRoleMutation>;
export type CreateUserWithTenantRoleMutationResult = Apollo.MutationResult<CreateUserWithTenantRoleMutation>;
export type CreateUserWithTenantRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserWithTenantRoleMutation, CreateUserWithTenantRoleMutationVariables>;
export const GlobalMailLayoutDocument = gql`
    query GlobalMailLayout {
  globalMailLayouts {
    totalCount
    items {
      id
      name
      machineName
      description
      layout
      default
      tenantId
      createdAt
      updatedAt
      mailLayoutFields {
        totalCount
        items {
          id
          name
          machineName
          mailLayoutId
          required
        }
      }
    }
  }
}
    `;

/**
 * __useGlobalMailLayoutQuery__
 *
 * To run a query within a React component, call `useGlobalMailLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalMailLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalMailLayoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalMailLayoutQuery(baseOptions?: Apollo.QueryHookOptions<GlobalMailLayoutQuery, GlobalMailLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalMailLayoutQuery, GlobalMailLayoutQueryVariables>(GlobalMailLayoutDocument, options);
      }
export function useGlobalMailLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalMailLayoutQuery, GlobalMailLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalMailLayoutQuery, GlobalMailLayoutQueryVariables>(GlobalMailLayoutDocument, options);
        }
export function useGlobalMailLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalMailLayoutQuery, GlobalMailLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalMailLayoutQuery, GlobalMailLayoutQueryVariables>(GlobalMailLayoutDocument, options);
        }
export type GlobalMailLayoutQueryHookResult = ReturnType<typeof useGlobalMailLayoutQuery>;
export type GlobalMailLayoutLazyQueryHookResult = ReturnType<typeof useGlobalMailLayoutLazyQuery>;
export type GlobalMailLayoutSuspenseQueryHookResult = ReturnType<typeof useGlobalMailLayoutSuspenseQuery>;
export type GlobalMailLayoutQueryResult = Apollo.QueryResult<GlobalMailLayoutQuery, GlobalMailLayoutQueryVariables>;
export const GetMailTemplateWithLayoutFieldsDocument = gql`
    query GetMailTemplateWithLayoutFields($id: ID!) {
  mailTemplate(id: $id) {
    id
    name
    description
    mailLayout {
      id
      name
      machineName
      description
      mailLayoutFields {
        items {
          id
          name
          required
          machineName
          description
          createdAt
          updatedAt
        }
      }
    }
    mailTemplateFields {
      items {
        id
        name
        machineName
        description
        required
      }
    }
  }
}
    `;

/**
 * __useGetMailTemplateWithLayoutFieldsQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateWithLayoutFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateWithLayoutFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateWithLayoutFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMailTemplateWithLayoutFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetMailTemplateWithLayoutFieldsQuery, GetMailTemplateWithLayoutFieldsQueryVariables> & ({ variables: GetMailTemplateWithLayoutFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateWithLayoutFieldsQuery, GetMailTemplateWithLayoutFieldsQueryVariables>(GetMailTemplateWithLayoutFieldsDocument, options);
      }
export function useGetMailTemplateWithLayoutFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateWithLayoutFieldsQuery, GetMailTemplateWithLayoutFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateWithLayoutFieldsQuery, GetMailTemplateWithLayoutFieldsQueryVariables>(GetMailTemplateWithLayoutFieldsDocument, options);
        }
export function useGetMailTemplateWithLayoutFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateWithLayoutFieldsQuery, GetMailTemplateWithLayoutFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateWithLayoutFieldsQuery, GetMailTemplateWithLayoutFieldsQueryVariables>(GetMailTemplateWithLayoutFieldsDocument, options);
        }
export type GetMailTemplateWithLayoutFieldsQueryHookResult = ReturnType<typeof useGetMailTemplateWithLayoutFieldsQuery>;
export type GetMailTemplateWithLayoutFieldsLazyQueryHookResult = ReturnType<typeof useGetMailTemplateWithLayoutFieldsLazyQuery>;
export type GetMailTemplateWithLayoutFieldsSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateWithLayoutFieldsSuspenseQuery>;
export type GetMailTemplateWithLayoutFieldsQueryResult = Apollo.QueryResult<GetMailTemplateWithLayoutFieldsQuery, GetMailTemplateWithLayoutFieldsQueryVariables>;